import React , { useEffect } from "react";
import axios from 'axios';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Formik, Form, Field } from 'formik';
import { LinearProgress, Box, Fab, Tooltip, Modal, Fade, TextField, Backdrop, Typography, Breadcrumbs, Accordion, AccordionSummary, AccordionDetails, 
  Stepper, Step, StepLabel, List, ListItem, ListItemText, Divider, MenuItem} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Support from '../../components/support/Support';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AssistantIcon from '@mui/icons-material/Assistant';
import AssignmentIcon from '@mui/icons-material/Assignment';
import AssignmentReturnIcon from '@mui/icons-material/AssignmentReturn';
import DeveloperBoardIcon from '@mui/icons-material/DeveloperBoard';
import MultilineChartIcon from '@mui/icons-material/MultilineChart';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import SettingsApplicationIcon from '@mui/icons-material/SettingsApplications';
import CustomTabs from "../../components/CustomTabs/CustomTabs.jsx";
import Skeleton from "@mui/material/Skeleton"
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import { useTheme } from "@mui/material/styles";
import Button from "../../components/CustomButtons/Button.jsx";
import {useSelector, useDispatch} from 'react-redux';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import { EditorState, convertToRaw } from 'draft-js';
import { mongoUrl } from '../../components/shared/mongoUrl.js';
import { baseUrl } from '../../components/shared/baseUrl';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import {motion, useCycle, AnimatePresence} from 'framer-motion';
import { upCount, finCount } from "../../reducers/actionCreators";
import {
  successColor,
  whiteColor,
  grayColor,
  hexToRgb
} from "../../components/assets/jss/material-dashboard-react.js";







const styles = (theme) =>({
   cardTitle: {
        color: 'blue',
        marginTop: "0px",
        minHeight: "auto",
        fontWeight: "300",
        fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
        marginBottom: "3px",
        textDecoration: "none",
        "& small": {
          color: grayColor[1],
          fontWeight: "400",
          lineHeight: "1"
        }
      },
     cardCategory: {
        color: grayColor[0],
        margin: "0",
        fontSize: "14px",
        marginTop: "0",
        paddingTop: "10px",
        marginBottom: "0"
      },
  cardCategoryWhite: {
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily:"'Oswald'",
    marginBottom: "3px",
    textDecoration: "none",
    textAlign:'center'
  },
  styleChatbutton: {
    color: "black",
    padding: "16px 20px",
    border: "none",
    cursor: "pointer",
    opacity: "0.8",
    position: "fixed",
    zIndex: "10 !important",
    bottom: "23px",
    right: "28px",
    fontWeight: "300",
  },
  chatClose: {
    position: "fixed",
    zIndex: "10 !important",
    bottom: "485px",
    right: "20px",
  },
  chatContainer: {
    zIndex: "10 !important",
    position: "fixed",
    bottom: "110px",
    right: "22px",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    flexBasis: '33.33%',
    flexShrink: 0,
    fontFamily:"'Lucida Handwriting', 'Brush Script MT'"

  },
  fontCursive: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  fontBrush: {
    fontFamily:"'Brush Script MT', 'Cursive'"
  },
  fontGaramond: {
    fontFamily:"'Garamond', 'Serif'"
  },
  fontCourier:{
    fontFamily:"'Courier New', 'monospace'"
  },
  fontLucida:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  fontPapyrus:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  fontMonaco:{
    fontFamily:"'Monaco','monospace'"
  },
  deco:{
    fontFamily:"'Papyrus','Fantasy'"
  },
  abs:{
    fontFamily:"'Monaco','monospace'"
  },
  algo: {
    fontFamily:"'Lucida Handwriting', 'Cursive'"
  },
  pat:{
    fontFamily:"'Courier New', 'monospace'"
  },
  ana:{
    fontFamily:"'Lucida Console', 'monospace'"
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.text.secondary,
    fontFamily:"'Lucida Console', 'monospace'"

  },
  modal: {
    //display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    top:'20%',
    left:'10%',
    overflowY:'scroll',
    height:'100%',
    display:'block'
  },
  modal1:{
    position: 'relative',
    maxWidth: '1000px',
    margin : '0 auto',
    padding: '20px 20px 20px 20px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  modal2:{
    position: 'relative',
    maxWidth: '700px',
    margin : '0 auto',
    padding: '10px 10px 10px 10px',
    background: "rgba(0,0,0,0.5)",
    backgroundColor: 'white',
    borderRadius:'10 px',
    textAlign:'center',
    zIndex: 10

  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,

  },
  messageArea: {
    height: '40vh',
    overflowY: 'auto'
  },
  backdrop: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    background: "rgba(0,0,0,0.5)",
    zIndex: 10
  }
});

var numList = [
  { label: 1, value: 1 },
  { label: 2, value: 2}, { label: 3, value: 3}, { label: 4, value: 4},{ label: 21, value: 21}, { label: 21/2, value: 21/2}, 
  { label: 5, value: 5}, { label: 6, value: 6},{ label: 7, value: 7}, { label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, 
  { label: 11, value: 11}, { label: 12, value: 12}, { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, 
  { label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
    , { label: 19, value: 19}, { label: 20, value: 20}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
    , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
    , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
    , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
    , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
    , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
    , { label: 51, value: 51}, { label: 52, value: 52}, { label: 53, value: 53}, { label: 54, value: 54}, { label: 55, value: 55}
    , { label: 56, value: 56}, { label: 57, value: 57}, { label: 58, value: 58}, { label: 59, value: 59}, { label: 60, value: 60}
    , { label: 61, value: 61}, { label: 62, value: 62}, { label: 63, value: 63}, { label: 64, value: 64}, { label: 65, value: 65}
    , { label: 66, value: 66}, { label: 67, value: 67}, { label: 68, value: 68}, { label: 69, value: 69}, { label: 70, value: 70}
    , { label: 71, value: 71}, { label: 72, value: 72}, { label: 73, value: 73}, { label: 74, value: 74}, { label: 75, value: 75}
    , { label: 76, value: 76}, { label: 77, value: 77}, { label: 78, value: 78}, { label: 79, value: 79}, { label: 80, value: 80}
    , { label: 81, value: 81}, { label: 82, value: 82}, { label: 83, value: 83}, { label: 84, value: 84}, { label: 85, value: 85}
    , { label: 86, value: 86}, { label: 87, value: 87}, { label: 88, value: 88}, { label: 89, value: 89}, { label: 90, value: 90}
    , { label: 91, value: 91}, { label: 92, value: 92}, { label: 93, value: 93}, { label: 94, value: 94}, { label: 95, value: 95}
    , { label: 96, value: 96}, { label: 97, value: 97}, { label: 98, value: 98}, { label: 99, value: 99}, { label: 100, value: 100}
    , { label: 101, value: 101}, { label: 102, value: 102}, { label: 103, value: 103}, { label: 104, value: 104}, { label: 105, value: 105}
    , { label: 106, value: 106}, { label: 107, value: 107}, { label: 108, value: 108}, { label: 109, value: 109}, { label: 110, value: 110}
    , { label: 111, value: 111}, { label: 112, value: 112}, { label: 113, value: 113}, { label: 114, value: 114}, { label: 115, value: 115}
    , { label: 116, value: 116}, { label: 117, value: 117}, { label: 118, value: 118}, { label: 119, value: 119}, { label: 120, value: 120}
    , { label: 121, value: 121}, { label: 122, value: 122}, { label: 123, value: 123}, { label: 124, value: 124}, { label: 125, value: 125}
    , { label: 126, value: 126}, { label: 127, value: 127}, { label: 128, value: 128}, { label: 129, value: 129}, { label: 130, value: 130}
    , { label: 131, value: 131}, { label: 132, value: 132}, { label: 133, value: 133}, { label: 134, value: 134}, { label: 135, value: 135}
    , { label: 136, value: 136}, { label: 137, value: 137}, { label: 138, value: 138}, { label: 139, value: 139}, { label: 140, value: 140}
    , { label: 141, value: 141}, { label: 142, value: 142}, { label: 143, value: 143}, { label: 144, value: 144}, { label: 145, value: 145}
    , { label: 146, value: 146}, { label: 147, value: 147}, { label: 148, value: 148}, { label: 149, value: 149}, { label: 150, value: 150}
    
  ];


var numberList = [
{ label: 'none', value: ''},{ label: '1/3', value: 1/3 },{ label: 'pie=3.14', value: 3.14 },{ label: 0, value: 0 },{ label: 'height 1', value: 1 },
{ label: 2, value: 2}, { label: 3, value: 3}, { label: 'radius=4', value: 4},{ label: 'height=21', value: 21}, { label: 'height=21/2', value: 21/2}, 
{ label: 5, value: 5}, { label: 6, value: 6},{ label: 7, value: 7}, { label: 'radius=8', value: 8}, { label: 9, value: 9}, { label: 10, value: 10}, 
{ label: 11, value: 11}, { label: 12, value: 12}, { label: 13, value: 13}, { label: 14, value: 14}, { label: 15, value: 15}, 
{ label: 16, value: 16}, { label: 17, value: 17}, { label: 18, value: 18}
  , { label: 19, value: 19}, { label: 20, value: 20}, { label: 22, value: 22}, { label: 23, value: 23}, { label: 24, value: 24}
  , { label: 25, value: 25}, { label: 26, value: 26}, { label: 27, value: 27}, { label: 28, value: 28}, { label: 29, value: 29}
  , { label: 30, value: 30}, { label: 31, value: 31}, { label: 32, value: 32}, { label: 33, value: 33}, { label: 34, value: 34}, { label: 35, value: 35}
  , { label: 36, value: 36}, { label: 37, value: 37}, { label: 38, value: 38}, { label: 39, value: 39}, { label: 40, value: 40}
  , { label: 41, value: 41}, { label: 42, value: 42}, { label: 43, value: 43}, { label: 44, value: 44}, { label: 45, value: 45}
  , { label: 46, value: 46}, { label: 47, value: 47}, { label: 48, value: 48}, { label: 49, value: 49}, { label: 50, value: 50}
  , { label: 51, value: 51}, { label: 52, value: 52}, { label: 53, value: 53}, { label: 54, value: 54}, { label: 55, value: 55}
  , { label: 56, value: 56}, { label: 57, value: 57}, { label: 58, value: 58}, { label: 59, value: 59}, { label: 60, value: 60}
  , { label: 61, value: 61}, { label: 62, value: 62}, { label: 63, value: 63}, { label: 64, value: 64}, { label: 65, value: 65}
  , { label: 66, value: 66}, { label: 67, value: 67}, { label: 68, value: 68}, { label: 69, value: 69}, { label: 70, value: 70}
  , { label: 71, value: 71}, { label: 72, value: 72}, { label: 73, value: 73}, { label: 74, value: 74}, { label: 75, value: 75}
  , { label: 76, value: 76}, { label: 77, value: 77}, { label: 78, value: 78}, { label: 79, value: 79}, { label: 80, value: 80}
  , { label: 81, value: 81}, { label: 82, value: 82}, { label: 83, value: 83}, { label: 84, value: 84}, { label: 85, value: 85}
  , { label: 86, value: 86}, { label: 87, value: 87}, { label: 88, value: 88}, { label: 89, value: 89}, { label: 90, value: 90}
  , { label: 91, value: 91}, { label: 92, value: 92}, { label: 93, value: 93}, { label: 94, value: 94}, { label: 95, value: 95}
  , { label: 96, value: 96}, { label: 97, value: 97}, { label: 98, value: 98}, { label: 99, value: 99}, { label: 100, value: 100}
  , { label: 101, value: 101}, { label: 102, value: 102}, { label: 103, value: 103}, { label: 104, value: 104}, { label: 105, value: 105}
  , { label: 106, value: 106}, { label: 107, value: 107}, { label: 108, value: 108}, { label: 109, value: 109}, { label: 110, value: 110}
  , { label: 111, value: 111}, { label: 112, value: 112}, { label: 113, value: 113}, { label: 114, value: 114}, { label: 115, value: 115}
  , { label: 116, value: 116}, { label: 117, value: 117}, { label: 118, value: 118}, { label: 119, value: 119}, { label: 120, value: 120}
  , { label: 121, value: 121}, { label: 122, value: 122}, { label: 123, value: 123}, { label: 124, value: 124}, { label: 125, value: 125}
  , { label: 126, value: 126}, { label: 127, value: 127}, { label: 128, value: 128}, { label: 129, value: 129}, { label: 130, value: 130}
  , { label: 131, value: 131}, { label: 132, value: 132}, { label: 133, value: 133}, { label: 134, value: 134}, { label: 135, value: 135}
  , { label: 136, value: 136}, { label: 137, value: 137}, { label: 138, value: 138}, { label: 139, value: 139}, { label: 140, value: 140}
  , { label: 141, value: 141}, { label: 142, value: 142}, { label: 143, value: 143}, { label: 144, value: 144}, { label: 145, value: 145}
  , { label: 146, value: 146}, { label: 147, value: 147}, { label: 148, value: 148}, { label: 149, value: 149}, { label: 150, value: 150}
  
];

var numberNewList = [
  { label: 'none', value: ''},{ label: '1/3', value: 1/3 },{ label: 'pie=3.14', value: 3.14 },{ label: 0, value: 0 },{ label: 'height 1', value: 1 },
  { label: 2, value: 2}, { label: 3, value: 3}, { label: 'radius=4', value: 4},{ label: 'height=21', value: 21}, { label: 'height/2=21/2', value: 21/2}, 
   { label: '2*radius=2*4', value: 8}];


var bracketList = [
  { label: '(', value: '(' },
  { label: ')', value: ')'}
];

var standard = [
  { label: 'increases', value: 'increases' },
  { label: 'decreases', value: 'decreases'},
  { label: 'noChange', value: 'noChange'}
];

var cla = {
  "_id":"6006f33eef2c0d65ccbf6601",
  "title": "Class IX",
  "teacherId":"5fe192d970d8c633c005da24"
}

var pairList = [
  { label: 'index1=12', value: 12 },
  { label: 'index2=17', value: 17 },
  { label: 'index3=24', value: 24 },
  { label: 'index4=27', value: 27 },
  { label: 'index5=29', value: 29 },
  { label: 'index6=37', value: 37}
];
var nVarList = [
  {label: 'n', value: 'n'},
  {label: 'none', value: ''}
]

var textAlgoList = [
  {label: 'input', value: 'input'},
  {label: 'output', value: 'output'},
  {label: 'define', value: 'define'},
  {label: 'set', value: 'set'},
  {label: 'to', value: 'to'},
  {label: 'output', value: 'output'}
]

var compareList = [
  { label: 'isequalTo(==)', value: '==' },
  { label: 'notEqualTo(!=)', value: '!=' },
  { label: 'greaterThan(>)', value: '>' },
  { label: 'lessThan(<)', value: '<' },
]


var operatorList = [
  { label: 'add(+)', value: '+' },
  { label: 'subtract(-)', value: '-'},
  { label: 'multiply(*)', value: '*'},
  { label: 'divide(/)', value: '/'},
  { label: 'remainder(%)', value: '%'},
  { label: 'none', value: ''}
];
var funcList = [
    { label: 'none', value: ''},{ label: 'VolumeCone', value:'VolumeCone' },
    { label: 'VolumeCylinder', value: 'VolumeCylinder'},
    { label: 'RadiusCylinder', value: 'RadiusCylinder'}
  ];

  var numberFuncList = [
    { label: 'none', value: ''},{ label: 'heightNewCylinder', value: 1 },
    { label: 'radius', value: 4},{ label: 'height', value: 21}, { label: 'height/2', value: 21/2}, 
     { label: '2*radius', value: 8}];

  var fibNewList = [
    { label: '', value: ''},{ label: 'Fib(n-3)', value: 'Fib(n-3)' },{ label: 'Fib(n-2)', value: 'Fib(n-2)' },
    { label: 'Fib(n-1)', value: 'Fib(n-1)'},{ label: 'Fib(n-4)', value: 'Fib(n-4)'},{ label: 'Fib(n-5)', value: 'Fib(n-5)'},
    { label: 1, value: 1 },{ label: 2, value: 2},{ label: 3, value: 3},   { label: 4, value: 4},{ label: 5, value: 5}, 
    { label: 6, value: 6},{ label: 7, value: 7},{ label: 8, value: 8}, { label: 9, value: 9}, { label: 10, value: 10}
  ];


var task = ['Find the steps to move two disk from 1st rod to 3rd rod', 'Identify the movement of disk between rods',
 'Write the general steps needed to move from initial position to final position.', 'Write the steps to move disks from initial position to final position ',
'Analyse the algorithm to count maximum number of steps/operations used in algorithm and total extra variables defined in the algorithm', 'Write the steps to move disks from initial position to final position ', 'Compare the solutions (click to select a solution)']



function getSteps() {
  return ['Decomposition', 'Pattern Recognition', 'Abstraction', 'Algorithm design', 'Analysis of Algorithm', 'Solution', 'Comparison'];
}

const hintsActivity1 = [
  { step: 'Decomposition'},
  { step: 'Pattern recognition'},
  { step: 'Abstraction' },
  { step: 'Algorithm design'},
  { step: 'Analysis of Algorithm' },
  { step: 'Final solution'},
  { step: 'Comparison'}
]


const firstStep = () =>{

  return(
    <p> First step</p>
  );
};




export default function Fibonacci(props){
    const [module, setmodule] = React.useState('');
    var interval = null
    const [clas, setclas] = React.useState([]);
    const [loading, setloading] = React.useState(true);
    const [loadhint, setloadhint] = React.useState(false);
    const [myCount, setmyCount] = React.useState(10);
    const [isSubmit, setisSubmit] = React.useState(false);
    const [myDecoCount, setmyDecoCount] = React.useState(10);
    const [finalCount, setfinalCount] = React.useState(19);
    const [Num, setNum] = React.useState(1);
    const theme = useTheme()
    const classes =styles(theme);
    const [loadsupport, setloadsupport] = React.useState(false);
    const user = useSelector(state => state.user)
    const dispatch = useDispatch();
    const [editorState, seteditorState]= React.useState(EditorState.createEmpty())
    const [loadintro, setloadintro] = React.useState(true);
    const [error, seterror] = React.useState('');
    const [expanded, setExpanded] = React.useState(false);
    const [expanded1, setExpanded1] = React.useState(false); 
    const [addition, setaddition] = React.useState('Individual addition');
    const [termsum, settermsum] = React.useState('0');  
    const [jumps, setjumps] = React.useState([{"letter":'A',"source":1,"destination":2,"seq":['A',0,'B'],"completed":false},{"letter":'A',"source":1,"destination":2,"seq":['A',0,'B'],"completed":false}, {"letter":'A',"source":1,"destination":2,"seq":['A',0,'B'],"completed":false}, {"letter":'A',"source":1,"destination":2,"seq":['A',0,'B'],"completed":false}])
    const [sour,setsour] = React.useState([{"label":1,"value":1}]);
    const [dest,setdest] = React.useState([{"label":2,"value":2}])
    const [algojumps, setalgojumps] = React.useState([{"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false},{"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[1,2,3],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}])
    const [algosour,setalgosour] = React.useState([{"label":'rod1',"value":1}]);
    const [algodest,setalgodest] = React.useState([{"label":'rod2',"value":2},{"label":'rod3',"value":3}])
    const [disjumps, setdisjumps] = React.useState([{"source":1,"destination":2,"rod1":[0,1,2],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false},{"source":1,"destination":2,"rod1":[0,1,2],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[0,1,2],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[0,1,2],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}, {"source":1,"destination":2,"rod1":[0,1,2],"rod2":[0,0,0],"rod3":[0,0,0],"completed":false}])
    const [dissour,setdissour] = React.useState([{"label":'rod1',"value":1}]);
    const [disdest,setdisdest] = React.useState([{"label":'rod2',"value":2},{"label":'rod3',"value":3}])
    const [num1, setnum1] = React.useState('0');
    const [num2, setnum2] = React.useState('0');
    const [num3, setnum3] = React.useState('0');
    const [num4, setnum4] = React.useState('0');
    const [num5, setnum5] = React.useState('0');
    const [num6, setnum6] = React.useState('0');
    const [num7, setnum7] = React.useState('0');
    const [num8, setnum8] = React.useState('0');
    const [num9, setnum9] = React.useState('0');
    const [num10, setnum10] = React.useState('0');
    const [num11, setnum11] = React.useState('');
    const [num12, setnum12] = React.useState('');
    const [num13, setnum13] = React.useState('');
    const [num14, setnum14] = React.useState('');
    const [num15, setnum15] = React.useState('');
    const [num16, setnum16] = React.useState('');
    const [num17, setnum17] = React.useState('');
    const [num18, setnum18] = React.useState('');
    const [num19, setnum19] = React.useState('');
    const [num20, setnum20] = React.useState('');
    const [num21, setnum21] = React.useState('');
    const [num22, setnum22] = React.useState('');
    const [num23, setnum23] = React.useState('');
    const [num24, setnum24] = React.useState('');
    const [num25, setnum25] = React.useState('');
    const [mydata, setmydata] = React.useState('');
    const [totaldata, settotaldata] = React.useState('')
    const [mydeco, setmydeco] = React.useState('');
    const [patnum, setpatnum] = React.useState('');
    const [patnum1, setpatnum1] = React.useState('');
    const [patnum2, setpatnum2] = React.useState('');
    const [patnum3, setpatnum3] = React.useState('');
    const [patnum4, setpatnum4] = React.useState('');
    const [patnum5, setpatnum5] = React.useState('');
    const [patnum6, setpatnum6] = React.useState('');
    const [patnum7, setpatnum7] = React.useState('');
    const [patnum8, setpatnum8] = React.useState('');
    const [patnum9, setpatnum9] = React.useState('');
    const [patnum10, setpatnum10] = React.useState('');
    const [patnum11, setpatnum11] = React.useState('');
    const [patnum12, setpatnum12] = React.useState('');
    const [patnum13, setpatnum13] = React.useState('');
    const [patnum14, setpatnum14] = React.useState('');
    const [patnum15, setpatnum15] = React.useState('');
    const [patnum16, setpatnum16] = React.useState('');
    const [mypattern, setmypattern] = React.useState('');
    const [myabstract, setmyabstract] = React.useState('');
    const [abs1, setabs1] = React.useState('');
    const [abs2, setabs2] = React.useState('');
    const [abs3, setabs3] = React.useState('');
    const [abs4, setabs4] = React.useState('');
    const [abs5, setabs5] = React.useState('');
    const [abs6, setabs6] = React.useState('');
    const [abs7, setabs7] = React.useState('');
    const [abs8, setabs8] = React.useState('');
    const [abs9, setabs9] = React.useState('');
    const [abs10, setabs10] = React.useState('');
    const [abs11, setabs11] = React.useState('');
    const [abs12, setabs12] = React.useState('');
    const [abs13, setabs13] = React.useState('');
    const [abs14, setabs14] = React.useState('');
    const [abs15, setabs15] = React.useState('');
    const [abs16, setabs16] = React.useState('');
    const [abs17, setabs17] = React.useState('');
    const [abs18, setabs18] = React.useState('');
    const [myabs1, setmyabs1] = React.useState('');
    const [myabs2, setmyabs2] = React.useState('');
    const [absNum, setabsNum] = React.useState(4);
    const [algo, setalgo] = React.useState('');
    const [algo1, setalgo1] = React.useState('');
    const [algo2, setalgo2] = React.useState('');
    const [algo3, setalgo3] = React.useState('');
    const [algo4, setalgo4] = React.useState('');
    const [algo5, setalgo5] = React.useState('');
    const [algo6, setalgo6] = React.useState('');
    const [algo7, setalgo7] = React.useState('');
    const [algo8, setalgo8] = React.useState('');
    const [algo9, setalgo9] = React.useState('');
    const [algo10, setalgo10] = React.useState('');
    const [algo11, setalgo11] = React.useState('');
    const [algo12, setalgo12] = React.useState('');
    const [algo13, setalgo13] = React.useState('');
    const [algo14, setalgo14] = React.useState('');
    const [algo15, setalgo15] = React.useState('');
    const [algo16, setalgo16] = React.useState('');
    const [algo17, setalgo17] = React.useState('');
    const [algo18, setalgo18] = React.useState('');
    const [algo19, setalgo19] = React.useState('');
    const [algo20, setalgo20] = React.useState('');
    const [algo21, setalgo21] = React.useState('');
    const [algo22, setalgo22] = React.useState('');
    const [algo23, setalgo23] = React.useState('');
    const [algo24, setalgo24] = React.useState('');
    const [algo25, setalgo25] = React.useState('');
    const [myalgo, setmyalgo] = React.useState('');
    const [myalgo1, setmyalgo1] = React.useState('21');
    const [myalgo2, setmyalgo2] = React.useState('');
    const [myalgo3, setmyalgo3] = React.useState('');
    const [myalgo4, setmyalgo4] = React.useState('');
    const [myalgo5, setmyalgo5] = React.useState('');
    const [myalgo6, setmyalgo6] = React.useState('');
    const [myalgo7, setmyalgo7] = React.useState('');
    const [myalgo8, setmyalgo8] = React.useState('');
    const [myalgo9, setmyalgo9] = React.useState('');
    const [myanalysis, setmyanalysis] = React.useState('');
    const [mytime, setmytime] = React.useState('');
    const [myspace, setmyspace] = React.useState('');
    const [mycomsol, setmycomsol] = React.useState('');
    const [mycomsol1, setmycomsol1] = React.useState('');
    const [mycomsol2, setmycomsol2] = React.useState('');
    const [mycomsol3, setmycomsol3] = React.useState('');
    const [sollist, setsollist] = React.useState([]);
    const [openBoard, setopenBoard] = React.useState(false);
    const [animation, cycleAnimation] = useCycle("animateOne", "animateTwo");
    const [myModal, setmyModal] = React.useState(true);
    const [myModalTwo, setmyModalTwo] = React.useState(true);
    const [myModalThree, setmyModalThree] = React.useState(false);
    const [ansType, setansType] = React.useState('');
    const [altHint, setaltHint] = React.useState('');
    const [mysum, setmysum] = React.useState('0');
    //const classes = styles1(theme)
    const [arrStore, setarrStore]= React.useState([])
    const { classId, sesId } = useParams();





    

    useEffect(() => {



        const CancelToken = axios.CancelToken;
        const source = CancelToken.source();
        const classid = classId;
        console.log(classId)
        const sessid = sesId;
        console.log(user)
        const loadData=()=>{
          const config = {
            headers: { Authorization: `Bearer ${user.token}` }
        };

        try{
          
          setclas(cla)

            
          axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((resp) =>{
            if(resp.data.activity5[0].problemStatement!==''){
              const activity = resp.data.activity5[0]

              console.log('already started activity')
                setmydata(activity)
                settotaldata(resp.data)
                if(activity.decomposition.length=='0'){
            
                }
                else{
                  if(activity.decomposition[0].userText!==""){
  
                      var newarr  = activity.decomposition[0].userText.split('=')
                      var narr=newarr[1].split(';')
  
                      var jmps=[]
  
                      narr.map((val,index)=>{
                        if(index<narr.length-1){
                        var arr = val.split(':')
                        var sparr = arr[0].split(',')
                        var comp = false;
                        
                        if(arr[4]=='true'){
                          comp=true
                        }
                        var sarr = arr[1].split(',')
                        var sarr1 = arr[2].split(',')
                        var sarr2 = arr[3].split(',')
  
                        console.log(arr[1])
                        console.log(sarr)
                        
                        jmps.push({"source":Number(sparr[1]),"destination":Number(sparr[3]), "rod1":sarr,"rod2":sarr1,"rod3":sarr2, "completed":comp})
                        }
                      })
                      console.log(jmps)
                      setdisjumps(jmps)                                   
                    }
                  }
                if(activity.analysis.length=='0'){
                  setmytime('')
                  setmyspace('')
                }
                else{
                  setmytime(activity.analysis[0].timeText)
                  setmyspace(activity.analysis[0].spaceText)
                }
              
              setloading(false)
            }
            else{
            var question='Identify the minimum steps required to convert from Intial to final position.'
          
            if(resp.data.activity5[0].problemStatement==''){
              resp.data.activity5[0].problemStatement=question
            }
            resp.data.currentActivity='activity5'
              
            console.log('updating profile')
            const data=
            {
              profile: resp.data
            }    
          
          axios.put(`${baseUrl}pyinterpreter/profile/save/${sesId}`, data)
          .then((response) =>{
            //console.log(response.data)
            const activity = response.data.activity5[0]
            //console.log(activity)
              setmydata(activity)
           settotaldata(response.data)
              if(activity.decomposition.length=='0'){
            
              }
              else{
                if(activity.decomposition[0].userText!==""){

                    var newarr  = activity.decomposition[0].userText.split('=')
                    var narr=newarr[1].split(';')

                    var jmps=[]

                    narr.map((val,index)=>{
                      if(index<narr.length-1){
                      var arr = val.split(':')
                      var sparr = arr[0].split(',')
                      var comp = false;
                      
                      if(arr[4]=='true'){
                        comp=true
                      }
                      var sarr = arr[1].split(',')
                      var sarr1 = arr[2].split(',')
                      var sarr2 = arr[3].split(',')

                      console.log(arr[1])
                      console.log(sarr)
                      
                      jmps.push({"source":Number(sparr[1]),"destination":Number(sparr[3]), "rod1":sarr,"rod2":sarr1,"rod3":sarr2, "completed":comp})
                      }
                    })
                    console.log(jmps)
                    setdisjumps(jmps)                                   
                  }
                }
        
              if(activity.analysis.length=='0'){
                setmytime('')
                setmyspace('')
              }
              else{
                setmytime(activity.analysis[0].timeText)
                setmyspace(activity.analysis[0].spaceText)
              }
            

                // try{
                //         getData(sessid)
                //         interval = setInterval(() => {
                //             //console.log('Interval is working')
                //             getData(sessid);
                //             updateCount(user.count)
                //         }, 3000);
                
                   
                //   } catch (error) {
                //       if (axios.isCancel(error)) {
                //         console.log("cancelled");
                //       } else {
                //         throw error;
                //       }
                //     }
        
            
            setloading(false)
            

          })
          .catch((error)=>{
            console.log(error);
            });
          }
          })
          .catch((error)=>{
          console.log(error);
          });
        } catch (error) {
        if (axios.isCancel(error)) {
          console.log("cancelled");
        } else {
          throw error;
        }
      }

    };

    loadData();

   
    return() => {source.cancel();
    };


    }, []);

    useEffect(() => {  
      clearInterval(interval);
  
     })


  const LevenshteinDistance = (s1, s2) => {
    s1 = s1.toLowerCase();
    s2 = s2.toLowerCase();

    var costs = new Array(s2.length + 1);
    for (var i = 0; i <= s1.length; i++) {
        var lastValue = i;
        for (var j = 0; j <= s2.length; j++) {
            if (i == 0) {
                costs[j] = j;
            } else {
                if (j > 0) {
                    var newValue = costs[j - 1];
                    if (s1.charAt(i - 1) != s2.charAt(j - 1)) {
                        newValue = Math.min(Math.min(newValue, lastValue),
                                costs[j]) + 1;
                    }
                    costs[j - 1] = lastValue;
                    lastValue = newValue;
                }
            }
        }
        if (i > 0) {
            costs[s2.length] = lastValue;
        }
    }
    return costs[s2.length];
  }

  const similarity=(s1, s2) =>{
    var longer = s1;
    var shorter = s2;
    if (s1.length < s2.length) {
        longer = s2;
        shorter = s1;
    }
    var longerLength = longer.length;
    if (longerLength == 0) {
        return 1.0;
    }
    return (longerLength - LevenshteinDistance(longer, shorter)) / longerLength;
}

  
     const backdrop = {
      visible:{opacity: 1},
      hidden:{opacity: 0}
  }
  
  const modal = {
      hidden:{
        y:"-100vh",
        opacity: 1
      },
      visible:{
        y: "50px",
        opacity:1,
        transition:{ delay: 0.5 }
      },
      exit:{
        y:"500vh",
        opacity: 1,
        transition:{ delay: 1 }
  
      },
    }
     const imageVariants = {
      animateOne:{
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  repeat: finalCount,
                  duration:3,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      },
      animateTwo:{
        x: [0, 499],
        //y: [0, -30],
        transition: {
            x:{
                repeat: finalCount,
                duration:3,
                ease:"easeOut"
            },
            // y:{
            //     yoyo: Infinity,
            //     duration:0.25,
            //     ease:"easeOut"
            // },
        }
      }
    }

   

     const imgVariants = {
      hidden:{ opacity: 0},
      visible:{
        opacity: 1,  
          x: [0, 500],
          //y: [0, -30],
          transition: {
              x:{
                  yoyo: myCount,
                  duration:1,
                  ease:"easeOut"
              },
              // y:{
              //     yoyo: Infinity,
              //     duration:0.25,
              //     ease:"easeOut"
              // },
          }
      }
    }

    const Notification = (act) => {

      var query=totaldata.support.filter((ses)=> ses.activity == act)
      //console.log(query)
      const length = query.length;
      //console.log(length)
      ///check for new queries
      var newQuery = false;    

      if(length>0 && typeof(query)!='undefined' && typeof(length)!='undefined'){
        const lastMsg = new Date(query[length-1].created)
        const lastVisit = new Date(totaldata.lastViewStudentSupport)
      
        if(lastVisit < lastMsg){
          newQuery = true
        }
      }
        //console.log(newQuery)
        
          return newQuery

    }
    const handleCountChange = (event) =>{
      var count = event.target.value
      setmyCount(count)
      //console.log(event.target.value)
    }


  

    const getPatternText = () =>{
                
      var mytext = ''
      var newArr = mydata.pattern[0].userText.split(',')
      var i=0
      if(mydata.pattern[0].completed==false){
        while(newArr[i]!=='' && i<newArr.length){
            mytext=mytext+newArr[i]
            i=i+1
        }  
      }
      else{
        mytext =newArr[0]+newArr[1]+newArr[2]
      }
     /////console.log(mytext)          
       return(
             <>{mytext}</>
       );
     }
     const commaToText = (txt) =>{
      var mytext = ''
      if(txt!='' && typeof(txt)!=='undefined'){ 
      if(txt.includes(',')==true){
        var newArr = txt.split(',')
        var i=0
        while(newArr[i]!==''&& i<newArr.length && newArr[i]!=='undefined'){
              mytext=mytext+' '+newArr[i]
              i=i+1
          }  
        
         return mytext
      }
      else{
        return txt
      }
    }
    return txt
      
   }
   
     const abstractToText = (txt) =>{
        var mytext =''
        var tex = txt.split(':')

        if(tex[0]==='find specific pair'){
            var newArr = txt.split(',')
            var i=0
            while(typeof(newArr[i])!=='undefined'&& i<newArr.length){
                  mytext=mytext+newArr[i]
                  i=i+1
              }  
             return mytext
        }
        else{
            return txt
        }
    }

    const algoNewToText = (txt) =>{
      var tex = txt.split(';')
      var stex=[]
      if(tex.length==4){
        if(tex[2].includes('set')==true){
          stex = tex[2].split('set')
        }
      }
      else if(tex.length>4){
        if(tex[3].includes('set')==true){
          stex = tex[3].split('set')
        }
      }
      var text = []
      stex.map((val, index)=>{
        if(index>0){
          text[index]='set'+val
        }
        else{
          text[index]=val
        }
      })
      var texti=[]
      var k=0
      text.map((val,index)=>{
        var ifText = val.split('if')
        if(ifText.length>0){
          ifText.map((value,index1)=>{
            if(index1>0){
              texti[k++]= 'if'+value
            }
            else{
              texti[k++]= value
            }
          })
        }
        else{
          texti[k++]=val
        }
      })

      var textil=[]
      k=0
      texti.map((val,index)=>{
        var whileText = val.split('while')
        if(whileText.length>0){
          whileText.map((value,index1)=>{
            if(index1>0){
              textil[k++]= 'while'+value
            }
            else{
              textil[k++]= value
            }
          })
        }
        else{
          textil[k++]=val
        }
      })
      return (<div>
          {tex.length==4?
          <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                  <b>Input statement:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                   {commaToText(tex[0])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Define variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                   {commaToText(tex[1])} 
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Set variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                {textil.map((val, index)=>{
                    return(
                    <div>{commaToText(val)}</div>
                    )
                })}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Output:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[3])}
              </GridItem>
          </GridContainer>:
          <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <b>Input statement:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                  {commaToText(tex[0])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Define variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[1])} {commaToText(tex[2])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Set variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                {textil.map((val, index)=>{
                  return(
                    <div>{commaToText(val)}</div>
                    )
                })}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Output:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[4])}
              </GridItem>
          </GridContainer>}
          </div>
      )
    }
  
    const algoStepToText = (txt) =>{
      var tex = txt.split(';')
      var stex=[]
      if(tex.length==4){
        stex = tex[2].split('set')
      }
      else{
        stex = tex[3].split('set')
      }
  
  
      return (<div>
          {tex.length==4?
          <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                  <b>Input statement:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                   {commaToText(tex[0])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Define variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                   {commaToText(tex[1])} 
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Set variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
              
                {stex.map((val, index)=>{
                  if(index>0){
                  return(
                      <div>{commaToText('set'+val)}</div>
                    )
                  }
                  else{
                    var narr=val.split('~')
                  
                    var n=''
                    console.log(narr)
                    {narr.map((val,index)=>{
                      
                      if(index<narr.length-1){
                      var arr = val.split(':')
                      var sparr = arr[0].split(',')
                      var comp = false;
                      if(index==0){
                        if(arr[5]=='true'){
                          comp=true
                        }
                      }
                      if(arr[4]=='true'){
                        comp=true
                      }
                      if(comp==true){
                        n=n+';'+val
                      }
                    }
                    })}
                    return(<div>{n}</div>)
                    
                  }
                })}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
              <b>Output:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[3])}
              </GridItem>
          </GridContainer>:
          <GridContainer>
              <GridItem xs={12} sm={12} md={12}>
                <b>Input statement:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                  {commaToText(tex[0])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Define variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[1])} {commaToText(tex[2])}
              </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Set variable:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
              
              {stex.map((val, index)=>{
                if(index>0){
                return(
                    <div>{commaToText('set'+val)}</div>
                  )
                }
                else{
                  var narr=val.split('~')
                
                  var n=''
                  console.log(narr)
                  {narr.map((val,index)=>{
                    
                    if(index<narr.length-1){
                    var arr = val.split(':')
                    var sparr = arr[0].split(',')
                    var comp = false;
                    if(index==0){
                      if(arr[5]=='true'){
                        comp=true
                      }
                    }
                    if(arr[4]=='true'){
                      comp=true
                    }
                    if(comp==true){
                      n=n+';'+val
                    }
                  }
                  })}
                  return(<div>{n}</div>)
                  
                }
              })}
            </GridItem>
              <GridItem xs={12} sm={12} md={12}>
                <b>Output:</b>
              </GridItem>
              <GridItem xs={12} sm={12} md={12} >
                  {commaToText(tex[4])}
              </GridItem>
          </GridContainer>}
          </div>
      )
    }

      const algoToText = (txt) =>{
        var tex = txt.split(';')
        var stex=[]
        if(tex.length==4){
          stex = tex[2].split('set')
        }
        else{
          stex = tex[3].split('set')
        }
        return (<div>
            {tex.length==4?
            <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                    input statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                     {commaToText(tex[0])}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    define variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                     {commaToText(tex[1])} 
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    set variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                  {stex.map((val, index)=>{
                    if(index>0){
                    return(
                      <div>{commaToText('set'+val)}</div>
                    )
                    }
                    else{
                      return(
                      <div>{commaToText(val)}</div>
                      )
                    }
                  })}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    output statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                    {commaToText(tex[3])}
                </GridItem>
            </GridContainer>:
            <GridContainer>
                <GridItem xs={12} sm={12} md={3}>
                    input statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={9}>
                    {commaToText(tex[0])}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    define variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                    {commaToText(tex[1])} {commaToText(tex[2])}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    set variable:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                    {stex.map((val, index)=>{
                      if(index>0){
                      return(
                        <div>{commaToText('set'+val)}</div>
                      )
                      }
                      else{
                        return(
                        <div>{commaToText(val)}</div>
                        )
                      }
                    })}
                </GridItem>
                <GridItem xs={12} sm={12} md={3}>
                    output statement:
                </GridItem>
                <GridItem xs={12} sm={12} md={9} >
                    {commaToText(tex[4])}
                </GridItem>
            </GridContainer>}
            </div>
        )
     }

     const solutionIndex = () =>{
       var len=0
      if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
        len=mydata.decomposition[0].alternateSolution.length
      }
      if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
        len=len+mydata.pattern[0].alternateSolution.length
      }
      if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
        len=len+mydata.abstraction[0].alternateSolution.length
      }
      if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
        len=len+mydata.algorithm[0].alternateSolution.length
      }
      return len;

     }


      var abstractionList = [
      { label: abs2, value: abs2 },
      { label: '', value: '' }
    ];

    const Evaluation=(a,b,c,d,e,f,g,h,i)=>{
      var code='return 0'
      var num1=a;var num2=b;var num3=c;var num4=d;var num5=e;var num6=f;var num7=g;var num8=h;var num9=i
      if(num1!=='' && typeof(num1)!='undefined'){
          code=`n=${num1}; return n.toFixed(2)`
      }    
      if(num1!=='' && typeof(num1)!='undefined' && num2!='' && typeof(num2)!='undefined' && num3!='' && typeof(num3)!='undefined'){
          code=`n= ${num1}${num2}${num3}; return n.toFixed(2)`
      }
      if(num1!=='' && typeof(num1)!='undefined' && num2!='' && typeof(num2)!='undefined' && num3!=='' && typeof(num3)!='undefined' && num4!=='' && typeof(num4)!='undefined' && num5!=='' && typeof(num5)!='undefined'){
          code=`n=${num1}${num2}${num3}${num4}${num5}; return n.toFixed(2)`
      }
      if(num7!=='' && typeof(num7)!='undefined' && num6!=='' && typeof(num6)!='undefined' && num1!=='' && typeof(num1)!='undefined' && num2!='' && typeof(num2)!='undefined' && num3!=='' && typeof(num3)!='undefined' && num4!=='' && typeof(num4)!='undefined' && num5!=='' && typeof(num5)!='undefined'){
        code=`n=${num1}${num2}${num3}${num4}${num5}${num6}${num7}; return n.toFixed(2)`
      }
      if(num8!=='' && typeof(num8)!='undefined' && num9!=='' && typeof(num9)!='undefined' && num7!=='' && typeof(num7)!='undefined' && num6!=='' && typeof(num6)!='undefined' && num1!=='' && typeof(num1)!='undefined' && num2!='' && typeof(num2)!='undefined' && num3!=='' && typeof(num3)!='undefined' && num4!=='' && typeof(num4)!='undefined' && num5!=='' && typeof(num5)!='undefined'){
        code=`n=${num1}${num2}${num3}${num4}${num5}${num6}${num7}${num8}${num9}; return n.toFixed(2)`
      }
      const F = new Function(code);  
      var out = F()
      return out
      
  }
    
  const rootArea = (vol,d,a,b,c) =>{
    var code=`return 0`
    var num1=a;var num2=b;var num3=c;var volume=vol;var div = d
    if(div!=='' && typeof(div)!='undefined' && volume!=='' && typeof(volume)!='undefined' && num1!=='' && typeof(num1)!='undefined' && num2!='' && typeof(num2)!='undefined' && num3!='' && typeof(num3)!='undefined'){
      code=`n= Math.sqrt(${volume}${div}(${num1}${num2}${num3})); return n.toFixed(2)`
    }
    const F = new Function(code);  
    var out = F()
    return out
  }

    var setList = [
      { label: algo3, value: algo3 },
      { label: '', value: '' }
    ];


    var VarList = [
      {label: 'finalStep', value: 'finalStep'}, {label: 'Step', value: 'Step'},{label: 'finalPosition', value: 'finalPosition'},
      {label: 'RadCylinder', value: 'RadCylinder'}, {label: 'area', value: 'area'}, {label: 'n', value: 'n'}, {label: 'count', value: 'count'}, {label: 'var1', value: 'var1'},
      {label: 'l', value: 'l'}, {label: 'k', value: 'k'}, {label: 'x', value: 'x'},
      {label: 'y', value: 'y'}]

      var setVarList = [ { label: abs1, value: abs1 },
        {label: 'n', value: 'n'}, {label: 'o', value: 'o'}, {label: 'p', value: 'p'}, {label: 'sum', value: 'sum'},
        {label: 'area', value: 'area'}, {label: 'count', value: 'count'}, {label: 'var1', value: 'var1'},
        {label: 'l', value: 'l'}, {label: 'k', value: 'k'}, {label: 'x', value: 'x'}, {label: 'y', value: 'y'} ]

    const handleAbsChange1 = (event) =>{
        setabs1(event.target.value)
        setmyabs1(event.target.value)
    }
    const handleAbsChange2 = (event) =>{
      setabs2(event.target.value)
    }
    const handleAbsChange3 = (event) =>{
      setabs3(event.target.value)
    }
    const handleAbsChange4 = (event) =>{
      setabs4(event.target.value)
    }
    const handleAbsChange5 = (event) =>{
      setabs5(event.target.value)
    }
    const handleAbsChange6 = (event) =>{
      setabs6(event.target.value)
    }
    const handleAbsChange7 = (event) =>{
      setabs7(event.target.value)
    }
    const handleAbsChange8 = (event) =>{
      setabs8(event.target.value)
    }
    const handleAbsChange9 = (event) =>{
      setabs9(event.target.value)
    }
    const handleAbsChange10 = (event) =>{
      setabs10(event.target.value)
    }
    const handleAbsChange11 = (event) =>{
      setabs11(event.target.value)
    }
    const handleAbsChange12 = (event) =>{
      setabs12(event.target.value)
    }
    const handleAbsChange13 = (event) =>{
      setabs13(event.target.value)
    }
    const handleAbsChange14 = (event) =>{
      setabs14(event.target.value)
    }
    const handleAbsChange15 = (event) =>{
      setabs15(event.target.value)
    }
    const handleAbsChange16 = (event) =>{
      setabs16(event.target.value)
    }
    const handleAbsChange17 = (event) =>{
      setabs17(event.target.value)
    }
    const handleAbsChange18 = (event) =>{
      setabs18(event.target.value)
    }
    const handleMyAbsChange1 = (event) =>{
        setmyabs1(event.target.value)
    }
    const handleMyAbsChange2 = (event) =>{
        setmyabs2(event.target.value)
    }
    const handleAbsChangeNum = (event) =>{
      setabsNum(event.target.value)
    }
    
    
    

    const submitCount = () => {
      //console.log(myCount)
      dispatch(
        upCount(0)
      )
      
      var count = 2*myCount-1
      dispatch(
        finCount(count)
      )
      setfinalCount(count)
      cycleAnimation()
      //clearInterval(interval);


    }

    const closeModal=()=>{
      setmyModal(!myModal)
    }
    const closeModalTwo=()=>{
      setmyModalTwo(!myModalTwo)
    }
    const closeModalYesThree=()=>{
      
      var answerCorrect=false
      
      setmyModalThree(!myModalThree)
    
      
      if(activeStep==0){


          var decompos=''
                       
          var n=''
          var ans =''                         
          disjumps.map((value, index)=>{ 
              var k= index+1
              n=n+'Step'+k+'-Move disk from,'+value.source+',to,'+value.destination+':'+value.rod1.toString()+':'+value.rod2.toString()+':'+value.rod3.toString()+':'+value.completed+';'
              if(value.rod3.toString()==='0,1,2'){
                ans='found'
              }
            })
                        
          decompos ='Total steps='+n
        mydata.decomposition[0].userText=decompos
        mydata.decomposition[0].noOfattempts=mydata.decomposition[0].noOfattempts+1
        if(ans=='found'){
          mydata.decomposition.userText1=''
        }
        else{
          mydata.decomposition.userText1='incorrect answer'
        }
        arrStore.map((val, index)=>{
          mydata.decomposition[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity5',
          decomposition:mydata.decomposition,
          problem: 'towerOfHanoi' 
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity5[0]
          setmydata(activity)
           settotaldata(response.data)
          answerCorrect=activity.decomposition[0].completed
          
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          
          
            if(activity.decomposition[0].proceed===true){
              console.log('Going to'+activeStep) 
              setansType("Correct Answer Bravo!! Let's move to next")
              if(answerCorrect===false){
                
                  setmypattern(mydata.pattern[0].userText)
                  setpatnum1('')
                  setpatnum2('')
                  setpatnum3('')
                  setpatnum4('')
                  setpatnum5('')
                  setpatnum6('')
                  setpatnum7('')
                  setpatnum8('')

                }
              else{
                console.log('Going to'+activeStep) 
                setmypattern(mydata.pattern[0].userText)
                setpatnum1('')
                setpatnum2('')
                setpatnum3('')
                setpatnum4('')
                setpatnum5('')
                setpatnum6('')
                setpatnum7('')
                setpatnum8('')
              }
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
            else{
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                  if(activity.decomposition[0].noOfaltattempts<4){
                    setansType('Incorrect Answer. Try to connect your response to the previous step..')
                  }
                  else{
                    setaltHint(activity.decomposition[0].hints[0].alternate)
                  }
              }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }
            }

          setisSubmit(false)
          setmyModalTwo(!myModalTwo)    ////code for hints modal
          seterror('')

      })
            

      }

      if(activeStep==1){

        var err=false
        
          if( patnum1===''|| patnum2==='' || patnum3==='' || patnum4===''  || patnum5===''){
            err=true
          }
        
        if(err===false){
          seterror('')
        
          mydata.pattern[0].userText ='Observe that (2-1) disk is moved from ,'+patnum1+', to ,'+patnum2+', Next the disk is moved from,'+patnum3+', to ,'+patnum4+', Finally, move the disk from rod2 to ,'+patnum5

          if(patnum1=='rod1' && patnum2=='rod2'){
            mydata.pattern[0].userText1=''
          }
          else{
              mydata.pattern[0].userText1='movement disk1 incorrect'
          }

          if(patnum3=='rod1' && patnum4=='rod3'){
            mydata.pattern[0].userText2=''
          }
          else{
              mydata.pattern[0].userText2='movement disk2 incorrect'
          }

          if(patnum5=='rod3'){
            mydata.pattern[0].userText3=''
          }
          else{
            mydata.pattern[0].userText3='final disk incorrect'
          }
         


        mydata.pattern[0].noOfattempts=mydata.pattern[0].noOfattempts+1
        ///mydata.pattern[0].userText=mypattern
        //mydata.pattern[0].userText1=mypattern1
        if(mydata.altStep==='decomposition'){
          var len = mydata.decomposition[0].alternateSolution.length-1;
          if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
            mydata.pattern[0].noOfattempts=0
            mydata.pattern[0].noOfaltattempts=mydata.pattern[0].noOfaltattempts+1

          }
        }
        else if(mydata.altStep==='pattern'){
          var len = mydata.pattern[0].alternateSolution.length-1;
          if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
            mydata.pattern[0].noOfattempts=0
            mydata.pattern[0].noOfaltattempts=mydata.pattern[0].noOfaltattempts+1
          }
        }
        arrStore.map((val, index)=>{
          mydata.pattern[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity5',
          pattern: mydata.pattern,
          problem: 'towerOfHanoi' 
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity5[0]
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          setmydata(activity)
           settotaldata(response.data)
          
            if(activity.pattern[0].proceed===true){
              console.log('Going to'+activeStep) 
              setansType("Correct Answer Bravo!! Let's move to next")
              if(activity.pattern[0].completed===false){                
                
              }
              else{
                console.log('Going to'+activeStep)
                
              }
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
            }
            else{
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                if(activity.pattern[0].noOfaltattempts<4){
                    setansType('Incorrect Answer. Try to connect your response to the previous step..')
                  }
                  else{
                    if(activity.altStep=='decomposition'){
                        setaltHint(activity.decomposition[0].hints[0].alternate)
                      }
                      else if(activity.altStep=='pattern'){
                        setaltHint(activity.pattern[0].hints[0].alternate)
                      }
                  }
              }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }

            }
         
            setisSubmit(false)
            setmyModalTwo(!myModalTwo) ////code for hints modal
            seterror('')
  
        })
        }
        else{
          setisSubmit(false)
          seterror('Please enter text/number/operators in above space')
        }

      }

      if(activeStep==2){

        var err=''        
          if(abs1===''&& abs2==''&& abs3==''&& abs4==''){
            err='please enter text into the space above'
            seterror(err)
          } 
          
          mydata.abstraction[0].userText='Start with initial position: Move (n-1) disks from ,'+abs1+', to ,'+abs2+', Move last disk from ,'+abs3+', to ,'+abs4+', Finally, move (n-1) disks from rod2 to ,'+abs5+', :End with final position'      
          
          if(abs1=='rod1' && abs2=='rod2'){
            mydata.abstraction[0].userText2=''
          }
          else{
            mydata.abstraction[0].userText2='first movement incorrect'
          }
          if(abs3=='rod1' && abs4=='rod3'){
            mydata.abstraction[0].userText3=''
          }
          else{
            mydata.abstraction[0].userText3='second movement incorrect'
          }
          if(abs5=='rod3'){
            mydata.abstraction[0].userText4=''
          }
          else{
            mydata.abstraction[0].userText4='final movement incorrect'
          }
          mydata.abstraction[0].noOfattempts=mydata.abstraction[0].noOfattempts+1

        
        if(err===''){
        if(mydata.altStep==='decomposition'){
          var len = mydata.decomposition[0].alternateSolution.length-1;
          if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
            mydata.abstraction[0].noOfattempts=0
            mydata.abstraction[0].noOfaltattempts=mydata.abstraction[0].noOfaltattempts+1
          }
        }
        else if(mydata.altStep==='pattern'){
          var len = mydata.pattern[0].alternateSolution.length-1;
          if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
            mydata.abstraction[0].noOfattempts=0
            mydata.abstraction[0].noOfaltattempts=mydata.abstraction[0].noOfaltattempts+1
          }
        }
        arrStore.map((val, index)=>{
          mydata.abstraction[0].enteredSolution.push(val)
        })
        const data=
        {
          act:'activity5',
          abstraction: mydata.abstraction,
          problem: 'towerOfHanoi' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          //console.log(response.data)
          const activity = response.data.activity5[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          if(activity.abstraction[0].proceed===true){
            console.log('Going to'+activeStep)
            var setsum=mydata.abstraction[0].userText.split(':')
            setansType("Correct Answer Bravo!! Let's move to next")
            if(activity.abstraction[0].completed===false){
              if(activity.abstraction[0].userText.includes('find all pair')==true){
              }
              console.log('Not completed')
              
            }
            else{
              console.log('Going to'+activeStep)
              setmyalgo4('')     
              setmyalgo5('')     
            }
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
          }
          else{
            if(step===''){
              setansType('Incorrect Answer.')
            }
            else if(step!=='' && altcompleted==false){
                if(activity.abstraction[0].noOfaltattempts<4){
                    setansType('Incorrect Answer. Try to connect your response to the previous step..')
                  }
                  else{
                      if(activity.altStep=='decomposition'){
                        setaltHint(activity.decomposition[0].hints[0].alternate)
                      }
                      else if(activity.altStep=='pattern'){
                        setaltHint(activity.pattern[0].hints[0].alternate)
                      }
                  }            }
            else if(step!=='' && altcompleted==true){
              setansType('Can you change your answer? Try following hint.')
            }

          }
          setisSubmit(false)
          setmyModalTwo(!myModalTwo)
          seterror('')

        })

      }
      else{
        setisSubmit(false)
        seterror('Please enter text/number/operators in above space')
      }

    }

      if(activeStep==3){
        var ans=''
        var err=''
     
        var n=''
        var fstep=''
        var finalStep='' 
        var count=0
        algojumps.map((value, index)=>{ 
                          
              fstep = value.rod3.toString()
              var k= index+1
              n=n+'Step'+k+'-Move disk from,'+value.source+',to,'+value.destination+':'+value.rod1.toString()+':'+value.rod2.toString()+':'+value.rod3.toString()+':'+value.completed+'~'
              if(value.rod3.toString()==='1,2,3'){
                ans='found'
              }
              if(value.completed==true){
                count++
                finalStep=value.rod3.toString()             
              }
            })
                      
            var inp ='Total steps='+n

            mydata.algorithm[0].userText='input 3 rods 3 disks ;define,'+algo1+';initial position: rod1(3 disks) rod2(0 disk) rod3(0 disk).'+inp+'.set,'+algo2+',to,'+fstep+';output,'+algo3
            mydata.algorithm[0].userText1='Number of steps: '+count
            if(finalStep=='1,2,3'){
              if(Number(count)<12){
                mydata.algorithm[0].userText1='Number of steps: '+count
              }
              else{
                mydata.algorithm[0].userText1='correct answer: number of operations='+count+',total variables=1'
              }
            }
            else{
              mydata.algorithm[0].userText1='incorrect'
            }
            
            mydata.algorithm[0].noOfattempts=mydata.algorithm[0].noOfattempts+1
            
        
        err=error
        if(err===''){
          if(mydata.altStep==='decomposition'){
            var len = mydata.decomposition[0].alternateSolution.length-1;
            if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1

            }
          }
          else if(mydata.altStep==='pattern'){
            var len = mydata.pattern[0].alternateSolution.length-1;
            if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='abstraction'){
            var len = mydata.abstraction[0].alternateSolution.length-1;
            if(mydata.abstraction[0].alternateSolution[len].algoCompleted!==true){
              mydata.algorithm[0].noOfattempts=0
              mydata.algorithm[0].noOfaltattempts=mydata.algorithm[0].noOfaltattempts+1
            }
          }
          arrStore.map((val, index)=>{
            mydata.algorithm[0].enteredSolution.push(val)
          })
        const data=
        {
          act:'activity5',
          algorithm: mydata.algorithm,
          problem: 'towerOfHanoi',
        }                     
        console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity5[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            console.log('Alternate solution'+len+' '+altcompleted)
          }
          if(activity.algorithm[0].proceed===true){
            setActiveStep((prevActiveStep) => prevActiveStep + 1);
            console.log('Going to'+activeStep)
            ///var setsum='set sum to '+ mydata.abstraction[0].userText
            setansType("Correct Answer Bravo!! Let's move to next")
            if(activity.algorithm[0].completed===false){
              setmyspace(mydata.analysis[0].spaceText)
              setmytime(mydata.analysis[0].timeText) 
            }
            else{
              console.log('Going to'+activeStep)
              setmyspace(mydata.analysis[0].spaceText)
              setmytime(mydata.analysis[0].timeText) 
            }
          }
          else{
            if(step===''){
              setansType('Incorrect Answer.')
            }
            else if(step!=='' && altcompleted==false){
                if(activity.algorithm[0].noOfaltattempts<4){
                    setansType('Incorrect Answer. Try to connect your response to the previous step..')
                  }
                  else{
                    if(activity.altStep=='decomposition'){
                        setaltHint(activity.decomposition[0].hints[0].alternate)
                      }
                    else if(activity.altStep=='pattern'){
                        setaltHint(activity.pattern[0].hints[0].alternate)
                      }
                    else if(activity.altStep=='abstraction'){
                        setaltHint(activity.abstraction[0].hints[0].alternate)
                      }
                  }            
                }
            else if(step!=='' && altcompleted==true){
              setansType('Can you change your answer? Try following hint.')
            }

          }
          setisSubmit(false)
          setmyModalTwo(!myModalTwo)
          seterror('')          

      })
        }
        else{
          setisSubmit(false)
          setansType('see the error and change text/variable accordingly')
          setmyModalTwo(!myModalTwo)
        }

      }

      if(activeStep==4){
        setansType('')
        var err = ''
        if(myspace==''||myspace==' '){
          err='Please enter the no. of variables used'
        }
        else if(mytime==''||mytime==' '){
          err='Please enter the no. of operations used'
        }

        mydata.analysis[0].spaceText=myspace
        mydata.analysis[0].timeText=mytime
        mydata.analysis[0].noOfattempts=mydata.analysis[0].noOfattempts+1

        
        if(err===''){
          if(mydata.altStep==='decomposition'){
            var len = mydata.decomposition[0].alternateSolution.length-1;
            if(mydata.decomposition[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='pattern'){
            var len = mydata.pattern[0].alternateSolution.length-1;
            if(mydata.pattern[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          else if(mydata.altStep==='abstraction'){
            var len = mydata.abstraction[0].alternateSolution.length-1;
            if(mydata.abstraction[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1

            }
          }
          else if(mydata.altStep==='algorithm'){
            var len = mydata.algorithm[0].alternateSolution.length-1;
            if(mydata.algorithm[0].alternateSolution[len].algoCompleted!==true){
              mydata.analysis[0].noOfattempts=0
              mydata.analysis[0].noOfaltattempts=mydata.analysis[0].noOfaltattempts+1
            }
          }
          arrStore.map((val, index)=>{
            mydata.analysis[0].enteredSolution.push(val)
          })
        const data=
        {
          act:'activity5',
          analysis: mydata.analysis,
          problem: 'towerOfHanoi' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity5[0]
          setmydata(activity)
           settotaldata(response.data)
          var step = activity.altStep
          setarrStore([])
          if(step!==''){
            if(step=='decomposition'){
              var len = activity.decomposition[0].alternateSolution.length-1;
              var altcompleted = activity.decomposition[0].alternateSolution[len].algoCompleted
            }
            else if(step=='pattern'){
              var len = activity.pattern[0].alternateSolution.length-1;
              var altcompleted = activity.pattern[0].alternateSolution[len].algoCompleted
            }
            else if(step=='abstraction'){
              var len = activity.abstraction[0].alternateSolution.length-1;
              var altcompleted = activity.abstraction[0].alternateSolution[len].algoCompleted
            }
            else if(step=='algorithm'){
              var len = activity.algorithm[0].alternateSolution.length-1;
              var altcompleted = activity.algorithm[0].alternateSolution[len].algoCompleted
            }
          }
            if(activity.analysis[0].proceed===true){
              setActiveStep((prevActiveStep) => prevActiveStep + 1);
              console.log('Going to'+activeStep)
              if(activity.analysis[0].completed==false){
                setansType(' Your answer is correct but not the best. Try going back and change your solution to improve your solution.')
              }
              else{
                setansType('Correct Answer Bravo!!! The solution takes minimum variables')
              }
              
            }
            else{              
              if(step===''){
                setansType('Incorrect Answer.')
              }
              else if(step!=='' && altcompleted==false){
                  if(activity.analysis[0].noOfaltattempts<4){
                      setansType('Incorrect Answer. Try to analyse the algorithm developed in the previous step..')
                    }
                    else{
                      if(activity.altStep=='decomposition'){
                          setaltHint(activity.decomposition[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='pattern'){
                          setaltHint(activity.pattern[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='abstraction'){
                          setaltHint(activity.abstraction[0].hints[0].alternate)
                        }
                      else if(activity.altStep=='algorithm'){
                          setaltHint(activity.algorithm[0].hints[0].alternate)
                        }
                    }            
                  }
              else if(step!=='' && altcompleted==true){
                setansType('Can you change your answer? Try following hint.')
              }
            } 
            setisSubmit(false)         
            setmyModalTwo(!myModalTwo)
            seterror('')
      })
    }
    else{
      setisSubmit(false)
      setansType(err)
      setmyModalTwo(!myModalTwo)

    }
  }
  if(activeStep==5){
    setansType('')
    const data=
        {
          act:'activity5',
          comparison: mydata.comparison,
          problem: 'towerOfHanoi' 
        }                     
        //console.log(data)
  
      axios.put(`${baseUrl}pyinterpreter/profile/graph/${sesId}`, data)
      .then((response) => {
          console.log(response.data)
          const activity = response.data.activity5[0]
          setmydata(activity)
           settotaldata(response.data)
          setActiveStep((prevActiveStep) => prevActiveStep + 1);
          setmyModalTwo(!myModalTwo) ////code for hints modal 
          var len=0
          if(typeof(activity.decomposition[0].alternateSolution.length)!='undefined'){
            len=activity.decomposition[0].alternateSolution.length
          }
          if(typeof(activity.pattern[0].alternateSolution.length)!='undefined'){
            len=len+mydata.pattern[0].alternateSolution.length
          }
          if(typeof(activity.abstraction[0].alternateSolution.length)!='undefined'){
            len=len+activity.abstraction[0].alternateSolution.length
          }
          if(typeof(activity.algorithm[0].alternateSolution.length)!='undefined'){
            len=len+activity.algorithm[0].alternateSolution.length
          }
          if(typeof(activity.comparison[0].alternateSolution.length)!='undefined'){
            len=len+activity.comparison[0].alternateSolution.length
          }
          var list = new Array(len+1)
          for(let i=0; i<list.length;i++){
            var num=i+1
              list[i] = {
                'label':'solution'+num,
                'value':'solution'+num
              };
            }
            setsollist(list)
            setmycomsol(mydata.comparison[0].userText1) 
            setmycomsol1(mydata.comparison[0].userText2) 
            setmycomsol2(mydata.comparison[0].userText4) 
            setmycomsol3(mydata.comparison[0].userText5)
            setisSubmit(false)  
           setExpanded1('panel12')
           setmyModalTwo(!myModalTwo) ////code for hints modal
      })
    }
    if(activeStep==6){
      
      var empty = true;
      if(mycomsol !== '' && mycomsol2 !== '' && mycomsol1!=='' && mycomsol3!==''){
        empty=false
      }
       if(empty===true){
        setisSubmit(false)        
         seterror('Please enter text above')
        }
        else{
            seterror('')
            mydata.comparison[0].userText='Which of the solution do you think is better'
            mydata.comparison[0].userText1=mycomsol
            mydata.comparison[0].userText2=mycomsol1
            mydata.comparison[0].userText3='Your system can only perform 8 operations. If you want to implement one of the solutions, which one do you think is better?'
            mydata.comparison[0].userText4=mycomsol2
            mydata.comparison[0].userText5=mycomsol3
            arrStore.map((val, index)=>{
              mydata.comparison[0].enteredSolution.push(val)
          })
            const data=
            {
              act:'activity5',
              comparison:mydata.comparison,
              submit:true
            }                     
            console.log(data)
      
          axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
          .then((response) => {
              console.log(response.data)
              const activity = response.data.activity5[0]
              setmydata(activity)
           settotaldata(response.data)
              setisSubmit(false)        
              movedat('activity5','activity5','correct')
              history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/analytics/5`)
 
        })
      }
    } 
          
}


 

    const closeModalNoThree=()=>{
      setmyModalThree(!myModalThree)
      setisSubmit(false)
    }

    


    function getStepContent(step) {
      switch (step) {
        case 0:
          return 'decomposition' ;
        case 1:
          return 'pattern';
        case 2:
          return 'abstraction';
        case 3:
          return 'algorithm';
        case 4:
          return 'analysis';
        case 5:
          return 'solution';
        case 6:
          return 'comparison';
        case 7:
          return 'activity6';
        default:
          return 'unknown';
      }
    }
    const updateCount = (count) =>{
      //console.log(count)
      
      setNum(count)

      if(count<=user.fcount)
      {
        count=count+1
        dispatch(
          upCount(count)
        )
      }
      
    }

    

  const getData = (sessid) =>{
      const config = {
        headers: { Authorization: `Bearer ${user.token}` }
    };
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      //var num = Num+1
      //setNum(num)
      axios.get(`${baseUrl}pyinterpreter/profile/${sessid}`,config, { cancelToken: source.token })
          .then((response) =>{
            //console.log(response.data)
            const activity = response.data.activity5[0]
            settotaldata(response.data)
            //console.log(activity)
            setmydata(activity)
           settotaldata(response.data)
           
  
      })
    
  }

  ////////////Code for Stepper////////////////////////////

  const [activeStep, setActiveStep] = React.useState(0);
  const steps = getSteps();

  const handleNext = () => {
    var comp=false;

    if(activeStep==0 && mydata.decomposition[0].proceed===true){
      
      console.log('Going next Completed decomposition')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.decomposition[0].completed===true){
        if(mydata.pattern.length!=='0'){ 
          if(mydata.pattern[0].userText!==''){
            var newarr  = mydata.pattern[0].userText.split(',')
                    
                    console.log(newarr)
                      setpatnum1(newarr[1])
                      setpatnum2(newarr[3])
                      setpatnum3(newarr[5])
                      setpatnum4(newarr[7])
                      setpatnum5(newarr[10])

                            
          }          
        }
    }
    
      comp=true;
    }
    else if(activeStep==1 && mydata.pattern[0].proceed===true){
      console.log('Going next Completed pattern')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.pattern[0].completed===true){
        if(mydata.abstraction[0].userText!==''){
          var txt = mydata.abstraction[0].userText.split(',')
              setabs1(txt[1])
              setabs2(txt[3])
              setabs3(txt[5])
              setabs4(txt[7])
              setabs5(txt[10])
        }
      }
        comp=true;

    }
    else if(activeStep==2 && mydata.abstraction[0].proceed===true){
      console.log('Going next Completed abstraction')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('') 
      var setsum= mydata.abstraction[0].userText.split(':')

      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.abstraction[0].completed===true){

        if(mydata.algorithm[0].userText!==''){
          var newarr = mydata.algorithm[0].userText.split(';')
              var defarr = newarr[1].split(',')
              setalgo1(defarr[1])
              var steparr = newarr[2].split('.')
              console.log(steparr)
              var nearr  = steparr[1].split('=')
              var narr=nearr[1].split('~')
              console.log(narr)
                    var jmps=[]

                    narr.map((val,index)=>{
                      if(index<narr.length-1){
                      var arr = val.split(':')
                      var sparr = arr[0].split(',')
                      var comp = false;
                      if(arr[4]=='true'){
                        comp=true
                      }
                      var sarr = arr[1].split(',')
                      var sarr1 = arr[2].split(',')
                      var sarr2 = arr[3].split(',')

                      
                      jmps.push({"source":Number(sparr[1]),"destination":Number(sparr[3]), "rod1":sarr,"rod2":sarr1,"rod3":sarr2, "completed":comp})
                      }
                    })
                    console.log(jmps)
                    setalgojumps(jmps) 
              var setarr = steparr[2].split(',')
              setalgo2(setarr[1])
              var outarr = newarr[3].split(',')
              setalgo3(outarr[1])
      
        }
      }
      
      comp=true;

    }
    else if(activeStep==3 && mydata.algorithm[0].proceed===true){
      console.log('Going next Completed algorithm')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setansType('')
      setmyModalTwo(!myModalTwo) ////code for hints modal
      if(mydata.algorithm[0].completed===true){
        setmyspace(mydata.analysis[0].spaceText)
        setmytime(mydata.analysis[0].timeText)     
      }
      else{
        setmyspace(mydata.analysis[0].spaceText)
        setmytime(mydata.analysis[0].timeText)

      }
      
      comp=true;
    }
    else if(activeStep==4 && mydata.analysis[0].proceed===true){
      console.log('Going next Completed Analysis')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      console.log('Going to'+activeStep)   

      setmyModalTwo(!myModalTwo) ////code for hints modal
  
      if(mydata.analysis[0].completed===true){
        setansType('')
        // setmyspace(mydata.analysis[0].spaceText)
        // setmytime(mydata.analysis[0].timeText)     
      }
      
      comp=true;
    }
    else if(activeStep==5 && mydata.comparison[0].completed===true){
      setExpanded1('panel12')
      setActiveStep((prevActiveStep) => prevActiveStep + 1);
      setmyModalTwo(!myModalTwo) ////code for hints modal 
      var len=0
      if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
        len=mydata.decomposition[0].alternateSolution.length
      }
      if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
        len=len+mydata.pattern[0].alternateSolution.length
      }
      if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
        len=len+mydata.abstraction[0].alternateSolution.length
      }
      if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
        len=len+mydata.algorithm[0].alternateSolution.length
      }
      if(typeof(mydata.comparison[0].alternateSolution.length)!='undefined'){
        len=len+mydata.comparison[0].alternateSolution.length
      }
      var list = new Array(len+1)
      for(let i=0; i<list.length;i++){
        var num=i+1
          list[i] = {
            'label':'solution'+num,
            'value':'solution'+num
          };
        }
        setsollist(list)
        setmycomsol(mydata.comparison[0].userText1) 
        setmycomsol1(mydata.comparison[0].userText2) 
        setmycomsol2(mydata.comparison[0].userText4) 
        setmycomsol3(mydata.comparison[0].userText5)  
       
       setmyModalTwo(!myModalTwo) ////code for hints modal
       comp=true;
    }
    else if(activeStep==6 && mydata.completed===true){
      history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/analytics/5`)
      comp=true
      
    }
    
    console.log(activeStep)

   if(comp===false){
     console.log('Not completed step')
    setmyModalThree(!myModalThree)
   }
   else{
    movedat(getStepContent(activeStep),getStepContent(activeStep+1),'completed')
    setarrStore([])
  }  

  };

  const handleBack = () => {

    movedat(getStepContent(activeStep),getStepContent(activeStep-1),'completed')
    setarrStore([])
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
    console.log('Going Back to '+activeStep)
    console.log(mydata)
////Code to update the text area when click back
    if(activeStep-1==0){
      if(mydata.decomposition.length=='0'){
        setmydeco('')
      }
      else{
        setmydeco(mydata.decomposition[0].userText)

      }
    }
    else if(activeStep-1==1){
      if(mydata.pattern.length=='0'){
        setmypattern('')
      }
      else{
        setmypattern(mydata.pattern[0].userText)
      }
    }
    else if(activeStep-1==2){
    
      
    }
    else if(activeStep-1==3){
        // setmyalgo(mydata.algorithm[0].userText)
    }
    else if(activeStep-1==4){
        setmytime(mydata.analysis[0].timeText)
        setmyspace(mydata.analysis[0].spaceText) 
      
    }

  };

  const handleReset = () => {
    setActiveStep(0);
  };

  const handleAltSolution = () => {
    setarrStore([])
    setaltHint('')
    setisSubmit(true)
    setansType('Change you current solution')
    seterror('')
    if(mydata.altStep==='decomposition'){
      mydata.decomposition[0].proceed=false
      const data=
      {
        act: 'activity5',
        decomposition: mydata.decomposition
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
      movedat('solution','decomposition','altcompleted')
      setisSubmit(false)
        const activity = response.data.activity5[0]
        setmydata(activity)
           settotaldata(response.data)
        setActiveStep(0);

    })
    }
    else if(mydata.altStep==='pattern'){
      mydata.pattern[0].proceed=false
      const data=
      {
        act: 'activity5',
        pattern: mydata.pattern
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        movedat('solution','pattern','altcompleted')
        setisSubmit(false)
        const activity = response.data.activity5[0]
        setmydata(activity)
           settotaldata(response.data)
        setActiveStep(1);
    })
    }
    if(mydata.altStep==='abstraction'){
      mydata.abstraction[0].proceed=false
      const data=
      {
        act: 'activity5',
        abstraction: mydata.abstraction
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        movedat('solution','abstraction','altcompleted')
        setisSubmit(false)
        const activity = response.data.activity5[0]
        setmydata(activity)
        settotaldata(response.data)
        setActiveStep(2);
    })
    }
    if(mydata.altStep==='algorithm'){
      mydata.algorithm[0].proceed=false
      const data=
      {
        act: 'activity5',
        algorithm: mydata.algorithm
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        movedat('solution','algorithm','altcompleted')
        setisSubmit(false)
        const activity = response.data.activity5[0]
        setmydata(activity)
           settotaldata(response.data)
        setActiveStep(3);
    })
    }

  }

  /////////////////////////////////////////////////////


 

    const ToggleHint = () =>{
      if(loadhint==true){
      setloadhint(false)
      }
      else{
        setloadhint(true)
      }
    } 
    
    const Togglesupport = () =>{
      setloadsupport(!loadsupport)
      
    }



      const handleClosePreview= () => {
        setopenBoard(!openBoard)
      }

      const handleAccordionChange = (panel) => (event, isExpanded) => {
        setloadintro(false)
        if(panel==='panel8'){
          if(isExpanded===true){
            setmyModalTwo(!myModalTwo)
          }
        }
        setExpanded(isExpanded ? panel : false);
      };

      const handleAccordionChange1 = (panel) => (event, isExpanded) => {
        
        setExpanded1(isExpanded ? panel : false);
      };


      function MyCustomUploadAdapterPlugin(editor){
        editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
          return new MyUploadAdapter(loader)
        }
      }

      class MyUploadAdapter {
        constructor(props) {
            // CKEditor 5's FileLoader instance.
          this.loader = props;
          // URL where to send files.
          this.url = `${baseUrl}fileupload/files`;
        }
    
        // Starts the upload process.
        upload() {
          return this.loader.file
              .then( file => new Promise( ( resolve, reject ) => {
  
                  const toBase64 = file => new Promise((resolve, reject) => {
                      const reader = new FileReader();
                      reader.readAsDataURL(file);
                      reader.onload = () => resolve(reader.result);
                      reader.onerror = error => reject(error);
                  });
                  
                  return toBase64(file).then(cFile=>{
                    console.log(file)
                    const data=new FormData();
                    data.append('file', file)   
                    var filename = '';
                  axios.post(`${baseUrl}fileupload/files`, data)
                          .then((response) => {
                              console.log(response.data.file.filename)
                              filename = response.data.file.filename;
                              resolve({ 
                                default: `${baseUrl}fileupload/files/${filename}` 
                              })
                          })
                          .catch((error)=>{
                              reject(`Couldn't upload file: ${ file.name }.`)
                            console.log(error);
                            });
                          })
                  
              } ) );
      }
    
    }
 

    const handleAlgoNum1Change =(event,index)=> {
      var j=0;
      for(j=index;j<algojumps.length;j++){
        algojumps[j].letter=event.target.value
      }
      
      var source=[]
      var desti=[]
      console.log(algojumps[index].seq)
      
      algojumps[index].seq.map((value,ind)=>{
        console.log(value)
        if(value==algojumps[index].letter){
          source.push({"label":ind+1,"value":ind+1})
          if(algojumps[index].seq[ind+1]==0 && ind+1<=algojumps[index].seq.length){
            desti.push({"label":ind+2,"value":ind+2})
          }
          if(algojumps[index].seq[ind-1]==0 && ind-1>=0){
            desti.push({"label":ind,"value":ind})
          }
          if(algojumps[index].seq[ind+2]==0 && algojumps[index].seq[ind+1]!=0 && ind+2<=algojumps[index].seq.length){
            desti.push({"label":ind+3,"value":ind+3})
          }
          if(algojumps[index].seq[ind-2]==0 && algojumps[index].seq[ind-1]!=0 && ind-2>=0){
            desti.push({"label":ind-1,"value":ind-1})
          }

        }
        
      })
      console.log(source)
      console.log(desti)
      setalgosour(source)
      setalgodest(desti)
      setalgojumps(algojumps)

    }
    

    const SelectDisJump = (index) =>{
      var j=0;
      console.log(index)
        disjumps[index].completed=true
      var souRod = 'rod'+disjumps[index].source
      var desRod = 'rod'+disjumps[index].destination
      var souIndex=0
      var desIndex=0
      console.log(disjumps)
      var currjump = disjumps[index]
      console.log('sourceRod '+souRod+' detRod '+desRod)
      console.log(currjump[souRod])
      var k =0 
      currjump[souRod].map((val,index)=>{
        
        if(val>0){
          k++
        }
        if(k==1){
          souIndex=index
        }
      })
      
      currjump[desRod].map((val,index)=>{
        
        if(val==0){
          desIndex=index
        }
      })
    console.log('source index '+souIndex+', desti index '+desIndex)
   
    for(j=index;j<disjumps.length;j++){
      var k = disjumps[j][souRod][souIndex]
      disjumps[j][desRod][desIndex] = k
      disjumps[j][souRod][souIndex] = 0
    }
//////////////////////set source rod after done

      const findTop = (arr) =>{
        var i=0
        var elem='0'
        for(i=arr.length-1;i>=0;i--){
          if(arr[i]==0){
            }
          else{
            elem=arr[i]
            }
          }
        return elem
      }

      var top1 = findTop(disjumps[index].rod1)
      var top2 = findTop(disjumps[index].rod2)
      var top3 = findTop(disjumps[index].rod3)
      var sou=[]
      console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
      
        if(top1>0){
        sou.push({"label":'rod1',"value":1})
        }
        if(top2>0){
          sou.push({"label":'rod2',"value":2})
        }
        if(top3>0){
          sou.push({"label":'rod3',"value":3})
        }
      console.log(dest)
      setdissour(sou)

      /////////////////////////////////set dest//////////////////////////////////
      var dest=[]
      console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
      var newrod = 'rod'+sou[0].value
      console.log(newrod)
      if(newrod=='rod1'){
        if(top2==0){
          dest.push({"label":'rod2',"value":2})
        }
        if(top3==0){
          dest.push({"label":'rod3',"value":3})
        }
        if(top2>top1){
          dest.push({"label":'rod2',"value":2})
        }
        if(top3>top1){
          dest.push({"label":'rod3',"value":3})
        }
      }
      if(newrod=='rod2'){
        if(top1==0){
          dest.push({"label":'rod1',"value":1})
        }
        if(top3==0){
          dest.push({"label":'rod3',"value":3})
        }
        if(top1>top2){
          dest.push({"label":'rod1',"value":1})
        }
        if(top3>top2){
          dest.push({"label":'rod3',"value":3})
        }
      }
      if(newrod=='rod3'){
        if(top1==0){
          dest.push({"label":'rod1',"value":1})
        }
        if(top2==0){
          dest.push({"label":'rod2',"value":2})
        }
        if(top1>top3){
          dest.push({"label":'rod1',"value":1})
        }
        if(top2>top3){
          dest.push({"label":'rod2',"value":2})
        }
      }
      console.log(dest)
      setdisdest(dest)
      if(sou.length==0){
        sou.push({"label":'',"value":''})
      }
      if(dest.length==0){
        dest.push({"label":'',"value":''})
      }

      //////////////////////////////////////
      for(j=index+1;j<disjumps.length;j++){
        disjumps[j].source=sou[0].value
        disjumps[j].destination=dest[0].value
      }
     
      setdisjumps(disjumps)
   
  }

    const SelectAlgoJump = (index) =>{
      var j=0;
      console.log(index)
        algojumps[index].completed=true
      var souRod = 'rod'+algojumps[index].source
      var desRod = 'rod'+algojumps[index].destination
      var souIndex=0
      var desIndex=0
      var currjump = algojumps[index]
      console.log('sourceRod '+souRod+' detRod '+desRod)
      console.log(currjump[souRod])
      var k =0 
      currjump[souRod].map((val,index)=>{
        
        if(val>0){
          k++
        }
        if(k==1){
          souIndex=index
        }
      })
      
      currjump[desRod].map((val,index)=>{
        
        if(val==0){
          desIndex=index
        }
      })
    console.log('source index '+souIndex+', desti index '+desIndex)
   
    for(j=index;j<algojumps.length;j++){
      var k = algojumps[j][souRod][souIndex]
      algojumps[j][desRod][desIndex] = k
      algojumps[j][souRod][souIndex] = 0
    }
    

//////////////////////set source rod after done

      const findTop = (arr) =>{
        var i=0
        var elem='0'
        for(i=arr.length-1;i>=0;i--){
          if(arr[i]==0){
            }
          else{
            elem=arr[i]
            }
          }
        return elem
      }

      var top1 = findTop(algojumps[index].rod1)
      var top2 = findTop(algojumps[index].rod2)
      var top3 = findTop(algojumps[index].rod3)
      var sou=[]
      console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
      
        if(top1>0){
        sou.push({"label":'rod1',"value":1})
        }
        if(top2>0){
          sou.push({"label":'rod2',"value":2})
        }
        if(top3>0){
          sou.push({"label":'rod3',"value":3})
        }
      
      setalgosour(sou)

/////////////////////////////////set dest//////////////////////////////////
    var dest=[]
    console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
    var newrod = 'rod'+sou[0].value
    console.log(newrod)
    if(newrod=='rod1'){
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top2>top1){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3>top1){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod2'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top1>top2){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3>top2){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod3'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top1>top3){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2>top3){
        dest.push({"label":'rod2',"value":2})
      }
    }
    console.log(dest)
    setalgodest(dest)
    if(sou.length==0){
      sou.push({"label":'',"value":''})
    }
    if(dest.length==0){
      dest.push({"label":'',"value":''})
    }

//////////////////////////////////////
    for(j=index+1;j<algojumps.length;j++){
      algojumps[j].source=sou[0].value
      algojumps[j].destination=dest[0].value
    }
    setalgojumps(algojumps)
   
  }


    const DeleteAlgoJump = (index) =>{
      var j=0;
      console.log(index)
      for(j=index;j<algojumps.length;j++){
        algojumps[j].completed=false
        if(j>0){
          algojumps[j].rod1.pop()
          algojumps[j].rod1.pop()
          algojumps[j].rod1.pop()
          algojumps[j].rod1.push(algojumps[j-1].rod1[0])
          algojumps[j].rod1.push(algojumps[j-1].rod1[1])
          algojumps[j].rod1.push(algojumps[j-1].rod1[2])
          algojumps[j].rod2.pop()
          algojumps[j].rod2.pop()
          algojumps[j].rod2.pop()
          algojumps[j].rod2.push(algojumps[j-1].rod2[0])
          algojumps[j].rod2.push(algojumps[j-1].rod2[1])
          algojumps[j].rod2.push(algojumps[j-1].rod2[2])
          algojumps[j].rod3.pop()
          algojumps[j].rod3.pop()
          algojumps[j].rod3.pop()
          algojumps[j].rod3.push(algojumps[j-1].rod3[0])
          algojumps[j].rod3.push(algojumps[j-1].rod3[1])
          algojumps[j].rod3.push(algojumps[j-1].rod3[2])
        }
        else{
          algojumps[j].rod1.pop()
          algojumps[j].rod1.pop()
          algojumps[j].rod1.pop()
          algojumps[j].rod1.push(1)
          algojumps[j].rod1.push(2)
          algojumps[j].rod1.push(3)
          algojumps[j].rod2.pop()
          algojumps[j].rod2.pop()
          algojumps[j].rod2.pop()
          algojumps[j].rod2.push(0)
          algojumps[j].rod2.push(0)
          algojumps[j].rod2.push(0)
          algojumps[j].rod3.pop()
          algojumps[j].rod3.pop()
          algojumps[j].rod3.pop()
          algojumps[j].rod3.push(0)
          algojumps[j].rod3.push(0)
          algojumps[j].rod3.push(0)
        }
       
      }

      //////////////////////set source /////
      const findTop = (arr) =>{
        var i=0
        var elem='0'
        for(i=arr.length-1;i>=0;i--){
          if(arr[i]==0){
            }
          else{
            elem=arr[i]
            }
          }
        return elem
      }

      var top1 = findTop(algojumps[index].rod1)
      var top2 = findTop(algojumps[index].rod2)
      var top3 = findTop(algojumps[index].rod3)
      var sou=[]
      console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
      
        if(top1>0){
          sou.push({"label":'rod1',"value":1})
        }
        if(top2>0){
          sou.push({"label":'rod2',"value":2})
        }
        if(top3>0){
          sou.push({"label":'rod3',"value":3})
        }
      console.log('Source after delete: '+sou)
      setalgosour(sou)
///////////////////////////////////////////////////////////////////////////////////
///////////////////////////set destination//////////////////////////////////////////

    var dest=[]
    console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
    var newrod = 'rod'+sou[0].value
    console.log(newrod)
    if(newrod=='rod1'){
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top2>top1){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3>top1){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod2'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top1>top2){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3>top2){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod3'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top1>top3){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2>top3){
        dest.push({"label":'rod2',"value":2})
      }
    }
    console.log(dest)
    console.log('dest after delete: '+dest)
    if(sou.length==0){
      sou.push({"label":'',"value":''})
    }
    if(dest.length==0){
      dest.push({"label":'',"value":''})
    }
    setalgodest(dest)
    for(j=index;j<algojumps.length;j++){
      algojumps[j].source=sou[0].value
      algojumps[j].destination=dest[0].value
    }
/////////////////////////////////////////////////////////////////////////////////    
  setalgojumps(algojumps)
}



    const DeleteDisJump = (index) =>{
      var j=0;
      console.log(index)
      for(j=index;j<disjumps.length;j++){
        disjumps[j].completed=false
        if(j>0){
          disjumps[j].rod1.pop()
          disjumps[j].rod1.pop()
          disjumps[j].rod1.pop()
          disjumps[j].rod1.push(disjumps[j-1].rod1[0])
          disjumps[j].rod1.push(disjumps[j-1].rod1[1])
          disjumps[j].rod1.push(disjumps[j-1].rod1[2])
          disjumps[j].rod2.pop()
          disjumps[j].rod2.pop()
          disjumps[j].rod2.pop()
          disjumps[j].rod2.push(disjumps[j-1].rod2[0])
          disjumps[j].rod2.push(disjumps[j-1].rod2[1])
          disjumps[j].rod2.push(disjumps[j-1].rod2[2])
          disjumps[j].rod3.pop()
          disjumps[j].rod3.pop()
          disjumps[j].rod3.pop()
          disjumps[j].rod3.push(disjumps[j-1].rod3[0])
          disjumps[j].rod3.push(disjumps[j-1].rod3[1])
          disjumps[j].rod3.push(disjumps[j-1].rod3[2])
        }
        else{
          disjumps[j].rod1.pop()
          disjumps[j].rod1.pop()
          disjumps[j].rod1.pop()
          disjumps[j].rod1.push(0)
          disjumps[j].rod1.push(1)
          disjumps[j].rod1.push(2)
          disjumps[j].rod2.pop()
          disjumps[j].rod2.pop()
          disjumps[j].rod2.pop()
          disjumps[j].rod2.push(0)
          disjumps[j].rod2.push(0)
          disjumps[j].rod2.push(0)
          disjumps[j].rod3.pop()
          disjumps[j].rod3.pop()
          disjumps[j].rod3.pop()
          disjumps[j].rod3.push(0)
          disjumps[j].rod3.push(0)
          disjumps[j].rod3.push(0)
        }
       
      }

      //////////////////////set source /////
      const findTop = (arr) =>{
        var i=0
        var elem='0'
        for(i=arr.length-1;i>=0;i--){
          if(arr[i]==0){
            }
          else{
            elem=arr[i]
            }
          }
        return elem
      }

      var top1 = findTop(disjumps[index].rod1)
      var top2 = findTop(disjumps[index].rod2)
      var top3 = findTop(disjumps[index].rod3)
      var sou=[]
      console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
      
        if(top1>0){
          sou.push({"label":'rod1',"value":1})
        }
        if(top2>0){
          sou.push({"label":'rod2',"value":2})
        }
        if(top3>0){
          sou.push({"label":'rod3',"value":3})
        }
      console.log('Source after delete: '+sou)
      setdissour(sou)
///////////////////////////////////////////////////////////////////////////////////
///////////////////////////set destination//////////////////////////////////////////

    var dest=[]
    console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
    var newrod = 'rod'+sou[0].value
    console.log(newrod)
    if(newrod=='rod1'){
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top2>top1){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3>top1){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod2'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top1>top2){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3>top2){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod3'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top1>top3){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2>top3){
        dest.push({"label":'rod2',"value":2})
      }
    }
    console.log(dest)
    console.log('dest after delete: '+dest)

    setdisdest(dest)
    if(sou.length==0){
      sou.push({"label":'',"value":''})
    }
    if(dest.length==0){
      dest.push({"label":'',"value":''})
    }
    for(j=index;j<disjumps.length;j++){
      disjumps[j].source=sou[0].value
      disjumps[j].destination=dest[0].value
    }
/////////////////////////////////////////////////////////////////////////////////    
  setdisjumps(disjumps)
  }


    const handleDisNum2Change =(event,index)=> {
      var j=0;
      for(j=index;j<disjumps.length;j++){
        disjumps[j].source=event.target.value
      }

      const findTop = (arr) =>{
        var i=0
        var elem='0'
        for(i=arr.length-1;i>=0;i--){
          if(arr[i]==0){
            }
          else{
            elem=arr[i]
            }
          }
        return elem
      }

    var top1 = findTop(disjumps[index].rod1)
    var top2 = findTop(disjumps[index].rod2)
    var top3 = findTop(disjumps[index].rod3)
    var dest=[]
    console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
    var newrod = 'rod'+event.target.value
    console.log(newrod)
    if(newrod=='rod1'){
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top2>top1){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3>top1){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod2'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top1>top2){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3>top2){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod3'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top1>top3){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2>top3){
        dest.push({"label":'rod2',"value":2})
      }
    }
    console.log(dest)
    setdisdest(dest)

    console.log(disjumps)
    setdisjumps(disjumps)
    }

    const handleDisNum3Change =(event,index)=> {
      var j=0;
      for(j=index;j<disjumps.length;j++){
        disjumps[j].destination=event.target.value
    }
      setdisjumps(disjumps)
    }
    
    const handleAlgoNum2Change =(event,index)=> {
      var j=0;
      for(j=index;j<algojumps.length;j++){
        algojumps[j].source=event.target.value
      }

      const findTop = (arr) =>{
        var i=0
        var elem='0'
        for(i=arr.length-1;i>=0;i--){
          if(arr[i]==0){
            }
          else{
            elem=arr[i]
            }
          }
        return elem
      }

    var top1 = findTop(algojumps[index].rod1)
    var top2 = findTop(algojumps[index].rod2)
    var top3 = findTop(algojumps[index].rod3)
    var dest=[]
    console.log('rod1 '+top1+', rod2 '+top2+', rod3 '+top3)
    var newrod = 'rod'+event.target.value
    console.log(newrod)
    if(newrod=='rod1'){
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top2>top1){
        dest.push({"label":'rod2',"value":2})
      }
      if(top3>top1){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod2'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3==0){
        dest.push({"label":'rod3',"value":3})
      }
      if(top1>top2){
        dest.push({"label":'rod1',"value":1})
      }
      if(top3>top2){
        dest.push({"label":'rod3',"value":3})
      }
    }
    if(newrod=='rod3'){
      if(top1==0){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2==0){
        dest.push({"label":'rod2',"value":2})
      }
      if(top1>top3){
        dest.push({"label":'rod1',"value":1})
      }
      if(top2>top3){
        dest.push({"label":'rod2',"value":2})
      }
    }
    console.log(dest)
    setalgodest(dest)

    console.log(algojumps)
    setalgojumps(algojumps)
    }


    const handleAlgoNum3Change =(event,index)=> {
      var j=0;
      for(j=index;j<algojumps.length;j++){
        algojumps[j].destination=event.target.value
    }
      setalgojumps(algojumps)
    }

    const textToDisk = (arr) =>{
      var newArr = arr.toString()

      if(newArr=='1,2,3'){
        return(
          <img alt='th123' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th123.PNG'} />
        )
      }
      if(newArr=='0,0,0'){
        return(
          <img alt='th0' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th0.PNG'} />
        )
      }
      if(newArr=='0,0,1'){
        return(
          <img alt='th1' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th1.PNG'} />
        )
      }
      if(newArr=='0,0,2'){
        return(
          <img alt='th2' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th2.PNG'} />
        )
      }
      if(newArr=='0,1,2'){
        return(
          <img alt='th12' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th12.PNG'} />
        )
      }
      if(newArr=='0,1,3'){
        return(
          <img alt='th13' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th13.PNG'} />
        )
      }
      if(newArr=='0,2,3'){
        return(
          <img alt='th23' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th23.PNG'} />
        )
      }
      if(newArr=='0,0,3'){
        return(
          <img alt='th3' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th3.PNG'} />
        )
      }
    }

    const handleNum4Change =(event)=> {
      setnum4(event.target.value)
    }
    const handleNum5Change =(event)=> {
      setnum5(event.target.value)
    }
    const handleNum6Change =(event)=> {
      setnum6(event.target.value)
    }
    const handleNum7Change =(event)=> {
        setnum7(event.target.value)
      }
    const handleNum8Change =(event)=> {
        setnum8(event.target.value)
      }
    const handleNum9Change =(event)=> {
        setnum9(event.target.value)
    }
    const handleNum10Change =(event)=> {
        setnum10(event.target.value)
    }
    const handleNum11Change =(event)=> {
        setnum11(event.target.value)
    }
    const handleNum12Change =(event)=> {
        setnum12(event.target.value)
    }
    const handleNum13Change =(event)=> {
      setnum13(event.target.value)
    }
    const handleNum14Change =(event)=> {
      setnum14(event.target.value)
    }
    const handleNum15Change =(event)=> {
      setnum15(event.target.value)
    }
    const handleNum16Change =(event)=> {
      setnum16(event.target.value)
    }
    const handleNum17Change =(event)=> {
      setnum17(event.target.value)
    }
    const handleNum18Change =(event)=> {
      setnum18(event.target.value)
    }
    const handleNum19Change =(event)=> {
      setnum19(event.target.value)
    }
    const handleNum20Change =(event)=> {
      setnum20(event.target.value)
    }
    const handleNum21Change =(event)=> {
      setnum21(event.target.value)
  }
  const handleNum22Change =(event)=> {
      setnum22(event.target.value)
  }
  const handleNum23Change =(event)=> {
    setnum23(event.target.value)
  }
  const handleNum24Change =(event)=> {
    setnum24(event.target.value)
  }
  const handleNum25Change =(event)=> {
    setnum25(event.target.value)
  }
    const handlePatnumChange =(event)=> {
        setpatnum(event.target.value)
      }
    const handlePatnum1Change =(event)=> {
      setpatnum1(event.target.value)
    }
    const handlePatnum2Change =(event)=> {
      setpatnum2(event.target.value)
    }
    const handlePatnum3Change =(event)=> {
      setpatnum3(event.target.value)
    }
    const handlePatnum4Change =(event)=> {
      setpatnum4(event.target.value)
    }
    const handlePatnum5Change =(event)=> {
      setpatnum5(event.target.value)
    }
    const handlePatnum6Change =(event)=> {
      setpatnum6(event.target.value)
    }
    const handlePatnum7Change =(event)=> {
      setpatnum7(event.target.value)
    }
    const handlePatnum8Change =(event)=> {
      setpatnum8(event.target.value)
    }
    const handlePatnum9Change =(event)=> {
        setpatnum9(event.target.value)
    }
    const handlePatnum10Change =(event)=> {
      setpatnum10(event.target.value)
    }
    const handlePatnum11Change =(event)=> {
    setpatnum11(event.target.value)
    }
    const handlePatnum12Change =(event)=> {
      setpatnum12(event.target.value)
    }
    const handlePatnum13Change =(event)=> {
      setpatnum13(event.target.value)
    }
    const handlePatnum14Change =(event)=> {
      setpatnum14(event.target.value)
    }
    const handlePatnum15Change =(event)=> {
      setpatnum15(event.target.value)
    }
    const handlePatnum16Change =(event)=> {
      setpatnum16(event.target.value)
    }

    const PairCalculate=()=>{
      var code='return 1'
      var arr=[12, 17, 24, 27, 29, 37]
      var ind1=0
      var ind2=0
      arr.map((text, index)=>{
        if (text==abs1){
            ind1=index          
        }
        if(text==abs2){
          ind2=index
        }
      })
      if(abs15!=='' && typeof(abs15)!='undefined' && abs14!=='' && typeof(abs14)!='undefined' && myabs2!=='' && typeof(myabs2)!='undefined' && myabs1!=='' && typeof(myabs1)!='undefined' && abs7!=='' && typeof(abs7)!='undefined' && abs6!=='' && typeof(abs6)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!=='' && typeof(abs2)!='undefined' && abs3!=='' && typeof(abs3)!='undefined'){
        var inde1='index1'
        var inde2='index1'
        var inde3='index1'  
        var inde4='index1'    
        if(abs3=='firstNumPair'){
            inde1='index1'
          }
          else{
            inde1='index2'
          } 
          if(abs5=='firstNumPair'){
            inde2='index1'
          }
          else{
            inde2='index2'
          } 
          if(myabs1=='firstNumPair'){
            inde3='index1'
          }
          else{
            inde3='index2'
          } 
          if(myabs2=='firstNumPair'){
            inde4='index1'
          }
          else{
            inde4='index2'
          }
        code=`arr=[12, 17, 24, 27, 29, 37];n=${absNum};minimum=9999;Difference=0;calculatedSum='';pairs='not found';index1=0;index2=0;for(index1=${ind1};index1<6;index1++){for(index2=${ind2};index2<6;index2++){calculatedSum=arr[${inde1}]${abs4}arr[${inde2}];Difference=Math.abs(calculatedSum${abs14}${abs15});if(Difference${abs6}${abs7}){pairs=arr[${inde3}]+','+arr[${inde4}];${abs7}=Difference;}}}; return pairs`
      }
      console.log(code)
      const F = new Function(code);  
      var out = F()
      return out
  }

  const PairSpecificCalculate=()=>{
    var code='return 1'
    var arr=[12, 17, 24, 27, 29, 37]
    var ind1=0
    var ind2=0
    arr.map((text, index)=>{
      if (text==abs1){
          ind1=index          
      }
      if(text==abs2){
        ind2=index
      }
    })
    if(abs15!=='' && typeof(abs15)!='undefined' && abs14!=='' && typeof(abs14)!='undefined' && abs13!=='' && typeof(abs13)!='undefined' && abs12!=='' && typeof(abs12)!='undefined' && abs11!=='' && typeof(abs11)!='undefined' && abs10!=='' && typeof(abs10)!='undefined' && abs9!=='' && typeof(abs9)!='undefined' && abs8!=='' && typeof(abs8)!='undefined' && myabs2!=='' && typeof(myabs2)!='undefined' && myabs1!=='' && typeof(myabs1)!='undefined' && abs7!=='' && typeof(abs7)!='undefined' && abs6!=='' && typeof(abs6)!='undefined' && abs4!=='' && typeof(abs4)!='undefined' && abs5!=='' && typeof(abs5)!='undefined' && abs1!=='' && typeof(abs1)!='undefined' && abs2!=='' && typeof(abs2)!='undefined' && abs3!=='' && typeof(abs3)!='undefined'){
      var inde1='index1'
      var inde2='index1'
      var inde3='index1'  
      var inde4='index1' 
      var inc='++'
      var dec='--'   
      if(abs3=='firstNumPair'){
          inde1='index1'
        }
        else{
          inde1='index2'
        } 
        if(abs5=='firstNumPair'){
          inde2='index1'
        }
        else{
          inde2='index2'
        } 
        if(myabs1=='firstNumPair'){
          inde3='index1'
        }
        else{
          inde3='index2'
        } 
        if(myabs2=='firstNumPair'){
          inde4='index1'
        }
        else{
          inde4='index2'
        }
        if(abs10==='decrease'){
          inc='--'
        }
        if(abs13=='increase'){
          dec='++'
        }
      code=`arr=[12, 17, 24, 27, 29, 37];calculatedSum=0;Difference=0;maximum=0;minimum=9999;n=${absNum};pairs='not found';k=0;found=false;index1=${ind1};index2=${ind2};while(arr[index1]!=arr[index2] && found==false && index1<6 && index1>-1 && index2>-1 && index2<6){k++;calculatedSum=arr[${inde1}]${abs4}arr[${inde2}];Difference=Math.abs(calculatedSum${abs14}${abs15});if(Difference${abs6}${abs7}){${abs7}=Difference;pairs=arr[${inde3}]+','+arr[${inde4}];}if(calculatedSum${abs8}${abs9}){index1${inc};}else if(calculatedSum${abs11}${abs12}){index2${dec};}if(k>30){found=true;}}; return pairs`
    }
    console.log(code)
    const F = new Function(code);  
    var out = F()
    return out
}

  const AlgoPairCalculate=()=>{
    var code='return 1'
    
    var err=''
    if(myalgo===''){
      err='Please provide a way to write the algorithm'
    }
    else if(myalgo1==='' || absNum===''){
      err='Please provide an input statement'
    }
    else if(myalgo2===''|| myalgo3==='' || myalgo4===''|| myalgo5===''){
      err='Please select a new define variable'
    }
    else if(myalgo6==='' || algo1==='' || algo5==='' || algo6===''){
      err='Define a set variable'
    }
    else if(myalgo7=='' || myalgo8=='' || myalgo9=='' || algo2=='' || algo3==''|| algo4==''){
      err='set variable to a value'
    }
    else if(algo7==''|| algo8==''|| algo9=='' ){
      err='complete the function to calculate radius of new cylinder'
    }
    else if(algo===''){
      err='please define an output variable'
    }
    else{
      
      var incVar = false
      if(myalgo6==myalgo4||myalgo6==myalgo5||myalgo6==myalgo2||myalgo6==myalgo3){
        incVar=true
      }
      if(incVar===false){
          err='Setting variable to incorrect value. Please change set variable '+myalgo6+' to a variable declared previously'
      }
      var incVar = false
      
      if(algo1==myalgo4||algo1==myalgo5||algo1==myalgo2||algo1==myalgo3){
        incVar=true
      }
      if(incVar===false){
          err='Setting variable to incorrect value. Please change set variable '+algo1+' to a variable declared previously'
      }
      
      incVar = false
      if(algo5==myalgo4||algo5==myalgo5||algo5==myalgo2||algo5==myalgo3){
        incVar=true
      }
      if(incVar===false){
             err='Setting variable to incorrect value. Please change set variable '+algo5+' to a variable declared previously'
      }

      incVar = false
      if(algo6==myalgo4||algo6==myalgo5||algo6==myalgo2||algo6==myalgo3){
        incVar=true
      }
      if(incVar===false){
             err='Setting variable to incorrect value. Please change set variable '+algo6+' to a variable declared previously'
      }
      
    var incVar2=false
    if(algo===myalgo4){
      incVar2=true
    }
    else if(algo===myalgo5){
      incVar2=true
    }
    else if(algo===myalgo3){
      incVar2=true
    }
    else if(algo===myalgo2){
      incVar2=true
    }
    if(incVar2===false){
      err='Output variable incorrect. Please change the output variable and set it to previously declared variable'
    }
  }
  
      if(err==''){
        if(algo9!=='' && typeof(algo9)!='undefined' && algo8!=='' && typeof(algo8)!='undefined' && algo7!=='' && typeof(algo7)!='undefined' && algo6!=='' && typeof(algo6)!='undefined' && algo5!=='' && typeof(algo5)!='undefined' && algo4!=='' && typeof(algo4)!='undefined' && algo3!=='' && typeof(algo3)!='undefined' && algo2!=='' && typeof(algo2)!='undefined' && algo1!=='' && typeof(algo1)!='undefined' && algo!=='' && typeof(algo)!='undefined' && myalgo9!=='' && typeof(myalgo9)!='undefined' && myalgo8!=='' && typeof(myalgo8)!='undefined' && myalgo7!=='' && typeof(myalgo7)!='undefined' && myalgo6!=='' && typeof(myalgo6)!='undefined' && myalgo5!=='' && typeof(myalgo5)!='undefined' && myalgo4!=='' && typeof(myalgo4)!='undefined' && myalgo3!=='' && typeof(myalgo3)!='undefined' && myalgo2!=='' && typeof(myalgo2)!='undefined' && myalgo1!=='' && typeof(myalgo1)!='undefined' && myalgo!='underfined'){
          
          code=`radius=${absNum};height=${myalgo1};${myalgo4}=0;${myalgo2}=0;${myalgo3}=0;${myalgo5}='0';function VolumeCylinder(r,h) {return 3.14*r*r*h.toFixed(2);};function VolumeCone(r,h) {return 1/3*(3.14*r*r*h).toFixed(2);};function RadiusCylinder(h,v) {return Math.sqrt(v/(3.14*h)).toFixed(2);};${myalgo6}=${myalgo7}(${myalgo8},${myalgo9});${algo1}=${algo2}(${algo3},${algo4});${algo5}=${myalgo6}+${algo1};${algo6}=${algo7}(${algo8},${algo9}); return ${algo}`
        }
      }
    seterror(err)
    console.log(code)
    const F = new Function(code);  
    var out = F()
    return out
}
      

const AlgoSpecificPairCalculate=()=>{
  var code='return 1'
    
  var err=''
  
  if(algo1===''){
    err='Please select a new define variable'
  }
  else if(algo2===''){
    err='Define a set variable'
  }
  else if(algo3===''){
    err='please define an output variable'
  }
  else{
    
    var incVar = false
    if(algo2==algo1){
      incVar=true
    }
    if(incVar===false){
        err='Set variable incorrect. Please change set variable '+algo2+' to a variable declared previously'
    }
    
  var incVar2=false
  if(algo3===algo1){
    incVar2=true
  }
  if(incVar2===false){
    err='Output variable incorrect. Please change the output variable and set it to previously declared variable'
  }
}
    if(err==''){
      
    }
  seterror(err)
 
}
      

      const handleAlgoChange =( event )=> {
        setalgo(event.target.value)
      }
      const handleAlgoChange1 =( event )=> {
        setalgo1(event.target.value)
      }
      const handleAlgoChange2 =( event )=> {
        setalgo2(event.target.value)
      }
      const handleAlgoChange3 =( event )=> {
        setalgo3(event.target.value)
      }
      const handleAlgoChange4 =( event )=> {
        setalgo4(event.target.value)
      }
      const handleAlgoChange5 =( event )=> {
        setalgo5(event.target.value)
      }
      const handleAlgoChange6 =( event )=> {
        setalgo6(event.target.value)
      }
      const handleAlgoChange7 =( event )=> {
        setalgo7(event.target.value)
      }
      const handleAlgoChange8 =( event )=> {
        setalgo8(event.target.value)
      }
      const handleAlgoChange9 =( event )=> {
        setalgo9(event.target.value)
      }
      const handleAlgoChange10 =( event )=> {
        setalgo10(event.target.value)
      }
      const handleAlgoChange11 =( event )=> {
        setalgo11(event.target.value)
      }
      const handleAlgoChange12 =( event )=> {
        setalgo12(event.target.value)
      }
      const handleAlgoChange13 =( event )=> {
        setalgo13(event.target.value)
      }
      const handleAlgoChange14 =( event )=> {
        setalgo14(event.target.value)
      }
      const handleAlgoChange15 =( event )=> {
        setalgo15(event.target.value)
      }
      const handleAlgoChange16 =( event )=> {
        setalgo16(event.target.value)
      }
      const handleAlgoChange17 =( event )=> {
        setalgo17(event.target.value)
      }
      const handleAlgoChange18 =( event )=> {
        setalgo18(event.target.value)
      }
      const handleAlgoChange19 =( event )=> {
        setalgo19(event.target.value)
      }
      const handleAlgoChange20 =( event )=> {
        setalgo20(event.target.value)
      }
      const handleAlgoChange21 =( event )=> {
        setalgo21(event.target.value)
      }
      const handleAlgoChange22 =( event )=> {
        setalgo22(event.target.value)
      }
      const handleAlgoChange23 =( event )=> {
        setalgo23(event.target.value)
      }
      const handleAlgoChange24 =( event )=> {
        setalgo24(event.target.value)
      }
      const handleAlgoChange25 =( event )=> {
        setalgo25(event.target.value)
      }
      const handleAlgorithmChange =( event )=> {
        setmyalgo(event.target.value)
      }

      const handleAlgorithmChange1 =( event )=> {
        setmyalgo1(event.target.value)
      }

      const handleAlgorithmChange2 =( event )=> {
        setmyalgo2(event.target.value)
      }

      const handleAlgorithmChange3 =( event )=> {
        setmyalgo3(event.target.value)
      }
      
      const handleAlgorithmChange4 =( event )=> {
        setmyalgo4(event.target.value)
      }

      const handleAlgorithmChange5 =( event )=> {
        setmyalgo5(event.target.value)
      }
      const handleAlgorithmChange6 =( event )=> {
        setmyalgo6(event.target.value)
      }
      const handleAlgorithmChange7 =( event )=> {
        setmyalgo7(event.target.value)
      }
      const handleAlgorithmChange8 =( event )=> {
        setmyalgo8(event.target.value)
      }
      const handleAlgorithmChange9 =( event )=> {
        setmyalgo9(event.target.value)
      }
      const compareSolutionChange =( event )=> {
        setmycomsol(event.target.value)
      }
      const compareSolutionChange1 =( event )=> {
        setmycomsol1(event.target.value)
      }
      const compareSolutionChange2 =( event )=> {
        setmycomsol2(event.target.value)
      }
      const compareSolutionChange3 =( event )=> {
        setmycomsol3(event.target.value)
      }

      const handleSpaceChange =( event )=> {
        setmyspace(event.target.value)
      }

      const handleTimeChange =( event )=> {
        setmytime(event.target.value)
      }

      const custom_config = {
        extraPlugins: [ MyCustomUploadAdapterPlugin ],
        
        // toolbar: {
        //   items: [
        //     'heading',
        //     '|',
        //     'bold',
        //     'italic',
        //     'link',
        //     'bulletedList',
        //     'numberedList',
        //     '|',
        //     'blockQuote',
        //     'insertTable',
        //     '|',
        //     'imageUpload',
        //     'undo',
        //     'MathType',
        //     'SpecialCharacters',
        //     'SpecialCharactersMathematical',
        //     'redo',
        //     'Subscript', 
        //     'Superscript',            
        //   ]
        // }
        // ,
        // table: {
        //   contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
        // }
      }
      const buttonSelect = (len,k) =>{
        var mysol='solution'+len
        console.log(k)
        if(k=='1'){
          setmycomsol(mysol)
        }
        else if(k=='3'){
          setmycomsol2(mysol)
        }
      }


      const totalSolutionComparison =(deco,pattern,abs,algorithm,time,space,len,k,step)=>{

        const algoText = (txt) =>{
          var tex = txt.split(';')
          var ou = ''
          var out=''
          if(tex.length==4){
            ou = tex[3].split(',')
          }
          else if(tex.length>4){
            ou = tex[4].split(',')
          }
          out = ou[0]+','+ou[1]
          return (<div>
              {tex.length==4?
              <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                      input statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                       {commaToText(tex[0])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      define variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                       {commaToText(tex[1])} 
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      set variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[2])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      output statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(out)}
                  </GridItem>
              </GridContainer>:
              <GridContainer>
                  <GridItem xs={12} sm={12} md={5}>
                      input statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7}>
                      {commaToText(tex[0])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      define variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[1])} {commaToText(tex[2])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      set variable:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(tex[3])}
                  </GridItem>
                  <GridItem xs={12} sm={12} md={5}>
                      output statement:
                  </GridItem>
                  <GridItem xs={12} sm={12} md={7} >
                      {commaToText(out)}
                  </GridItem>
              </GridContainer>}
              </div>
          )
        }
          return (
            <>
            <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
              
                <Card hoverable onClick={() => buttonSelect(len,k)}  sx={k=='1'?{border: "1px solid grey",backgroundColor:mycomsol=='solution'+len?'#09ebe3':'white'}:{border: "1px solid blue",backgroundColor:mycomsol2=='solution'+len?'#09dfeb':'white'}}>
                      <b align="center"> Your Solution {len}</b>
                  <CardBody>
                    <b style={classes.ana}> Decomposition </b>
                    <p style={step=='decomposition'?{ ...classes.cardTitle }:null}>{commaToText(deco)}</p>
                    <b style={classes.ana}> Pattern </b>
                    <p style={step=='pattern'?{ ...classes.cardTitle }:null}>{commaToText(pattern)}</p>
                    <b style={classes.ana}> Abstraction </b>
                    <p style={step=='abstraction'?{ ...classes.cardTitle }:null}>{commaToText(abs)}</p>
                    <b style={classes.ana}> Algorithm </b>
                    <p style={step=='algorithm'?{ ...classes.cardTitle }:null}>{algoText(algorithm)}</p>
                    <b style={classes.ana}> Analysis</b>
                    <p style={classes.ana}>
                      
                      No. of operations={time},No. of variables={space}       </p>
                  </CardBody>
                </Card>
                </Link>
                {mycomsol!=='' && mycomsol=='solution'+len && k=='1'?
                <>
                    <h5>Answer 1. Why do you think it is?</h5>
                      <Field
                        component={TextField}
                        type="text"
                        variant="outlined"
                        label="Enter your answer "
                        value={mycomsol1}
                        onChange={compareSolutionChange1}
                        //validate={validateSimName}
                        fullWidth= {true} 
                        //style = {{width: 340}}
                      />                                    
                  </>
                :null}
                 {mycomsol2!=='' && mycomsol2=='solution'+len && k=='3'?
              <>
                <h5>Answer 2. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol3}
                    onChange={compareSolutionChange3}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
              </>              
              );
            }



const solutionComparison =(algorithm,analysis,len,k)=>{

  const algoText = (txt) =>{
    var tex = txt.split(';')
          var ou = ''
          var out=''
          if(tex.length==4){
            ou = tex[3].split(',')
          }
          else if(tex.length>4){
            ou = tex[4].split(',')
          }
          out = ou[0]+','+ou[1]
    return (<div>
        {tex.length==4?
        <GridContainer>
            <GridItem xs={12} sm={12} md={5}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
                 {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                 {commaToText(tex[1])} 
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(out)}
            </GridItem>
        </GridContainer>:
        <GridContainer>
            <GridItem xs={12} sm={12} md={5}>
                input statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7}>
                {commaToText(tex[0])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                define variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[1])} {commaToText(tex[2])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                set variable:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(tex[3])}
            </GridItem>
            <GridItem xs={12} sm={12} md={5}>
                output statement:
            </GridItem>
            <GridItem xs={12} sm={12} md={7} >
                {commaToText(out)}
            </GridItem>
        </GridContainer>}
        </div>
    )
  }
    return (
        <>
        <Link color="inherit" to="#" onClick={ (event) => event.preventDefault() }>
          <Card  onClick={() => buttonSelect(len,k)} hoverable sx={k=='1'?{border: "1px solid grey",backgroundColor:mycomsol=='solution'+len?'#09ebe3':'white'}:{border: "1px solid blue",backgroundColor:mycomsol2=='solution'+len?'#09dfeb':'white'}}>
                <b align="center">(other possible solutions) Solution {len}</b>
            <CardBody>
              <b style={classes.ana}> Algorithm </b>
              <p style={classes.cardTitle}>{algoText(algorithm)}</p>
              <b style={classes.ana}> Analysis </b>
              <p style={{color:'blue'}}>
                {analysis} 
              </p>
            </CardBody>
          </Card>
        </Link>
         
        {mycomsol!=='' && mycomsol=='solution'+len && k=='1'?
              <>
                <h5>Answer 1. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol1}
                    onChange={compareSolutionChange1}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
            {mycomsol2!=='' && mycomsol2=='solution'+len && k=='3'?
              <>
                <h5>Answer 2. Why do you think it is?</h5>
                  <Field
                    component={TextField}
                    type="text"
                    variant="outlined"
                    label="Enter your answer "
                    value={mycomsol3}
                    onChange={compareSolutionChange3}
                    //validate={validateSimName}
                    fullWidth= {true} 
                    //style = {{width: 340}}
                  />                                    
              </>
            :null}
        </>            
        );
      }
    

const submitPatternForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      mydata.pattern[0].userText ='Observe that (2-1) disk is moved from ,'+patnum1+', to ,'+patnum2+', Next the disk is moved from,'+patnum3+', to ,'+patnum4+', Finally, move the disk from rod2 to ,'+patnum5
                                          
      arrStore.map((val, index)=>{
        mydata.pattern[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity5',
        pattern:mydata.pattern
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity5[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  
}


const submitAbstractionForm = () =>{
  
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
                                              
      mydata.abstraction[0].userText='Start with initial position: Move (n-1) disks from ,'+abs1+', to ,'+abs2+', Move last disk from ,'+abs3+', to ,'+abs4+', Finally, move (n-1) disks from rod2 to ,'+abs5+', :End with final position'      
      arrStore.map((val, index)=>{
        mydata.abstraction[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity5',
        abstraction:mydata.abstraction
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity5[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  
}

const submitAlgorithmForm = () =>{
  var empty = true;
 
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      var n=''
      var ans=''
      var fstep=''
      var finalStep='' 
      var count=0
      algojumps.map((value, index)=>{ 
                          
        fstep = value.rod3.toString()
        var k= index+1
        n=n+'Step'+k+'-Move disk from,'+value.source+',to,'+value.destination+':'+value.rod1.toString()+':'+value.rod2.toString()+':'+value.rod3.toString()+':'+value.completed+'~'
        if(value.rod3.toString()==='1,2,3'){
          ans='found'
        }
        if(value.completed==true){
          count++
          finalStep=value.rod3.toString()             
        }
      })
                    
          var inp ='Total steps='+n

          mydata.algorithm[0].userText='input 3 rods 3 disks ;define,'+algo1+';initial position: rod1(3 disks) rod2(0 disk) rod3(0 disk).'+inp+'.set,'+algo2+',to,'+fstep+';output,'+algo3
          mydata.algorithm[0].userText1='Number of steps: '+count
        
      
          arrStore.map((val, index)=>{
            mydata.algorithm[0].enteredSolution.push(val)
          })
      const data=
      {
        act:'activity5',
        algorithm:mydata.algorithm
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity5[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
}

const submitAnalysisForm = () =>{
  const analysis = myanalysis;                     
  var empty = true;
  if(myspace !== '' && mytime !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter a number')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      mydata.analysis[0].spaceText=myspace
      mydata.analysis[0].timeText=mytime
      arrStore.map((val, index)=>{
        mydata.analysis[0].enteredSolution.push(val)
      })
      const data=
      {
        act:'activity5',
        analysis:mydata.analysis
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        const activity = response.data.activity5[0]
        setmydata(activity)
           settotaldata(response.data)
        setarrStore([])
    })
  }
}

const submitComparisonForm = () =>{
  var empty = true;
  if(mycomsol !== '' && mycomsol2 !== ''){
    empty=false
  }
   if(empty===true){
     seterror('Please enter text above')
    }
    else{
      seterror('')
      alert(JSON.stringify('Saving...', null, 2));
      mydata.comparison[0].userText='Which of the solution do you think is better'
      mydata.comparison[0].userText1=mycomsol
      mydata.comparison[0].userText2=mycomsol1
      mydata.comparison[0].userText3='Your system can only perform 8 operations. If you want to implement one of the solutions, which one do you think is better?'
      mydata.comparison[0].userText4=mycomsol2
      mydata.comparison[0].userText5=mycomsol3
      arrStore.map((val, index)=>{
        mydata.comparison[0].enteredSolution.push(val)
    })
      const data=
      {
        act:'activity5',
        comparison:mydata.comparison
      }                     
      console.log(data)

    axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
    .then((response) => {
        console.log(response.data)
        setarrStore([])
        const activity = response.data.activity5[0]
        setmydata(activity)
           settotaldata(response.data)
        
    })
  }
}

//////////////code to update student interaction 

const solutionEnter = (act,step,k) =>{

  var dat = {
    solution:k,
    altStep:mydata.altStep,
    created:Date.now(),
  }
  var newact = totaldata[act][0]
  var len = newact[step][0].enteredSolution.length
  var lastVal = newact[step][0].enteredSolution[len-1].solution

  var arrlen = arrStore.length

  if(arrStore.length>0){
    lastVal = arrStore[arrlen-1].solution
  }

  if(lastVal==k){

  }
  else{
     arrStore.push(dat)
     setarrStore(arrStore)
   
  }

}

const movedat = (sou,dest,typ) =>{

  var dat = {
    source:sou,
    destination:dest,
    altStep:mydata.altStep,
    type:typ,

  }
  const data=
  {
    act:'activity5',
    moveData:dat
  }                     
  console.log(data)

//   axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//   .then((response) => {
//     if(typ=='completed' && arrStore.length>0){
//       if(sou=='decomposition'){
//         arrStore.map((val, index)=>{
//           mydata.decomposition[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity5',
//           decomposition:mydata.decomposition
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity5[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }
//       else if(sou=='pattern'){
//         arrStore.map((val, index)=>{
//           mydata.pattern[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity5',
//           pattern:mydata.pattern
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity5[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }
//       else if(sou=='abstraction'){
//         arrStore.map((val, index)=>{
//           mydata.abstraction[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity5',
//           abstraction:mydata.abstraction
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity5[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='algorithm'){
//         arrStore.map((val, index)=>{
//           mydata.algorithm[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity5',
//           algorithm:mydata.algorithm
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity5[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='analysis'){
//         arrStore.map((val, index)=>{
//           mydata.analysis[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity5',
//           analysis:mydata.analysis
//         } 
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity5[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         })
//       }
//       else if(sou=='comparison'){
//         arrStore.map((val, index)=>{
//           mydata.comparison[0].enteredSolution.push(val)
//         })
//         const data=
//         {
//           act:'activity5',
//           comparison:mydata.comparison
//         }
//         axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
//         .then((response) => {
//         console.log(response.data)
//         const activity = response.data.activity5[0]
//         setmydata(activity)
//            settotaldata(response.data)
//         setarrStore([])
//         }) 
//       }        
//     }
//     else{
//       const activity = response.data.activity5[0]
//       setmydata(activity)
//            settotaldata(response.data)
//     }
// })
}

const history = useNavigate();


const handleBackActivity = () =>{
  movedat('activity5','activity3','completed')
  history(`/student/dashboard/viewstudentclass/${clas._id}/session/${sesId}/activity3${totaldata.activity2[0].level}`)
}

const hintGenerate =()=>{
  return(
    <div>
                          {hintsActivity1.map((text, index)=>(
                              index===activeStep?
                              <Card sx={{border: "1px solid grey"}}>
                                  <CardHeader color="success" align="center">
                                    <Typography variant="subtitle2" align="center" sx={classes.cardTitleWhite}>Hints {hintsActivity1[index].step}</Typography>
                                  </CardHeader>
                                
                                  <List sx={classes.messageArea}>
                                    {index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'? 
                                        <div>
                                        <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                          <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>Basic </Typography>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                             {mydata.decomposition[0].hints[0].basic}
                                          </AccordionDetails>
                                        </Accordion> <Divider /> </div>:null}
                                      {index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced' || index==0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate'?
                                      <div>
                                      <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>Intermediate</Typography>
                                          
                                        </AccordionSummary>
                                        <AccordionDetails>
                                         {mydata.decomposition[0].hints[0].intermediate}
                                        </AccordionDetails>
                                      </Accordion><Divider /> </div>:null}
                                      {index===0 && mydata.decomposition[0].levelOfHints==='Advanced'?<div>
                                      <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                        <AccordionSummary
                                          expandIcon={<ExpandMoreIcon />}
                                          aria-controls="panel1bh-content"
                                          id="panel1bh-header"
                                        >
                                          <Typography sx={classes.heading}>Advanced</Typography>
                                        </AccordionSummary>
                                        <AccordionDetails>
                                          {mydata.decomposition[0].hints[0].advanced}
                                        </AccordionDetails>
                                      </Accordion><Divider /> </div>:null}
                                    {index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {index===1 && mydata.pattern[0].levelOfHints==='Advanced' || index===1 && mydata.pattern[0].levelOfHints==='Intermediate'?
                                  < div>
                                    <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Intermediate</Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].intermediate}
                                      </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index===1 && mydata.pattern[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.pattern[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Basic' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>: null}
                                  {index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced' || index===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.abstraction[0].hints[0].intermediate}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==2 && mydata.abstraction[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.abstraction[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Basic' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  {index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.algorithm[0].hints[0].intermediate}
                                           
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==3 && mydata.algorithm[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.algorithm[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>:null}
                                  {index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Basic' || index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Basic </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.analysis[0].hints[0].basic}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  {index==4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && mydata.analysis[0].levelOfHints==='Advanced'?
                                  <div>
                                  <Accordion expanded={expanded1 === 'panel6'} onChange={handleAccordionChange1('panel6')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Intermediate</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.analysis[0].hints[0].intermediate}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div>: null}
                                  {index==4 && mydata.analysis[0].levelOfHints==='Advanced'?<div>
                                  <Accordion expanded={expanded1 === 'panel7'} onChange={handleAccordionChange1('panel7')}>
                                    <AccordionSummary
                                      expandIcon={<ExpandMoreIcon />}
                                      aria-controls="panel1bh-content"
                                      id="panel1bh-header"
                                    >
                                      <Typography sx={classes.heading}>Advanced</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                      {mydata.analysis[0].hints[0].advanced}
                                    </AccordionDetails>
                                  </Accordion><Divider /> </div> :null}

                                  {index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index==0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index==0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced'? 
                                        <div>
                                        <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                          <AccordionSummary
                                            expandIcon={<ExpandMoreIcon />}
                                            aria-controls="panel1bh-content"
                                            id="panel1bh-header"
                                          >
                                            <Typography sx={classes.heading}>General </Typography>
                                          </AccordionSummary>
                                          <AccordionDetails>
                                             {mydata.decomposition[0].hints[0].general}
                                          </AccordionDetails>
                                        </Accordion> <Divider /> </div>:null}
                                  
                                  {index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}

                                  {index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Basic' || index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || index===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>: null}
                                  
                                  {index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Basic' || index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || index==3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}

                                  {index==4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Basic' || index==4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Intermediate' || index===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Advanced'? 
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel4'} onChange={handleAccordionChange1('panel4')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>General </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.analysis[0].hints[0].general}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                  </List>
                                  {mydata.altStep==""?'':<List sx={classes.messageArea}>
                                  {(index==1 && mydata.altStep=='decomposition' && mydata.pattern[0].noOfaltattempts>3)||(index==2 && mydata.altStep=='decomposition' && mydata.abstraction[0].noOfaltattempts>3)||(index==3 && mydata.altStep=='decomposition' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='decomposition' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.decomposition[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {(index==2 && mydata.altStep=='pattern' && mydata.abstraction[0].noOfaltattempts>3)||(index==3 && mydata.altStep=='pattern' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='pattern' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.pattern[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {(index==3 && mydata.altStep=='abstraction' && mydata.algorithm[0].noOfaltattempts>3)||(index==4 && mydata.altStep=='abstraction' && mydata.analysis[0].noOfaltattempts>3)?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.abstraction[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                    {index==4 && mydata.altStep=='algorithm' && mydata.analysis[0].noOfaltattempts>3?
                                    <div>
                                    <Accordion expanded={expanded1 === 'panel9'} onChange={handleAccordionChange1('panel9')}>
                                      <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel1bh-content"
                                        id="panel1bh-header"
                                      >
                                        <Typography sx={classes.heading}>Alternate Hint </Typography>
                                      </AccordionSummary>
                                      <AccordionDetails>
                                        {mydata.algorithm[0].hints[0].alternate}
                                      </AccordionDetails>
                                    </Accordion> <Divider /> </div>:null}
                                   
                                  

                                  </List>}
                                 </Card>
                                :null))}                  
              
                              </div>
  )
}

//console.log(Num)
//console.log('Deco:'+mydeco)



    return(
    loading!==true?
      <div>
          <GridContainer>
            {/* {sim()} */}
          <GridItem xs={12} sm={12} md={12}>
            <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
              <Link color="inherit" to="/student/dashboard">
                Dashboard
              </Link>
              <Link color="inherit" to={`/student/dashboard/viewsession/${clas._id}`}>
                <Typography color="textPrimary">{clas.title}</Typography>
              </Link>
                                         
              <Link color="inherit" to={`/student/dashboard/viewstudentclass/${clas._id}/session/${totaldata.sessionId}/profile/${sesId}/scenario`}>
                <Typography color="textPrimary"> Scenario </Typography>
              </Link>
                <Typography color="textPrimary">Activity 5</Typography>

            </Breadcrumbs>
            {/* {console.log({...sess}.title)} */}
          </GridItem>
            <GridItem xs={12} sm={12} md={12} >
              <Button
                  //disabled={activeStep === 0}
                  onClick={handleBackActivity}
                  sx={classes.backButton}
                  >
                      Previous Activity
              </Button>
              <Typography variant="h4" align="center" sx={classes.fontLato}>
                 Solve the Puzzle 
              </Typography>
            </GridItem>

        </GridContainer>
          
            
            {myModal && (
            <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                    <GridContainer> 
                      <GridItem xs={12} sm={12} md={3}>
                        <img alt='Thinking Panda' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <motion.div style={classes.modal1}>
                          <h5 style={classes.fontCursive}>Read the Instructions carefully.</h5>
                          <h5 style={classes.fontCursive}> Solve the problem to complete the activity and move forward in your mission.</h5>
                        </motion.div>
                      </GridItem>
                    </GridContainer>
                    <Button color="success" variant="contained" onClick={closeModal} 
                    title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                        OK
                    </Button>
                    
                  </motion.div>
                </motion.div>
            </AnimatePresence>)}

                                  
          <CustomTabs
            title="Activity:"
            headerColor="primary"
            tabs={[
              {
                tabName: "Introduction",
                tabIcon: AssignmentIcon,
                 tabContent: 
                (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}> 
                      <blockquote className="blockquote">
                                <p>
                                  After repairing the bridge, your team crossed the bridge carefully. 
                                  The team marches forward into the scarier jungle as it's getting dark. 
                                </p>

                                <p>
                                  Going further, you can see a long dark wall with no way forward.  
                                  Upon observing the wall closely, we found a door to a cave.  
                                </p>
                                <p>
                                  The door has a strange architecture with something written on it in Sanskrit.  
                                  After translating into English, it is identified that we have to solve a problem to open the door. 
                                  To proceed further, read the problem statement carefully.   
                                </p>
                                
                      </blockquote>                              
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                      <img alt='Cave door' className="card-img-top" src={baseUrl+'assets/images/cavedoor.PNG'} />
                  </GridItem>
                </GridContainer> 
                )
              },
              {
                tabName: "Problem Statement",
                tabIcon: QuestionAnswerIcon,
                tabContent: (
                  <GridContainer>
                    <GridItem xs={12} sm={12} md={6}>
                      <blockquote className="blockquote">
                        <p> The writings on the door describes a puzzle problem as describe below: </p>
                          <p>There are 3 towers and 3 rings. These rings are of different sizes and stacked upon in an ascending order, i.e. the smaller one sits over the larger one. 
                            The objective of the problem is to move the entire stack from source rod to destination rod, obeying the following simple rules: 
                          </p>
                          <p>1. Only one disk can be moved at a time. </p>
                          <p>2. Each move consists of taking the upper disk from one of the stacks and placing it on top of another stack i.e. a disk can only be moved if it is the uppermost disk on a stack.</p>
                          <p>3. No disk may be placed on top of a smaller disk (large disk cannot be on the small disk).</p>
                          <p>
                          Can you develop the steps to solve the problem in minimum number of operations. The door will open automatically after you identify the minimum steps required to convert from initial position to final position.
                          Your objective is defined as follows:</p>
  
                      </blockquote>
                    </GridItem>
                    <GridItem xs={12} sm={12} md={6}>
                      <img alt='Activity5Hard' className="card-img-top"  src={baseUrl+'assets/images/towerOfHanoi.PNG'} />
                    </GridItem>
                    <GridItem xs={12} sm={12} md={12}>
                      <blockquote className="blockquote">
                        <p>Given 3 towers and 3 rings</p><p><strong>Input: </strong> Initial position (see image) </p><p><strong>Output: </strong> Final position (see image)</p>
                        <p><strong>Objective: </strong> Identify the minimum steps required to convert from Intial to final position.</p>
                      </blockquote>
                    </GridItem>
                  </GridContainer>
                  
                )                
              },
              {
                tabName: "Example",
                tabIcon: MultilineChartIcon,
                tabContent: (
                <GridContainer>
                  <GridItem xs={12} sm={12} md={2}>  
                  </GridItem>
                  <GridItem xs={12} sm={12} md={8}>
                    <blockquote className="blockquote">
                   
                    <p> Given are some aluminium sheets having square of side 16 units. We cut the aluminium sheets and construct a circle inscribed in square, and next we construct square inscribed in the previous circle. We cut the aluminium sheets, build a square-inscribed circle, and then build a square-inscribed version of the previous circle. 
                      Continue making squares, circles, squares, circles, and so forth. The area of aluminium sheet diminishes when we create new geometric shapes like circles and squares by cutting sheets. 
                      We are computing the area of the aluminium sheet after cutting it. We have to find the circle or square with area 12.56 square units.
                       Hence, we must find the circle's radius or the square's side with an area of 12.56 square units </p>
                       <p>The main task here is to write an algorithm to find a suitable structure either a radius of circle or side of square with area 12.56 sq. units after extracting circle in square and again square in circle and continue so on from a square of side 16 units. </p>
                      <img alt='circleInSquare' className="card-img-top"  src={baseUrl+'assets/images/circleInSquare.PNG'} />

                      <p><b>Input: </b> side=16 units, requiredArea=12.56 </p>
                      <p><b>Output: </b> circle of radius 2 units</p>
                      <b>Objective: </b> Write an algorithm to calculate side of square/radius of circle with area 12.56 sq. units after inscribing circle in square and square in circle continuously from a square of side 16 units. 
                      <p><b> Decomposition: </b> 
                      Radius of circle inside square=8, Side of square inside previous circle=8*√2.</p> 
                      <p><b> Pattern recognition: </b>
                      Given side of square: 16, Radius of circle in square=8=16/2, Side of square in circle=8*√2=16/√2 </p> 
                      <p><b> Abstraction: </b>
                      Given a square of side=16, Radius of circle in square=side/2,Side of square in circle=side/√2.</p>  
                      <p><b> Algorithm design: </b></p>
                      Given functions SquareArea(side) ==={'>'} side*side   CircleArea(radius)==={'>'} 3.14*radius*radius   SquarePerimeter(side)==={'>'} 4*side, CirclePerimeter(radius) ==={'>'} 2*3.14*radius
                      {algoNewToText('input side=16,requiredArea=12.56;define variable area; Area (length) ===> {check if(SquareArea(length)===requiredArea){square with side length unit} check if(CircleArea(length/2)==requiredArea){circle with radius length/2 } Area(length/root(2))}, set area to Area(side); output, area')}
                        <b> Analysis of the algorithm: </b> 
                        <p> Number of operations: 15</p> <p> Number of variables: 3</p>
                    </blockquote>
                     
                  </GridItem>
                                        
                </GridContainer>
                )
                
              },
              {
                tabName: "Helpful concepts",
                tabIcon: AssignmentReturnIcon,
                tabContent: (
                <GridContainer>


                  <GridItem xs={12} sm={12} md={12}>
                    <blockquote className="blockquote">
                      <h3 align="center"><b>Important concepts</b></h3>
                      <img alt='ifelseHelp' className="card-img-top"  src={baseUrl+'assets/images/ifelseHelp.PNG'} />
                      <img alt='funcHelp' className="card-img-top"  src={baseUrl+'assets/images/forHelp.PNG'} />
                      <img alt='funcHelp' className="card-img-top"  src={baseUrl+'assets/images/functionHelp.PNG'} />
                      <img alt='algoHelp' className="card-img-top"  src={baseUrl+'assets/images/algoHelp.PNG'} />
                      <img alt='analysisHelp' className="card-img-top"  src={baseUrl+'assets/images/analysisHelp.PNG'} />

                    </blockquote>
                  </GridItem>                      
                </GridContainer>
                )
                
              },
              {
                tabName: "Computational Thinking Steps",
                tabIcon: SettingsApplicationIcon,
                tabContent: (
          

                  <Formik
                    initialValues={{
                    hypothesis: '',
                    }}


                    onSubmit={(values, {setSubmitting}) => {
                     setTimeout(() => {
                        setSubmitting(false);
                   
                    alert(JSON.stringify('Saving...', null, 2));

                        var decompos=''
                       
                        var n=''
                        disjumps.map((value, index)=>{ 
                          var k= index+1                         
                          n=n+'Step'+k+'-Move disk from,'+value.source+',to,'+value.destination+':'+value.rod1.toString()+':'+value.rod2.toString()+':'+value.rod3.toString()+':'+value.completed+';'
                        })
                        
                        decompos ='Total steps='+n
                        seterror('')
                        mydata.decomposition[0].userText=decompos
                        arrStore.map((val, index)=>{
                          mydata.decomposition[0].enteredSolution.push(val)
                        })
                        const data=
                        {
                          act: 'activity5',
                          decomposition: mydata.decomposition
                        }                     
                        console.log(data)

                      axios.put(`${baseUrl}pyinterpreter/profile/${sesId}`, data)
                      .then((response) => {
                          console.log(response.data)
                          const activity = response.data.activity5[0]
                          setmydata(activity)
           settotaldata(response.data)
                          setarrStore([])
                      })
                     }, 500);
                    }}
                >

          {({submitForm, isSubmitting, touched, errors}) => (
          <Form>
          {loading!==true?

            <GridContainer>
                          
{/**''''''''''''''''''''''''''''''''Code for Hints''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''''*/}

            

{hintsActivity1.map((text, index)=>(
              index===activeStep?
              myModalTwo && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal1}
                    variants={modal} 
                    >
                     
                      <GridContainer>
                      <GridItem xs={12} sm={12} md={3}>
                         <img alt='Marine Life' width="60" height="150" className="card-img-top" src={baseUrl+'assets/images/pandaPic3.jpg'} />
                      </GridItem>
                      <GridItem xs={12} sm={12} md={9}>
                        <GridContainer>
                        <motion.div style={classes.modal1}>
                          <h5 style={ansType.includes('Correct Answer')==true?{color:'green'}:{color:'red'}}> {ansType} </h5>
                          {altHint!=''?<subtitle1> AlternateHint: {altHint} </subtitle1>:null}
                          <h5 style={classes.fontMonaco}> Current Step: {hintsActivity1[index].step} 
                          {activeStep === 0?mydata.decomposition[0].proceed===true && mydata.decomposition[0].completed===false?' (Submitted)':'':
                          activeStep === 1?mydata.pattern[0].proceed===true && mydata.pattern[0].completed===false?' (Submitted)':'':
                          activeStep === 2?mydata.abstraction[0].proceed===true && mydata.abstraction[0].completed===false?' (Submitted)':'':
                          activeStep === 3?mydata.algorithm[0].proceed===true && mydata.algorithm[0].completed===false?' (Submitted)':'':
                          mydata.analysis[0].proceed===true && mydata.analysis[0].completed===false?' (Submitted)':''}

                          {activeStep === 0?mydata.decomposition[0].completed===true?' (Completed)':'':
                          activeStep === 1?mydata.pattern[0].completed===true?' (Completed)':'':
                          activeStep === 2?mydata.abstraction[0].completed===true?' (Completed)':'':
                          activeStep === 3?mydata.algorithm[0].completed===true?' (Completed)':'':
                          activeStep === 4?mydata.analysis[0].completed===true?' (Completed)':'':null} </h5>
                          {mydata.analysis[0].completed===false?<h5 style={classes.fontGaramond}> Your Task: {task[activeStep]}</h5>:null}
                          
                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.decomposition[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && (index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='experiment' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b>  {mydata.decomposition[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced') || (mydata.altStep==='decomposition' && index===0 && mydata.decomposition[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b>  {mydata.decomposition[0].hints[0].advanced}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b>  {mydata.pattern[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && (index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && (index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='experiment' && mydata.pattern[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.pattern[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && index===1 && mydata.pattern[0].levelOfHints==='Advanced') || (mydata.altStep==='pattern' && index===1 && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.pattern[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}>Basic Hint:</b> {mydata.abstraction[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced') || (mydata.altStep==='abstraction' && activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='experiment' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint:</b>  {mydata.abstraction[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep===''  && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && activeStep===2 && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.abstraction[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.algorithm[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='experiment' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.algorithm[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep===''  && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && activeStep===3 && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.algorithm[0].hints[0].advanced}           
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='experiment' && mydata.analysis[0].noOfattempts>1 && activeStep===4 && mydata.analysis[0].levelOfHints==='Basic' || activeStep===4 && totaldata.type=='experiment' &&  mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Basic Hint: </b> {mydata.analysis[0].hints[0].basic}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='experiment' && activeStep===4 && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='experiment' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Intermediate Hint: </b> {mydata.analysis[0].hints[0].intermediate}           
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && activeStep===4 && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> Advanced Hint: </b> {mydata.analysis[0].hints[0].advanced}           
                            </GridItem>
                          :null}
                          {/*//////////////////////////// belowfor control hint */}

                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced')) || (mydata.altStep==='decomposition' && mydata.decomposition[0].noOfattempts>1 && (index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Basic' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Intermediate' || index===0 && totaldata.type=='control' && mydata.decomposition[0].levelOfHints==='Advanced'))? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.decomposition[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && (mydata.pattern[0].noOfattempts>1 && index===1 && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced'))|| (mydata.altStep==='pattern' && mydata.pattern[0].noOfattempts>1 && index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Basic' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Intermediate' || index===1 && totaldata.type=='control' && mydata.pattern[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b>  {mydata.pattern[0].hints[0].general}          
                            </GridItem>
                          :null}

                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced')|| (mydata.altStep==='abstraction' && totaldata.type=='control' && mydata.abstraction[0].noOfattempts>1 &&activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Basic' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Intermediate' || activeStep===2 && totaldata.type=='control' && mydata.abstraction[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}>General Hint:</b> {mydata.abstraction[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced') || (mydata.altStep==='algorithm' && mydata.algorithm[0].noOfattempts>1 && activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Basic' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Intermediate' || activeStep===3 && totaldata.type=='control' && mydata.algorithm[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.algorithm[0].hints[0].general}          
                            </GridItem>
                          :null}
                          {(mydata.altStep==='' && totaldata.type=='control' && mydata.analysis[0].noOfattempts>1 && activeStep===4 && mydata.analysis[0].levelOfHints==='Basic' || activeStep===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Intermediate' || activeStep===4 && totaldata.type=='control' && mydata.analysis[0].levelOfHints==='Advanced')? 
                            <GridItem xs={12} sm={12} md={12}>
                            <b style={classes.fontGaramond}> General Hint: </b> {mydata.analysis[0].hints[0].general}          
                            </GridItem>
                          :null}

                          {/*///////////////////////////////// above for control hint */}
                          
                          {activeStep===5 && mydata.analysis[0].completed===false? 
                            <GridItem xs={12} sm={12} md={12}>
                              <b style={classes.fontGaramond}> Your solution takes {mydata.analysis[0].hints[0].basic}</b>            
                            </GridItem>
                          :null}
                          {activeStep===6 ? 
                            <GridItem xs={12} sm={12} md={12}>
                                  {['1'].map((text,index)=>{
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                        len=mydata.decomposition[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.pattern[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.abstraction[0].alternateSolution.length
                                      }
                                    if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                        len=len+mydata.algorithm[0].alternateSolution.length
                                      }
                                      return(
                                        <>
                                        <b style={classes.fontGaramond}>So you have implemented {len+1} solution, but there are other {mydata.comparison[0].alternateSolution.length} possible solutions.</b>
                                          <b style={classes.fontGaramond}> Observe the solutions and compare them </b> 
                                        </>
                                      )
                                  })}           
                            </GridItem>
                          :null}
                          </motion.div>
                        </GridContainer>
                          
                      </GridItem>
                         
                    </GridContainer>
                          <Button color="success" variant="contained" onClick={closeModalTwo} 
                            title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                              OK
                          </Button>
                    </motion.div>
                     
                </motion.div>
              </AnimatePresence>)
              :null
            ))
            }

              {myModalThree && (
              <AnimatePresence exitBeforeEnter>
                <motion.div style={classes.backdrop}
                variants={backdrop}
                initial="hidden"
                animate="visible"
                exit={{  zIndex: 0,
                  x: -1000,
                  opacity:0,
                }}
               
                >
                  <motion.div style={classes.modal2}
                    variants={modal} 
                    >
                     <GridContainer>
                     {setisSubmit(true)}
                        <GridItem xs={12} sm={12} md={3}>
                          <img alt='Marine Life' width="40" height="100" className="card-img-top" src={baseUrl+'assets/images/pandaPic2.PNG'} />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={9}>
                          <motion.div style={classes.modal2}>
                            <h4 style={classes.fontGaramond}> Are you sure you want to submit </h4>
                            <Button color="success" variant="contained" onClick={closeModalYesThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                Yes
                            </Button>
                            <Button color="success" variant="contained" onClick={closeModalNoThree} 
                              title="Click here to  proceed" sx={{ fontSize: '10px' }} >
                                No
                            </Button>
                          </motion.div>
                        </GridItem>
                      </GridContainer>
                    </motion.div>  
                </motion.div>
              </AnimatePresence>)}
    
            <GridItem xs={12} sm={12} md={12}>
                <GridContainer>

                  <GridItem xs={12} sm={12} md={12}>
                    <h5 style={{...classes.fontCourier, ...{color:'blue'}}}><b>Important Instructions:</b> Read question for each step. Select the text/number below to complete the statement/equation and then click on the submit button. For any help click support button to contact your teacher</h5>
                    <Stepper activeStep={activeStep} alternativeLabel sx={{backgroundColor:'#e0e2ff'}}>

                      {steps.map((step, index) => {
                
                    return (
                      <Step key={index}>
                        <StepLabel><h5 style={classes.fontLucida}>{step}</h5></StepLabel>
                      </Step>
                      );
                      })}
                    </Stepper>
                  </GridItem>
                
                  <GridItem xs={12} sm={12} md={12}>
                    <GridContainer>
                      {activeStep=='0' ?   //////Decomposition
                      <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={8}>
                            <Card>
                              <CardHeader color="success">
                                  <h5 style={classes.cardTitleWhite}> {task[0]} </h5>
                              </CardHeader>
                              <p><i>{ansType}</i></p>

                              <CardBody>
                              <GridContainer>

                                              <GridItem xs={12} sm={12} md={7}>
                                                <h3>Start from Initial Position</h3>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={5}>
                                                <GridContainer>
                                                  <GridItem xs={12} sm={12} md={4}>
                                                    <img alt='th12' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th12.PNG'} />
                                                  </GridItem>
                                                  <GridItem xs={12} sm={12} md={4}>
                                                    <img alt='th0' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th0.PNG'} />
                                                  </GridItem>
                                                  <GridItem xs={12} sm={12} md={4}>
                                                    <img alt='th0' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th0.PNG'} />
                                                  </GridItem>
                                                </GridContainer>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={12}>
                                                      
                                                  {disjumps.map((value,index)=>{
                                                  var k = 0;
                                                  var stepCount=0;
                                                  for(k=0;k<disjumps.length;k++){
                                                    if(disjumps[k].completed==true){
                                                      stepCount++;
                                                    }
                                                  }
                                                  if(index<=stepCount){
                                                    return(
                                                      <h1>
                                                      <GridContainer>
                                                          <GridItem xs={12} sm={12} md={7}>
                                                            <Field
                                                              component={TextField}
                                                              type="text"
                                                              name="std"
                                                              //label="1st num"
                                                              value={`Step${index+1}:Move disk from`}
                                                              select
                                                              variant="standard"
                                                              //helperText="select"
                                                              //style = {{width: 60}}
                                                              margin="normal"
                                                              InputLabelProps={{
                                                                  shrink: true,
                                                              }}
                                                              >
                                                              {[{label:`Step${index+1}:Move disk from`,value:`Step${index+1}:Move disk from`}].map((option) => (
                                                                  <MenuItem key={option.value} value={option.value}>
                                                                  {option.label}
                                                                  </MenuItem>
                                                              ))}
                                                            </Field>
                                                            
                                                            {value.completed==false?
                                                            <Field
                                                              component={TextField}
                                                              type="text"
                                                              name="std"
                                                              //label=""
                                                              value={value.source}
                                                              //disabled={true}
                                                              onChange={e=>handleDisNum2Change(e,index)}
                                                              select
                                                              variant="standard"
                                                              helperText="select"
                                                              //style = {{width: 30}}
                                                              margin="normal"
                                                              InputLabelProps={{
                                                                  shrink: true,
                                                              }}
                                                              >
                                                              {dissour.map((option) => (
                                                                  <MenuItem key={option.value} value={option.value}>
                                                                  {option.label}
                                                                  </MenuItem>
                                                              ))}
                                                            </Field>:
                                                             <Field
                                                             component={TextField}
                                                             type="text"
                                                             name="std"
                                                             //label=""
                                                             value={value.source}
                                                             disabled={true}
                                                             //onChange={e=>handleNum2Change(e,index)}
                                                             select
                                                             variant="standard"
                                                             //helperText="select"
                                                             //style = {{width: 30}}
                                                             margin="normal"
                                                             InputLabelProps={{
                                                                 shrink: true,
                                                             }}
                                                             >
                                                             {[{label:value.source,value:value.source}].map((option) => (
                                                                 <MenuItem key={option.value} value={option.value}>
                                                                 {option.label}
                                                                 </MenuItem>
                                                             ))}
                                                           </Field>
                                                            }

                                                            <Field
                                                              component={TextField}
                                                              type="text"
                                                              name="std"
                                                              //label="1st num"
                                                              value='to'
                                                              select
                                                              variant="standard"
                                                              //helperText="select"
                                                              //style = {{width: 60}}
                                                              margin="normal"
                                                              InputLabelProps={{
                                                                  shrink: true,
                                                              }}
                                                              >
                                                              {[{label:'to',value:'to'}].map((option) => (
                                                                  <MenuItem key={option.value} value={option.value}>
                                                                  {option.label}
                                                                  </MenuItem>
                                                              ))}
                                                            </Field>
                                                            {value.completed==false?

                                                            <Field
                                                              component={TextField}
                                                              type="text"
                                                              name="std"
                                                              //label="Number"
                                                              value={value.destination}
                                                              onChange={e=>handleDisNum3Change(e,index)}
                                                              select
                                                              variant="standard"
                                                              helperText="select"
                                                              //style = {{width: 60}}
                                                              margin="normal"
                                                              InputLabelProps={{
                                                                  shrink: true,
                                                              }}
                                                              >
                                                              {disdest.map((option) => (
                                                                  <MenuItem key={option.value} value={option.value}>
                                                                  {option.label}
                                                                  </MenuItem>
                                                              ))}
                                                            </Field>:
                                                            <Field
                                                              component={TextField}
                                                              type="text"
                                                              name="std"
                                                              //label="Number"
                                                              value={value.destination}
                                                              //onChange={e=>handleNum3Change(e,index)}
                                                              select
                                                              disabled={true}
                                                              variant="standard"
                                                              //helperText="select"
                                                              //style = {{width: 60}}
                                                              margin="normal"
                                                              InputLabelProps={{
                                                                  shrink: true,
                                                              }}
                                                              >
                                                              {[{label:value.destination,value:value.destination}].map((option) => (
                                                                  <MenuItem key={option.value} value={option.value}>
                                                                  {option.label}
                                                                  </MenuItem>
                                                              ))}
                                                            </Field>
                                                            }
                                                            {value.completed==false?
                                                              <Button
                                                                size="small"
                                                                color="primary"
                                                                variant="contained"
                                                                onClick={e=>SelectDisJump(index)}
                                                              >
                                                                Done
                                                              </Button>:
                                                              <Button
                                                                size="small"
                                                                color="primary"
                                                                variant="contained"
                                                                onClick={e=>DeleteDisJump(index)}
                                                              >
                                                                Delete
                                                              </Button>}
                                                      </GridItem>
                                                      
                                                      {value.completed==true?
                                                      <GridItem xs={12} sm={12} md={5}>
                                                        <GridContainer>
                                                          <GridItem xs={12} sm={12} md={4}>
                                                            {textToDisk(value.rod1)}
                                                          </GridItem>
                                                          <GridItem xs={12} sm={12} md={4}>
                                                            {textToDisk(value.rod2)}
                                                          </GridItem>
                                                          <GridItem xs={12} sm={12} md={4}>
                                                            {textToDisk(value.rod3)}
                                                          </GridItem>
                                                        </GridContainer>
                                                      
                                                      </GridItem>:null}
                                                  </GridContainer>
                                                  </h1>
                                                )}
                                              })}
                                          </GridItem> 
                                            
                    
                              </GridContainer>
                              </CardBody>
                            </Card>
                            {isSubmitting && <LinearProgress />}
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                   disabled={isSubmitting}
                                  onClick={submitForm}
                                >
                                  Save
                                </Button>
                              </GridItem> 
                            </GridItem>
                            <GridItem xs={12} sm={12} md={4}>
                              <GridContainer>
                                <GridItem xs={12} sm={12} md={12}>
                                  <Card sx={{border: "1px solid black"}}>
                                    <CardHeader color="primary">
                                      <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                    </CardHeader>
                                    <CardBody>
                                      <b>Start from Initial Position   </b>
                                      {disjumps.map((value, index)=>{ 
                                        var k= index+1                         
                                        var n = 'Step'+k+' Move disk from '+value.source+' to '+value.destination+''
                                        
                                        if(value.completed==true){
                                        return (
                                        <div>
                                          {n}
                                        </div>)
                                        }
                                        
                                      })}
                                    
                                    </CardBody>
                                    {[0].map((value, index)=>{
                                        var n=''
                                        var ans =''                         
                                        disjumps.map((value, index)=>{ 
                                            var k= index+1
                                            n=n+'Step'+k+'-Move disk from,'+value.source+',to,'+value.destination+':'+value.rod1.toString()+':'+value.rod2.toString()+':'+value.rod3.toString()+':'+value.completed+';'
                                            if(value.rod3.toString()==='0,1,2'){
                                              ans='found'
                                            }
                                          })
                                      solutionEnter('activity5', 'decomposition','Total steps: '+n)
                                    })}
                                  </Card>
                                </GridItem>
                                
                                {(mydata.decomposition[0].noOfattempts>1 && mydata.decomposition[0].proceed===false)||(mydata.altStep!="" && mydata.decomposition[0].proceed===false)?
                                  <GridItem xs={12} sm={12} md={12}>
                                    <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                          onClick={ToggleHint}>    
                                          <AssistantIcon sx={{ mr: 1 }} />
                                          Hints
                                    </Fab>
                                    {loadhint === true?loading !== true?
                                      hintGenerate()
                                    :null:null}
                                  </GridItem>
                                :null}
                                
                              </GridContainer>
                            </GridItem>
                        </GridContainer>
                      </GridItem>
                          :activeStep=='1' ?    ///Pattern Recognition
                                        
                      <GridItem xs={12} sm={12} md={12}>
                        <GridContainer>
                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                  
                                      <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>                                    
                                      
                                       <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>       
                                </GridItem>
                                    
                                <GridItem xs={12} sm={12} md={8}>
                                  <Card>
                                    <CardHeader color="success">
                                      <h5 style={classes.cardTitleWhite}>{task[1]} </h5>
                                    </CardHeader>
                                    <p><i>{ansType}</i></p>

                                    <CardBody>
                                      <GridContainer>
                                       
                                        <h5>Observe the statements in previous step and identify the movement of 2 disks between rod1,rod2, and rod3.</h5>
                 
                                        <GridItem xs={12} sm={12} md={12}>
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="1st num"
                                                  value='Observe that (2-1) disk is moved from'
                                                  //onChange={handleNum1Change}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'Observe that (2-1) disk is moved from',value:'Observe that (2-1) disk is moved from'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label="1st num"
                                                value={patnum1}
                                                onChange={handlePatnum1Change}
                                                select
                                                variant="standard"
                                                helperText="rod1"
                                                //style = {{width: 60}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="1st num"
                                                  value='to'
                                                  //onChange={handleNum1Change}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'to',value:'to'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              
                                              <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                //label=""
                                                value={patnum2}
                                                //disabled={true}
                                                onChange={handlePatnum2Change}
                                                select
                                                variant="standard"
                                                helperText="rod2"
                                                //style = {{width: 30}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                              <div>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="1st num"
                                                  value='Next, the disk is moved from'
                                                  //onChange={handleNum1Change}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'Next, the disk is moved from',value:'Next, the disk is moved from'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="1st num"
                                                  value={patnum3}
                                                  onChange={handlePatnum3Change}
                                                  select
                                                  variant="standard"
                                                  helperText="rod1"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                              
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="1st num"
                                                  value='to'
                                                  //onChange={handleNum1Change}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'to',value:'to'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                              
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label=""
                                                  value={patnum4}
                                                  //disabled={true}
                                                  onChange={handlePatnum4Change}
                                                  select
                                                  variant="standard"
                                                  helperText="rod3"
                                                  //style = {{width: 30}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field> 
                                              </div>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="1st num"
                                                  value='Finally, move the disk from rod2 to'
                                                  //onChange={handleNum1Change}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'Finally, move the disk from rod2 to',value:'Finally, move the disk from rod2 to'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="1st num"
                                                  value={patnum5}
                                                  onChange={handlePatnum5Change}
                                                  select
                                                  variant="standard"
                                                  helperText="select"
                                                  //style = {{width: 60}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>   
                                        </GridItem>
                                          {error}
                                      </GridContainer>
                                    </CardBody>
                                  </Card> 
                                    <GridItem xs={12} sm={12} md={6}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                             disabled={isSubmit}
                                            onClick={submitPatternForm}
                                          >
                                            Save
                                          </Button>
                                    </GridItem> 
                                </GridItem>
                                <GridItem xs={12} sm={12} md={4}>
                                  <GridContainer>
                                    <GridItem xs={12} sm={12} md={12}>
                                      <Card sx={{border: "1px solid black"}}>
                                        <CardHeader color="primary">
                                          <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                        </CardHeader>
                                        <CardBody>
                                          
                                          {mydata.decomposition[0].completed===true?'Observe that (2-1) disk is moved from '+patnum1+' to '+patnum2+''
                                          :null} 
                                          <div>{mydata.decomposition[0].completed===true?'Next, the disk is moved from '+patnum3+' to '+patnum4
                                          :null}</div>
                                          {mydata.decomposition[0].completed===true?'Finally, move the disk from rod2 to '+patnum5:null}                                   
                                        </CardBody>
                                        {solutionEnter('activity5', 'pattern','Observe that (2-1) disk is moved from ,'+patnum1+', to ,'+patnum2+', Next the disk is moved from,'+patnum3+', to ,'+patnum4+', Finally, move the disk from rod2 to ,'+patnum5)}

                                      </Card>
                                    </GridItem>
                                    
                                    {(mydata.pattern[0].noOfattempts>1 && mydata.pattern[0].proceed===false)||(mydata.altStep!="" && mydata.pattern[0].proceed===false)?
                                    <GridItem xs={12} sm={12} md={12}>
                                    <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                          onClick={ToggleHint}>    
                                          <AssistantIcon sx={{ mr: 1 }} />
                                          Hints
                                    </Fab>
                                        {loadhint === true?loading !== true?
                                          hintGenerate()
                                      :null:null}
                                    </GridItem>:null}
                                  </GridContainer>
                                </GridItem>
                              </GridContainer>
                            </GridItem>
                            
                        </GridContainer>
                      </GridItem>

                          :activeStep=='2' ? 

                          
                            <GridItem xs={12} sm={12} md={12}>
                              <GridContainer>
                              <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={12}>
                                   <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>
                                    
                                    <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>
                                  </GridItem>
                                  
                                  
                                  <GridItem xs={12} sm={12} md={12}>
                                   <p id="simple-modal-description" align="center"style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                    
                                    <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                                    
                              <GridItem xs={12} sm={12} md={8}>

                              <Card>
                                <CardHeader color="success">
                                    <h4 style={classes.cardTitleWhite}> {task[2]}</h4>
                                </CardHeader>
                                <p><i>{ansType}</i></p>

                                <CardBody>
                                <GridContainer>
                                 
                                  <GridItem xs={12} sm={12} md={12}>
                                    <h5>General method to move n disks from first rod to third rod</h5>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={12}>  
                                    
                                    {activeStep===2 && mydata.pattern[0].completed===true?  
                                            <div>
                                           
                                              <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value='Start with initial position'
                                                  //onChange={handleAbsChange1}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  //disabled={true}
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'Start with initial position',value:'Start with initial position'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                              </Field>
                                              <div>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='Move (n-1) disks from'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'Move (n-1) disks from',value:'Move (n-1) disks from'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs1}
                                                    onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    helperText="rod1"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='to'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'to',value:'to'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                              
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={abs2}
                                                    onChange={handleAbsChange2}
                                                    select
                                                    variant="standard"
                                                    helperText="rod2"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                              </div>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value='Move last disk from'
                                                  //onChange={handleAbsChange1}
                                                  select
                                                  variant="standard"
                                                  //helperText=""
                                                  //disabled={true}
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'Move last disk from',value:'Move last disk from'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                            
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value={abs3}
                                                  onChange={handleAbsChange3}
                                                  select
                                                  variant="standard"
                                                  helperText="rod1"
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value='to'
                                                  //onChange={handleAbsChange1}
                                                  select
                                                  variant="standard"
                                                  //helperText="select"
                                                  //disabled={true}
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'to',value:'to'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value={abs4}
                                                  onChange={handleAbsChange4}
                                                  select
                                                  variant="standard"
                                                  helperText="select"
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                              <div>
                                                <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='Finally, move (n-1) disks from rod2 to'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'Finally, move (n-1) disks from rod2 to',value:'Finally, move (n-1) disks from rod2 to'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  //label="Number"
                                                  value={abs5}
                                                  onChange={handleAbsChange5}
                                                  select
                                                  variant="standard"
                                                  helperText="select"
                                                  //style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {[{label:'rod1',value:'rod1'},{label:'rod2',value:'rod2'},{label:'rod3',value:'rod3'}].map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                           
                                              </div>
                                              <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value='End with final position'
                                                    //onChange={handleAbsChange1}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //disabled={true}
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {[{label:'End with final position',value:'End with final position'}].map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                </Field>
                                                  
                                              </div>:null}
                                             
                                        </GridItem>
                                        <p>{error}</p>
                                  
                                </GridContainer>
                                </CardBody>
                                {/* {isSubmitting && <LinearProgress />} */}
                              </Card>
                              <GridItem xs={12} sm={12} md={6}>
                                  <Button
                                    variant="contained"
                                    color="primary"
                                     disabled={isSubmit}
                                    onClick={submitAbstractionForm}
                                  >
                                    Save
                                  </Button>
                                </GridItem> 
                              </GridItem>
                              <GridItem xs={12} sm={12} md={4}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={12}>
                                        <Card sx={{border: "1px solid black"}}>
                                          <CardHeader color="primary">
                                            <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                          </CardHeader>
                                          <CardBody>
                                            <b>General method to move n disks from first to third rod</b>
                                            <div>Start with initial position</div>
                                            Move (n-1) disks from {abs1} to {abs2}
                                            <div>Move last disk from {abs3} to {abs4}</div>
                                            <div>Finally, move (n-1) disks from rod2 to {abs5}</div>
                                            End with final position
                                          </CardBody>
                                           {solutionEnter('activity5', 'abstraction','Start with initial position: Move (n-1) disks from ,'+abs1+', to ,'+abs2+', Move last disk from ,'+abs3+', to ,'+abs4+', Finally, move (n-1) disks from rod2 to ,'+abs5+', :End with final position')}
                                        </Card>
                                  </GridItem>
                                  
                                  {(mydata.abstraction[0].noOfattempts>1 && mydata.abstraction[0].proceed===false)||(mydata.altStep!="" && mydata.abstraction[0].proceed===false)?
                                  <GridItem xs={12} sm={12} md={12}>
                                  <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                        onClick={ToggleHint}>    
                                        <AssistantIcon sx={{ mr: 1 }} />
                                        Hints
                                  </Fab>
                                        {loadhint === true?loading !== true?
                                          hintGenerate()
                                      :null:null}
                                  </GridItem>:null}
                                </GridContainer>
                              </GridItem> 
                                
                                </GridContainer>
                              </GridItem>                           
                           

                          :activeStep=='3' ?  ///Algorithm design

                           
                              <GridItem xs={12} sm={12} md={12}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={8} sx={classes.paper}>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align='center' style={classes.ana}> Decomposition ({task[0]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>
                                      </GridItem>
                                      
                                      
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align="center"style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                        <p id="simple-modal-description" align="center"style={classes.ana}> Abstraction ({task[2]}) </p>
                                        
                                        <p id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.abstraction[0].userText)}</p>
                                      </GridItem>
                                      
                                    </GridContainer>
                                  </GridItem>
                                    
                                  
                                    <GridItem xs={12} sm={12} md={8}>
                                      <Card>
                                        <CardHeader color="success">
                                          <h4 style={classes.cardTitleWhite}>{task[3]}</h4>
                                        </CardHeader>
                                        <p><i>{ansType}</i></p>
                                          
                                        <CardBody>
                                        <GridContainer>
                                         
                                        <h2> Steps to convert from initial position </h2> 
                                        {loading!==true?
                                          <GridItem xs={12} sm={12} md={12}>
                                            <div> {error}</div>    
                                           
                                            <GridContainer>
                                              <GridItem xs={12} sm={12} md={12}>
                                                  <h5>Input Statement:</h5> 
                                                  <GridContainer>
                                                    <GridItem xs={12} sm={12} md={2}>
                                                      <Field
                                                        component={TextField}
                                                        type="text"
                                                        name="std"
                                                        //label="Number"
                                                        value="input"
                                                        disabled={true}
                                                        //onChange={handlePatternChange}
                                                        select
                                                        variant="standard"
                                                        //helperText="select"
                                                        //style = {{width: 30}}
                                                        margin="normal"
                                                        InputLabelProps={{
                                                            shrink: true,
                                                        }}
                                                        >
                                                        {textAlgoList.map((option) => (
                                                            <MenuItem key={option.value} value={option.value}>
                                                            {option.label}
                                                            </MenuItem>
                                                        ))}
                                                      </Field>
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={3}>
                                                     rod1: <img alt='th123' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th123.PNG'} />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={3}>
                                                    rod2:<img alt='th0' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th0.PNG'} />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={3}>
                                                    rod3:<img alt='th0' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th0.PNG'} />
                                                    </GridItem>
                                                  </GridContainer>
                                                  
                                              </GridItem>
                                              
                                              <GridItem xs={12} sm={12} md={12}>
                                              <h5>Define variable: </h5> 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value="define"
                                                    disabled={true}
                                                    //onChange={handlePatternChange}
                                                    select
                                                    variant="standard"
                                                    //helperText="select"
                                                    //style = {{width: 30}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {textAlgoList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                 
                                                  <Field
                                                    component={TextField}
                                                    type="text"
                                                    name="std"
                                                    //label="Number"
                                                    value={algo1}
                                                    onChange={handleAlgoChange1}
                                                    select
                                                    variant="standard"
                                                    helperText="final position"
                                                    //style = {{width: 200}}
                                                    margin="normal"
                                                    InputLabelProps={{
                                                        shrink: true,
                                                    }}
                                                    >
                                                    {VarList.map((option) => (
                                                        <MenuItem key={option.value} value={option.value}>
                                                        {option.label}
                                                        </MenuItem>
                                                    ))}
                                                  </Field>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={7}>
                                                  <h2>Start from Initial Position</h2>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={5}>
                                                  <GridContainer>
                                                    <GridItem xs={12} sm={12} md={4}>
                                                      <img alt='th123' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th123.PNG'} />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={4}>
                                                      <img alt='th0' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th0.PNG'} />
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={4}>
                                                      <img alt='th0' className="card-img-top" width="10" height="60" src={baseUrl+'assets/images/th0.PNG'} />
                                                    </GridItem>
                                                  </GridContainer>
                                                </GridItem>
                                               
                                                <GridItem xs={12} sm={12} md={12}>
                                                          
                                                      {algojumps.map((value,index)=>{
                                                      var k = 0;
                                                      var stepCount=0;
                                                      for(k=0;k<algojumps.length;k++){
                                                        if(algojumps[k].completed==true){
                                                          stepCount++;
                                                        }
                                                      }
                                                      if(index<=stepCount){
                                                        return(
                                                          <h1>
                                                          <GridContainer>
                                                              <GridItem xs={12} sm={12} md={7}>
                                                                <Field
                                                                  component={TextField}
                                                                  type="text"
                                                                  name="std"
                                                                  //label="1st num"
                                                                  value={`Step${index+1}:Move disk from`}
                                                                  select
                                                                  variant="standard"
                                                                  //helperText="select"
                                                                  //style = {{width: 60}}
                                                                  margin="normal"
                                                                  InputLabelProps={{
                                                                      shrink: true,
                                                                  }}
                                                                  >
                                                                  {[{label:`Step${index+1}:Move disk from`,value:`Step${index+1}:Move disk from`}].map((option) => (
                                                                      <MenuItem key={option.value} value={option.value}>
                                                                      {option.label}
                                                                      </MenuItem>
                                                                  ))}
                                                                </Field>
                                                               
                                                                
                                                                {value.completed==false?
                                                                <Field
                                                                  component={TextField}
                                                                  type="text"
                                                                  name="std"
                                                                  //label=""
                                                                  value={value.source}
                                                                  //disabled={true}
                                                                  onChange={e=>handleAlgoNum2Change(e,index)}
                                                                  select
                                                                  variant="standard"
                                                                  helperText="select"
                                                                  //style = {{width: 30}}
                                                                  margin="normal"
                                                                  InputLabelProps={{
                                                                      shrink: true,
                                                                  }}
                                                                  >
                                                                  {algosour.map((option) => (
                                                                      <MenuItem key={option.value} value={option.value}>
                                                                      {option.label}
                                                                      </MenuItem>
                                                                  ))}
                                                                </Field>:
                                                                <Field
                                                                component={TextField}
                                                                type="text"
                                                                name="std"
                                                                //label=""
                                                                value={value.source}
                                                                disabled={true}
                                                                //onChange={e=>handleNum2Change(e,index)}
                                                                select
                                                                variant="standard"
                                                                //helperText="select"
                                                                //style = {{width: 30}}
                                                                margin="normal"
                                                                InputLabelProps={{
                                                                    shrink: true,
                                                                }}
                                                                >
                                                                {[{label:value.source,value:value.source}].map((option) => (
                                                                    <MenuItem key={option.value} value={option.value}>
                                                                    {option.label}
                                                                    </MenuItem>
                                                                ))}
                                                              </Field>
                                                                }

                                                                <Field
                                                                  component={TextField}
                                                                  type="text"
                                                                  name="std"
                                                                  //label="1st num"
                                                                  value='to'
                                                                  //onChange={handleNum1Change}
                                                                  select
                                                                  variant="standard"
                                                                  //helperText="select"
                                                                  //style = {{width: 60}}
                                                                  margin="normal"
                                                                  InputLabelProps={{
                                                                      shrink: true,
                                                                  }}
                                                                  >
                                                                  {[{label:'to',value:'to'}].map((option) => (
                                                                      <MenuItem key={option.value} value={option.value}>
                                                                      {option.label}
                                                                      </MenuItem>
                                                                  ))}
                                                                </Field>
                                                                {value.completed==false?

                                                                <Field
                                                                  component={TextField}
                                                                  type="text"
                                                                  name="std"
                                                                  //label="Number"
                                                                  value={value.destination}
                                                                  onChange={e=>handleAlgoNum3Change(e,index)}
                                                                  select
                                                                  variant="standard"
                                                                  helperText="select"
                                                                  //style = {{width: 60}}
                                                                  margin="normal"
                                                                  InputLabelProps={{
                                                                      shrink: true,
                                                                  }}
                                                                  >
                                                                  {algodest.map((option) => (
                                                                      <MenuItem key={option.value} value={option.value}>
                                                                      {option.label}
                                                                      </MenuItem>
                                                                  ))}
                                                                </Field>:
                                                                <Field
                                                                  component={TextField}
                                                                  type="text"
                                                                  name="std"
                                                                  //label="Number"
                                                                  value={value.destination}
                                                                  //onChange={e=>handleNum3Change(e,index)}
                                                                  select
                                                                  disabled={true}
                                                                  variant="standard"
                                                                  //helperText="select"
                                                                  //style = {{width: 60}}
                                                                  margin="normal"
                                                                  InputLabelProps={{
                                                                      shrink: true,
                                                                  }}
                                                                  >
                                                                  {[{label:value.destination,value:value.destination}].map((option) => (
                                                                      <MenuItem key={option.value} value={option.value}>
                                                                      {option.label}
                                                                      </MenuItem>
                                                                  ))}
                                                                </Field>
                                                                }
                                                                {value.completed==false?
                                                                  <Button
                                                                    size="small"
                                                                    color="primary"
                                                                    variant="contained"
                                                                    onClick={e=>SelectAlgoJump(index)}
                                                                  >
                                                                    Done
                                                                  </Button>:
                                                                  <Button
                                                                    size="small"
                                                                    color="primary"
                                                                    variant="contained"
                                                                    onClick={e=>DeleteAlgoJump(index)}
                                                                  >
                                                                    Delete
                                                                  </Button>}
                                                          </GridItem>
                                                          
                                                          {value.completed==true?
                                                          <GridItem xs={12} sm={12} md={5}>
                                                            <GridContainer>
                                                              <GridItem xs={12} sm={12} md={4}>
                                                                {textToDisk(value.rod1)}
                                                              </GridItem>
                                                              <GridItem xs={12} sm={12} md={4}>
                                                                {textToDisk(value.rod2)}
                                                              </GridItem>
                                                              <GridItem xs={12} sm={12} md={4}>
                                                                {textToDisk(value.rod3)}
                                                              </GridItem>
                                                            </GridContainer>
                                                          </GridItem>:null}
                                                      </GridContainer>
                                                      </h1>
                                                    )}
                                                  })}
                                              </GridItem> 
                                              
                                              <GridItem xs={12} sm={12} md={12}>
                                                  <h5>Set variable: </h5> 
                                                <GridContainer>
                                                  <GridItem xs={12} sm={12} md={7}>

                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="set"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo2}
                                                      onChange={handleAlgoChange2}
                                                      select
                                                      variant="standard"
                                                      helperText="final pos"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                    <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="to"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                    </Field>
                                                  </GridItem>
                                                  <GridItem xs={12} sm={12} md={5}>
                                                    {algojumps.map((value,index)=>{
                                                      var k = 0;
                                                      var stepCount=0;
                                                      for(k=0;k<algojumps.length;k++){
                                                        if(algojumps[k].completed==true){
                                                          stepCount++;
                                                        }
                                                      }
                                                    
                                                      if(index==stepCount-1){
                                                        return(
                                                          
                                                            <GridContainer>
                                                              <GridItem xs={12} sm={12} md={4}>
                                                                {textToDisk(value.rod1)}
                                                              </GridItem>
                                                              <GridItem xs={12} sm={12} md={4}>
                                                                {textToDisk(value.rod2)}
                                                              </GridItem>
                                                              <GridItem xs={12} sm={12} md={4}>
                                                                {textToDisk(value.rod3)}
                                                              </GridItem>
                                                            </GridContainer>
                                                        )
                                                      }
                                                    })} 
                                                  </GridItem>
                                                </GridContainer>                                          
                                              </GridItem>
                                              
                                              <GridItem xs={12} sm={12} md={12}>
                                                  <h5>Output: </h5>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value="output"
                                                      disabled={true}
                                                      //onChange={handlePatternChange}
                                                      select
                                                      variant="standard"
                                                      //helperText="select"
                                                      //style = {{width: 30}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {textAlgoList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field>
                                                  <Field
                                                      component={TextField}
                                                      type="text"
                                                      name="std"
                                                      //label="Number"
                                                      value={algo3}
                                                      onChange={handleAlgoChange3}
                                                      select
                                                      variant="standard"
                                                      helperText="select"
                                                      //style = {{width: 200}}
                                                      margin="normal"
                                                      InputLabelProps={{
                                                          shrink: true,
                                                      }}
                                                      >
                                                      {VarList.map((option) => (
                                                          <MenuItem key={option.value} value={option.value}>
                                                          {option.label}
                                                          </MenuItem>
                                                      ))}
                                                  </Field> 
                                                  {AlgoSpecificPairCalculate()}
    
                                              </GridItem>
                                              {error}
                                          </GridContainer>
                                          </GridItem>:null}
                                        </GridContainer>
                                        </CardBody>
                                        <GridItem xs={12} sm={12} md={6}>
                                          <Button
                                            variant="contained"
                                            color="primary"
                                             disabled={isSubmit}
                                            onClick={submitAlgorithmForm}
                                          >
                                            Save
                                          </Button>
                                        </GridItem>
                                      </Card>
                                    </GridItem>
                                    <GridItem xs={12} sm={12} md={4}>
                                      <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <Card sx={{border: "1px solid black"}}>
                                            <CardHeader color="primary">
                                              <h5 style={classes.cardTitleWhite}> Entered solution </h5>
                                            </CardHeader>
                                            <CardBody>
                                              <GridContainer>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <b>Input statement:</b>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                    input 
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                <b>Define variable:</b>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12} >
                                                    define {algo1}
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                <b>Set variable:</b>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12} >
                                                <b>Start from Initial Position   </b>
                                                  {algojumps.map((value, index)=>{ 
                                                    var k= index+1                         
                                                    var n = 'Step'+k+' Move disk from '+value.source+' to '+value.destination+''
                                                    
                                                    if(value.completed==true){
                                                    return (
                                                    <div>
                                                      {n}
                                                    </div>)
                                                    }
                                                    
                                                  })}
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12} >
                                                  set {algo2} to 
                                                  {algojumps.map((value,index)=>{
                                                      var k = 0;
                                                      var stepCount=0;
                                                      for(k=0;k<algojumps.length;k++){
                                                        if(algojumps[k].completed==true){
                                                          stepCount++;
                                                        }
                                                      }
                                                      
                                                      console.log(index)
                                                      if(index==stepCount-1){
                                                        return(
                                                          
                                                            <>
                                                              
                                                            </>
                                                        )
                                                      }
                                                    })} 
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12}>
                                                  <b>Output:</b>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={12} >
                                                    {algo3}
                                                </GridItem>
                                              </GridContainer>
                                            </CardBody>
                                            {[0].map((value, index)=>{
                                               var ans=''                                            
                                               var n=''
                                               var fstep=''
                                               var finalStep='' 
                                               var count=0
                                               algojumps.map((value, index)=>{ 
                                                                 
                                                     fstep = value.rod3.toString()
                                                     var k= index+1
                                                     n=n+'Step'+k+'-Move disk from,'+value.source+',to,'+value.destination+':'+value.rod1.toString()+':'+value.rod2.toString()+':'+value.rod3.toString()+':'+value.completed+'~'
                                                     if(value.rod3.toString()==='1,2,3'){
                                                       ans='found'
                                                     }
                                                     if(value.completed==true){
                                                       count++
                                                       finalStep=value.rod3.toString()             
                                                     }
                                                   })
                                              solutionEnter('activity5', 'algorithm','Total steps: '+n)
                                            })}

                                          </Card>
                                        </GridItem>
                                        
                                        {(mydata.algorithm[0].noOfattempts>1 && mydata.algorithm[0].proceed===false)||(mydata.altStep!="" && mydata.algorithm[0].proceed===false)?
                                        <GridItem xs={12} sm={12} md={12}>
                                        <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                              onClick={ToggleHint}>    
                                              <AssistantIcon sx={{ mr: 1 }} />
                                              Hints
                                        </Fab>
                                            {loadhint === true?loading !== true?
                                              hintGenerate()
                                          :null:null}
                                        </GridItem>:null}
                                      </GridContainer>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                            

                          :activeStep=='4' ?    ////Analysis of algorithm
                           
                              <GridItem xs={12} sm={12} md={12}>
                                <GridContainer>
                                  <GridItem xs={12} sm={12} md={9} sx={classes.paper}>
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align="center" style={classes.ana}> Decomposition ({task[0]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>
                                      </GridItem>
                                      
                                      
                                      <GridItem xs={12} sm={12} md={12}>
                                       <p id="simple-modal-description" align="center" style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                        
                                        <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                        <p id="simple-modal-description" align="center" style={classes.ana}> Abstraction ({task[2]}) </p>
                                        
                                        <p id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.abstraction[0].userText)}</p>
                                      </GridItem>
                                      <GridItem xs={12} sm={12} md={12}>
                                          <p id="simple-modal-description" align="center" style={classes.ana}> Algorithm ({task[3]}) </p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={2}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>
                                            {algoStepToText(mydata.algorithm[0].userText)}
                                        </GridItem>
                                    </GridContainer>
                                  </GridItem>
                                  <GridItem xs={12} sm={12} md={8}>
                                    <Card>
                                      <CardHeader color="success">
                                        <h4 style={classes.cardTitleWhite}>{task[4]} </h4>

                                      </CardHeader>
                                      <CardBody>
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                            <GridContainer>
                                              <GridItem xs={12} sm={12} md={5}>
                                                <h5>Enter the total number of steps/operations: </h5>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={7}>
                                                {loading!==true?
                                                <Field
                                                component={TextField}
                                                type="text"
                                                name="std"
                                                label="No. of operations"
                                                value={mytime}
                                                onChange={handleTimeChange}
                                                select
                                                variant="standard"
                                                helperText="select"
                                                style = {{width: 200}}
                                                margin="normal"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                >
                                                {numList.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                    {option.label}
                                                    </MenuItem>
                                                ))}
                                              </Field>
                                                  :null}
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={5}>
                                                <h5>Enter the total number of defined variables: </h5>
                                              </GridItem>
                                              <GridItem xs={12} sm={12} md={7}>
                                                {loading!==true?
                          
                                                <Field
                                                  component={TextField}
                                                  type="text"
                                                  name="std"
                                                  label="No. of variables"
                                                  value={myspace}
                                                  onChange={handleSpaceChange}
                                                  select
                                                  variant="standard"
                                                  helperText="select"
                                                  style = {{width: 200}}
                                                  margin="normal"
                                                  InputLabelProps={{
                                                      shrink: true,
                                                  }}
                                                  >
                                                  {numList.map((option) => (
                                                      <MenuItem key={option.value} value={option.value}>
                                                      {option.label}
                                                      </MenuItem>
                                                  ))}
                                                </Field>
                                                  :null}
                                              </GridItem>
                                              {error}
                                            </GridContainer>
                                          </GridItem>
                                        </GridContainer>
                                      </CardBody>
                                    </Card>
                                      <GridItem xs={12} sm={12} md={6}>
                                        <Button
                                          variant="contained"
                                          color="primary"
                                           disabled={isSubmit}
                                          onClick={submitAnalysisForm}
                                        >
                                          Save
                                        </Button>
                                    </GridItem>
                                  </GridItem>
                                  {solutionEnter('activity5', 'analysis','No. of operations '+mytime+';No. of variables '+myspace)}
                                  <GridItem xs={12} sm={12} md={4}>
                                      <GridContainer>
                                        
                                        {(mydata.analysis[0].noOfattempts>1 && mydata.analysis[0].proceed===false)||(mydata.altStep!="" && mydata.analysis[0].proceed===false)?
                                        <GridItem xs={12} sm={12} md={12}>
                                        <Fab  variant="extended" color="secondary" aria-label="add" size="small" component="span" 
                                              onClick={ToggleHint}>    
                                              <AssistantIcon sx={{ mr: 1 }} />
                                              Hints
                                        </Fab>
                                            {loadhint === true?loading !== true?
                                              hintGenerate()
                                          :null:null}
                                        </GridItem>:null}
                                      </GridContainer>
                                  </GridItem>
                                  
                                </GridContainer>
                              </GridItem>
                            

                          :activeStep=='5' ? 

                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                              <Card>
                                <CardHeader color="success">
                                  <h4 style={classes.cardTitleWhite}> Your Solution </h4>
                                </CardHeader>
                                <p><i>{ansType}</i></p>
                                <CardBody>
                                <GridContainer>
                                  {loading!==true?
                                  <GridItem xs={12} sm={12} md={12} sx={classes.paper}>
                                    
                                    <GridContainer>
                                      <GridItem xs={12} sm={12} md={12}>
                                         <p id="simple-modal-description" align="center" style={classes.ana}> Decomposition ({task[0]}) </p>
                                          
                                          <div id="simple-modal-description" align='center'><b>Answer:</b>{mydata.decomposition[0].userText}</div>
                                        </GridItem>
                                        
                                        
                                        <GridItem xs={12} sm={12} md={12}>
                                         <p id="simple-modal-description" align="center" style={classes.ana}> Pattern Recognition ({task[1]}) </p>
                                          
                                          <div id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.pattern[0].userText)}</div>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                          <p id="simple-modal-description" align="center" style={classes.ana}> Abstraction ({task[2]}) </p>
                                          
                                          <p id="simple-modal-description" align='center'><b>Answer:</b>{commaToText(mydata.abstraction[0].userText)}</p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <p id="simple-modal-description" align="center" style={classes.ana}> Algorithm ({task[3]}) </p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={6}>
                                            {algoStepToText(mydata.algorithm[0].userText)}
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        
                                        <GridItem xs={12} sm={12} md={12}>
                                            <p id="simple-modal-description" align="center" style={classes.ana}> Analysis of the algorithm </p>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <p id="simple-modal-description"> No. of operations : {mydata.analysis[0].timeText}</p>
                                        </GridItem>
                                        
                                        <GridItem xs={12} sm={12} md={6}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <p id="simple-modal-description"> No. of variables : {mydata.analysis[0].spaceText}</p>
                                        </GridItem>
                                        
                                      
                                  </GridContainer>

                                                                     
                                  </GridItem>:null}
                                </GridContainer>
                                </CardBody>
                                {/* {isSubmitting && <LinearProgress />} */}
                              </Card>
                                
                            </GridContainer>
                          </GridItem>
                          :activeStep=='6'?
                          <GridItem xs={12} sm={12} md={12}>
                            <GridContainer>
                              <Card>
                                <CardHeader color="success">
                                <h4 style={classes.cardTitleWhite}> {task[6]} </h4>

                                </CardHeader>
                                <CardBody>
                                  {error}
                                <Accordion expanded={expanded1 === 'panel12'} onChange={handleAccordionChange1('panel12')}>
                                  <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel2bh-content"
                                    id="panel2bh-header"
                                  >
                                    <Typography sx={classes.heading}>Question 1</Typography>
                                    <Typography sx={classes.secondaryHeading}>
                                    Which of the solutions do you think is better?
                                    </Typography>
                                  </AccordionSummary>
                                  <AccordionDetails>
                                    <GridContainer spacing={3}>
                                      {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                                        if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                        if(text.algorithm.includes('nitesh')==true){
                                          var newalgo=text.algorithm.split('nitesh')
                                        }
                                        var arr = text.analysis.split(',')
                                        var newarr1=arr[0].split('=')
                                        var newarr2=arr[1].split('=')
                                        var tim = newarr1[1]
                                        var spc = newarr2[1]
                                          return (
                                            text.algoCompleted==true?
                                            
                                            <GridItem xs={12} sm={6} md={6} key={index}>
                                                {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'1','decomposition')}
                                            </GridItem> 
                                            :null
                                          )}})}
                                        {mydata.pattern[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                          var len=0;
                                          if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                            len=mydata.decomposition[0].alternateSolution.length
                                          }
                                          if(text.algorithm.includes('nitesh')==true){
                                            var newalgo=text.algorithm.split('nitesh')
                                          }
                                          var arr = text.analysis.split(',')
                                          var newarr1=arr[0].split('=')
                                          var newarr2=arr[1].split('=')
                                          var tim = newarr1[1]
                                          var spc = newarr2[1]
                                          return (
                                          text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={6} key={index}>
                                              {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','pattern')}
                                          </GridItem> 
                                          :null
                                        )}})}
                                        {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                        var len=0;
                                        if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                          len=mydata.decomposition[0].alternateSolution.length
                                        }
                                        if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                          len=len+mydata.pattern[0].alternateSolution.length
                                        }
                                        if(text.algorithm.includes('nitesh')==true){
                                          var newalgo=text.algorithm.split('nitesh')
                                        }
                                        var arr = text.analysis.split(',')
                                        var newarr1=arr[0].split('=')
                                        var newarr2=arr[1].split('=')
                                        var tim = newarr1[1]
                                        var spc = newarr2[1]
                                        return (
                                        text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={6} key={index}>
                                            {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','abstraction')}
                                          </GridItem>  
                                        :null
                                        )}})}
                                        {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                                          if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                          var len=0;
                                          if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                            len=mydata.decomposition[0].alternateSolution.length
                                          }
                                          if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                            len=len+mydata.pattern[0].alternateSolution.length
                                          }
                                          if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                            len=len+mydata.abstraction[0].alternateSolution.length
                                          }
                                          if(text.algorithm.includes('nitesh')==true){
                                            var newalgo=text.algorithm.split('nitesh')
                                          }
                                          var arr = text.analysis.split(',')
                                          var newarr1=arr[0].split('=')
                                          var newarr2=arr[1].split('=')
                                          var tim = newarr1[1]
                                          var spc = newarr2[1]
                                          return (
                                          text.algoCompleted==true?
                                          <GridItem xs={12} sm={6} md={6} key={index}>
                                              {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'1','algorithm')}
                                          </GridItem> 
                                            :null
                                          )}})}
                                          {mydata.analysis[0].completed===true?
                                                <GridItem xs={12} sm={6} md={6}>                                          
                                                    {totalSolutionComparison(mydata.decomposition[0].userText,mydata.pattern[0].userText,mydata.abstraction[0].userText,mydata.algorithm[0].userText,mydata.analysis[0].timeText,mydata.analysis[0].spaceText,solutionIndex()+1,'1','correct')}
                                                </GridItem>             
                                          :null}

                                          {mydata.analysis[0].completed===true?
                                              
                                                  <>
                                                  {mydata.comparison[0].alternateSolution.map((text, index)=>{
                                                    var len=0;
                                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                                      len=mydata.decomposition[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.pattern[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.abstraction[0].alternateSolution.length
                                                    }
                                                    if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                                      len=len+mydata.algorithm[0].alternateSolution.length
                                                    }
                                                    return(
                                                      <GridItem xs={12} sm={6} md={6} key={index}>
                                                        {solutionComparison(text.algorithm,text.analysis,len+index+2,'1')}
                                                      </GridItem>
                                                    )})}
                                                    </>
                                              
                                              :null}
                                      </GridContainer>
                                    </AccordionDetails>
                                </Accordion>
                            <Accordion expanded={expanded1 === 'panel13'} onChange={handleAccordionChange1('panel13')}>
                              <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2bh-content"
                                id="panel2bh-header"
                                >
                                  <Typography sx={classes.heading}>Question 2</Typography>
                                  <Typography sx={classes.secondaryHeading}>
                                  Your system can only perform 8 operations. If you want to implement one of the solutions, which one do you think is better?
                                  </Typography>
                              </AccordionSummary>
                              <AccordionDetails>
                                <GridContainer spacing={3}>
                                {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                                  if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var arr = text.analysis.split(',')
                                  var newarr1=arr[0].split('=')
                                  var newarr2=arr[1].split('=')
                                  var tim = newarr1[1]
                                  var spc = newarr2[1]
                                    return (
                                      text.algoCompleted==true?
                                      
                                      <GridItem xs={12} sm={6} md={6} key={index}>
                                          {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1,'3','decomposition')}
                                      </GridItem> 
                                      :null
                                    )}})}
                                  {mydata.pattern[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.decomposition[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    var tim = newarr1[1]
                                    var spc = newarr2[1]
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','pattern')}
                                    </GridItem> 
                                     :null
                                  )}})}
                                  {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                  var len=0;
                                  if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                    len=mydata.decomposition[0].alternateSolution.length
                                  }
                                  if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                    len=len+mydata.pattern[0].alternateSolution.length
                                  }
                                  if(text.algorithm.includes('nitesh')==true){
                                    var newalgo=text.algorithm.split('nitesh')
                                  }
                                  var arr = text.analysis.split(',')
                                  var newarr1=arr[0].split('=')
                                  var newarr2=arr[1].split('=')
                                  var tim = newarr1[1]
                                  var spc = newarr2[1]
                                  return (
                                  text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                      {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','abstraction')}
                                    </GridItem>  
                                  :null
                                  )}})}
                                  {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                                    if(text.decomposition!='' && text.pattern!=''&& text.abstraction!='' && text.algorithm!=''){
                                    var len=0;
                                    if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                      len=mydata.decomposition[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.pattern[0].alternateSolution.length
                                    }
                                    if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                      len=len+mydata.abstraction[0].alternateSolution.length
                                    }
                                    if(text.algorithm.includes('nitesh')==true){
                                      var newalgo=text.algorithm.split('nitesh')
                                    }
                                    var arr = text.analysis.split(',')
                                    var newarr1=arr[0].split('=')
                                    var newarr2=arr[1].split('=')
                                    var tim = newarr1[1]
                                    var spc = newarr2[1]
                                    return (
                                    text.algoCompleted==true?
                                    <GridItem xs={12} sm={6} md={6} key={index}>
                                        {totalSolutionComparison(text.decomposition,text.pattern,text.abstraction,newalgo[1],tim,spc,index+1+len,'3','algorithm')}
                                    </GridItem> 
                                      :null
                                    )}})}
                                    {mydata.analysis[0].completed===true?
                                          <GridItem xs={12} sm={6} md={6}>                                          
                                              {totalSolutionComparison(mydata.decomposition[0].userText,mydata.pattern[0].userText,mydata.abstraction[0].userText,mydata.algorithm[0].userText,mydata.analysis[0].timeText,mydata.analysis[0].spaceText,solutionIndex()+1,'3','correct')}
                                          </GridItem>             
                                    :null}

                                    {mydata.analysis[0].completed===true?
                                        
                                            <>
                                            {mydata.comparison[0].alternateSolution.map((text, index)=>{
                                              var len=0;
                                              if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                                len=mydata.decomposition[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.pattern[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.abstraction[0].alternateSolution.length
                                              }
                                              if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                                len=len+mydata.algorithm[0].alternateSolution.length
                                              }
                                              return(
                                                <GridItem xs={12} sm={6} md={6} key={index}>
                                                  {solutionComparison(text.algorithm,text.analysis,len+index+2,'3')}
                                                </GridItem>
                                              )})}
                                              </>
                                        
                                        :null}
                                    </GridContainer>
                                  </AccordionDetails>
                                </Accordion>
                                  {error}
                                </CardBody>
                              </Card>
                              <GridItem xs={12} sm={12} md={6}>
                                <Button
                                  variant="contained"
                                  color="primary"
                                   disabled={isSubmit}
                                  onClick={submitComparisonForm}
                                >
                                  Save
                                </Button>
                              </GridItem>
                            </GridContainer>
                            {solutionEnter('activity5', 'comparison','1. Better solution: '+mycomsol+',1. Reason: '+mycomsol1+'; 2. Efficient solution: '+mycomsol2+', 2. Reason: '+mycomsol3)}
                          </GridItem>
                          :null}
                      </GridContainer>
                      {loading!==true?
                      <GridContainer>
                          <GridItem xs={12} sm={12} md={9}>
                              </GridItem>
                        <GridItem xs={12} sm={12} md={3}>
                                  <div style={classes.styleChatbutton}>
                                  <Tooltip
                                    arrow
                                    title="Click for Support"
                                    placement="bottom">
                                    <Fab  color="secondary" aria-label="add" size="medium" component="span" onClick={Togglesupport}>    
                                      <ContactSupportIcon /> {Notification('activity5')==true?'1':null}
                                    </Fab>
                                  </Tooltip> 
                                    <p>Support</p>
                                  </div>
                                  
                                  {loadsupport === true?loading !== true?
                                  <>
                                    <div style={classes.chatClose}>
                                      <Fab color="warning" aria-label="add" size="small" component="span" onClick={Togglesupport}>    
                                        <CloseIcon  onClick={Togglesupport}/>
                                        
                                      </Fab>
                                    </div>
                                    <div style={classes.chatContainer}>                                      
                                        <Support user = {sesId} act = 'activity5' classid = {classId}/>
                                    </div>
                                  </>
                                  :null:null} 
                                  
                              </GridItem>
                            <GridItem xs={12} sm={12} md={9}>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                            {isSubmit && <LinearProgress />}
                              <div>
                                {activeStep === steps.length-2 ? (
                                  <div>
                                    <Typography sx={classes.instructions}> Preview steps </Typography>
                                    {/* <Button onClick={handleReset}>Reset</Button> */}
                                    <Button
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                      </Button>
                                      
                                      
                                    {mydata.analysis[0].completed!==true?
                                      <Button
                                        onClick={handleAltSolution}
                                        disabled={isSubmit}
                                        variant="contained"
                                        color="primary"
                                      >
                                        Go to {mydata.altStep}
                                      </Button>
                                      :null
                                      // <Button onClick={handleClosePreview}> Preview </Button>
                                      }
                                    {mydata.analysis[0].completed==true?
                                      <Button
                                        variant="contained"
                                        color="primary"
                                        onClick={handleNext}
                                        disabled={isSubmit}
                                      >
                                        Compare solutions 
                                      </Button>:null}
                                  </div>
                                ) : activeStep === steps.length-1 ?(
                                <div>
                                    <Button
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                    </Button>
                                  {mydata.analysis[0].completed==true?
                                    <Button
                                      variant="contained"
                                      color="primary"
                                      onClick={handleNext}
                                      disabled={isSubmit}
                                    >
                                      Submit Answer 
                                    </Button>:null}
                                </div>):
                                (
                                  <div>
                                    {/* <Typography sx={classes.instructions}>{getStepContent(activeStep)}</Typography> */}
                                    <div>
                                      <Button
                                        disabled={activeStep === 0}
                                        onClick={handleBack}
                                        sx={classes.backButton}
                                      >
                                        Back
                                      </Button>
                                      
                                      <Button variant="contained" color="primary" 
                                      disabled={isSubmit}
                                      onClick={handleNext}>
                                        {activeStep === steps.length - 3 ? 'Finish' : 'Submit and Go to Next Step'}
                                      </Button>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </GridItem>
                      </GridContainer>:null}
                  </GridItem>

                </GridContainer>
            </GridItem>
            </GridContainer>:null}
                                                                      

          </Form>
          )}
          </Formik>
           )
                      
          },
          {
            tabName: "Previous Attempts",
            tabIcon: DeveloperBoardIcon,
            tabContent: (
              <GridItem xs={12} sm={12} md={12}>
              {mydata.analysis[0].completed===true||mydata.decomposition[0].alternateSolution.length>0||mydata.pattern[0].alternateSolution.length>0 || mydata.abstraction[0].alternateSolution.length>0?
                 
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                        {mydata.decomposition[0].alternateSolution.map((text, index)=>{
                           if(text.algorithm.includes('nitesh')==true){
                            var newalgo=text.algorithm.split('nitesh')
                          }
                            return (
                              text.algoCompleted==true?
                               
                              <div>
                                <h5 id="simple-modal-description" align='center'> Solution {index+1}  </h5>
                                <p><i> <b>Decomposition:</b> {text.decomposition}</i></p>
                                <p><b> Pattern:</b> {text.pattern}</p>
                                <p><b>Abstraction:</b> {text.abstraction}</p>

                                <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                                <p><b>Analysis:</b> {text.analysis}</p>
                              </div> :<p>Wait until you complete the current solution</p>
                            )})}
                            {mydata.pattern[0].alternateSolution.map((text, index)=>{
                              var len=0;
                              if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                len=mydata.decomposition[0].alternateSolution.length
                              }
                              if(text.algorithm.includes('nitesh')==true){
                                var newalgo=text.algorithm.split('nitesh')
                              }
                            return (
                              text.algoCompleted==true?
                               
                              <div>
                                <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                                <p><b>Decomposition:</b> {text.decomposition}</p>
                                <p><i> <b> Pattern:</b> {text.pattern}</i></p>
                                <p><b>Abstraction:</b> {text.abstraction}</p>
                                <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                                <p><b>Analysis:</b>{text.analysis}</p>
                              </div> :<p>Wait until you complete the current solution</p>
                            )})}
                            {mydata.abstraction[0].alternateSolution.map((text, index)=>{
                            var len=0;
                            if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                              len=mydata.decomposition[0].alternateSolution.length
                            }
                            if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                              len=len+mydata.pattern[0].alternateSolution.length
                            }
                            if(text.algorithm.includes('nitesh')==true){
                              var newalgo=text.algorithm.split('nitesh')
                            }
                            return (
                              text.algoCompleted==true?
                               
                              <div>
                                <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                                <p><b>Decomposition:</b> {text.decomposition}</p>
                                <p><b> Pattern:</b> {text.pattern}</p>
                                <p><i><b>Abstraction:</b>{text.abstraction}</i></p>
                                <p><b>Algorithm:</b>{algoNewToText(newalgo[1])}</p>
                                <p><b>Analysis:</b>{text.analysis}</p>
                              </div> :<p>Wait until you complete the current solution</p>
                            )})}
                            {mydata.algorithm[0].alternateSolution.map((text, index)=>{
                              var len=0;
                              if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                len=mydata.decomposition[0].alternateSolution.length
                              }
                              if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                len=len+mydata.pattern[0].alternateSolution.length
                              }
                              if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                len=len+mydata.abstraction[0].alternateSolution.length
                              }
                              if(text.algorithm.includes('nitesh')==true){
                                var newalgo=text.algorithm.split('nitesh')
                              }
                              return (
                                text.algoCompleted==true?
                                
                                <div>
                                  <h5 id="simple-modal-description" align='center'> Solution {index+len+1}  </h5>
                                  <p><b>Decomposition:</b> {text.decomposition}</p>
                                  <p><b> Pattern:</b> {commaToText(text.pattern)}</p>
                                   <p><b>Abstraction:</b>{commaToText(text.abstraction)}</p>
                                  <p><i><b>Algorithm:</b>{algoNewToText(newalgo[1])}</i></p>
                                  <p><b>Analysis:</b>{text.analysis}</p>
                                </div> :<p>Wait until you complete the current solution</p>
                              )})}
                           {mydata.analysis[0].completed===true?
                            <div>
                              <h5 id="simple-modal-description" align='center'> Solution {solutionIndex()+1} </h5>
                              <div><b>Decomposition</b></div> {commaToText(mydata.decomposition[0].userText)}
                              <div><b>Pattern</b></div>{commaToText(mydata.pattern[0].userText)}
                              <div> <b>Abstraction</b> </div>{commaToText(mydata.abstraction[0].userText)}
                              <div><b>Algorithm</b></div> 
                              {algoNewToText(mydata.algorithm[0].userText)} 
                              <div><b>Analysis</b></div>
                              No. of operations:{mydata.analysis[0].timeText}, No. of variables:{mydata.analysis[0].spaceText} 
                            </div> :null}
                            {mydata.analysis[0].completed===true?
                            <div>
                              <h5 id="simple-modal-description" align='center'>Other possible solutions</h5>
                              
                              {mydata.comparison[0].alternateSolution.map((text, index)=>{
                                var len=0;
                                if(typeof(mydata.decomposition[0].alternateSolution.length)!='undefined'){
                                  len=mydata.decomposition[0].alternateSolution.length
                                }
                                if(typeof(mydata.pattern[0].alternateSolution.length)!='undefined'){
                                  len=len+mydata.pattern[0].alternateSolution.length
                                }
                                if(typeof(mydata.abstraction[0].alternateSolution.length)!='undefined'){
                                  len=len+mydata.abstraction[0].alternateSolution.length
                                }
                                if(typeof(mydata.algorithm[0].alternateSolution.length)!='undefined'){
                                  len=len+mydata.algorithm[0].alternateSolution.length
                                }
                                return(
                                  <div>
                                    <h5 id="simple-modal-description" align='center'> Solution {index+len+2} </h5>
                                    <p><b>Algorithm:</b>{algoNewToText(text.algorithm)}</p>
                                    <p><b>Analysis:</b>{text.analysis}</p>
                                  </div> 
                                )})}
                            </div>
                            :null}
                  </GridItem>
                </GridContainer>
             :<p>You have not attempted any problem</p>}
              </GridItem>
            )
            
          }

        ]}
      />
                
    
    

    </div>:<GridContainer spacing={2}>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={12}>
          <Skeleton variant="text" /> 
        </GridItem>
        <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5, padding: 2 }}>
            <Skeleton animation="wave" variant="rect" width={640} height={400} />    
          </Box>
          </GridItem>
          <GridItem xs={12} sm={12} md={6}>
          <Box sx={{ width: 640, marginRight: 2, my: 5 }}>
            <Skeleton animation="wave" variant="rect" width={640} height={400} />    
          </Box> 
          </GridItem>
        <GridItem xs={12} sm={12} md={12}>         
          <Skeleton variant="text" />
        </GridItem>
      </GridContainer>
    );
}

